window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};


/*! 
 * slick-slim.min.js
 */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this.options.asNavFor;return e&&null!==e&&(e=i(e).not(this.$slider)),e},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){this.autoPlayTimer&&clearInterval(this.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots&&o.slideCount>o.options.slidesToShow){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>0){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){for(o in s=null,r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n=this,r=i(e.currentTarget);switch(r.is("a")&&e.preventDefault(),r.is("li")||(r=r.closest("li")),o=n.slideCount%n.options.slidesToScroll!=0?0:(n.slideCount-n.currentSlide)%n.options.slidesToScroll,e.data.message){case"previous":s=0===o?n.options.slidesToScroll:n.options.slidesToShow-o,n.slideCount>n.options.slidesToShow&&n.slideHandler(n.currentSlide-s,!1,t);break;case"next":s=0===o?n.options.slidesToScroll:o,n.slideCount>n.options.slidesToShow&&n.slideHandler(n.currentSlide+s,!1,t);break;case"index":var l=0===e.data.index?0:e.data.index||r.index()*n.options.slidesToScroll;n.slideHandler(n.checkNavigable(l),!1,t),r.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(t=0,i>(e=this.getNavigableIndexes())[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>0&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);if(i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s){var n="slick-slide-control"+e.instanceUid+s;i("#"+n).length&&i(this).attr({"aria-describedby":n})}}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.options.focusOnChange?e.$slides.eq(s).attr({tabindex:"0"}):e.$slides.eq(s).removeAttr("tabindex");e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&e.slideCount>e.options.slidesToShow&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&e.slideCount>e.options.slidesToShow&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){var e,t,o,s=this;function n(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),n=i(this).attr("data-sizes")||s.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),n&&e.attr("sizes",n)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),s.$slider.trigger("lazyLoaded",[s,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),s.$slider.trigger("lazyLoadError",[s,e,t])},r.src=t})}if(!0===s.options.centerMode?!0===s.options.infinite?o=(t=s.currentSlide+(s.options.slidesToShow/2+1))+s.options.slidesToShow+2:(t=Math.max(0,s.currentSlide-(s.options.slidesToShow/2+1)),o=s.options.slidesToShow/2+1+2+s.currentSlide):(t=s.options.infinite?s.options.slidesToShow+s.currentSlide:s.currentSlide,o=Math.ceil(t+s.options.slidesToShow),!0===s.options.fade&&(t>0&&t--,o<=s.slideCount&&o++)),e=s.$slider.find(".slick-slide").slice(t,o),"anticipated"===s.options.lazyLoad)for(var r=t-1,l=o,d=s.$slider.find(".slick-slide"),a=0;a<s.options.slidesToScroll;a++)r<0&&(r=s.slideCount-1),e=(e=e.add(d.eq(r))).add(d.eq(l)),r--,l++;n(e),s.slideCount<=s.options.slidesToShow?n(s.$slider.find(".slick-slide")):s.currentSlide>=s.slideCount-s.options.slidesToShow?n(s.$slider.find(".slick-cloned").slice(0,s.options.slidesToShow)):0===s.currentSlide&&n(s.$slider.find(".slick-cloned").slice(-1*s.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){this.checkResponsive(),this.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){this.autoPlayClear(),this.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){for(e in s.respondTo=s.options.respondTo||"window",n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){i||this.autoPlay(),this.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,l=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t&&a.slideCount>a.options.slidesToShow?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t&&a.slideCount>a.options.slidesToShow?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(d=(d=a.getNavTarget()).slick("getSlick")).slideCount<=d.options.slidesToShow&&d.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t&&a.slideCount>a.options.slidesToShow?a.animateSlide(l,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}})
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(":visible")
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).off("focusin");

    $(document).on(eventsName.focusout, function () {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    var body = document.querySelector("body");

    var idSelectors = {
      newWindow: "a11y-new-window-message",
      external: "a11y-external-message",
      newWindowExternal: "a11y-new-window-external-message",
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $("a[href]:not([aria-describedby])");
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== "object") {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: "Opens in a new window.",
          external: "Opens external website.",
          newWindowExternal: "Opens external website in a new window.",
        },
        customMessages
      );

      var container = document.createElement("ul");
      var htmlMessages = "";

      for (var message in messages) {
        htmlMessages +=
          "<li id=" + idSelectors[message] + ">" + messages[message] + "</li>";
      }

      container.setAttribute("hidden", true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function () {
      var $link = $(this);
      var target = $link.attr("target");
      var rel = $link.attr("rel");
      var isExternal = _externalSite($link);
      var isTargetBlank = target === "_blank";

      if (isExternal) {
        $link.attr("aria-describedby", idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf("noopener") === -1) {
          $link.attr("rel", function (i, val) {
            var relValue = val === undefined ? "" : val + " ";
            return relValue + "noopener";
          });
        }
        $link.attr("aria-describedby", idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr("aria-describedby", idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  },
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = theme.moneyFormat; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this._firstupdateVariant(this.currentVariant);

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );

    this.sticky_atc = $(".pr-selectors .pr-swatch");
    $(this.sticky_atc, this.$container).on(
      "click",
      this._onSelectChange2.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var selectedOption1;
      var selectedOption2;
      var selectedOption3;
      var check_swatch_option = false;

      if ($(".selector-wrapper-1", this.$container).hasClass("swatch")) {
        check_swatch_option = true;
      }

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      if (found == undefined || found.available == false) {
        if (check_swatch_option == true) {
          selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("input:checked")
            .val();
          selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("input:checked")
            .val();
          selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("input:checked")
            .val();

          $(".selector-wrapper-3 .swatch-element", this.$container).each(
            function () {
          
              var swatchVal = $(this).data("value");
              var optionSoldout = variants.find(function (variant) {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option2 == selectedOption2 &&
                  variant.option3 == swatchVal &&
                  variant.available
                );
              });

              if (optionSoldout == undefined) {
                $(this).addClass("soldout");
                $(this).find(":radio").prop("disabled", true);
              } else {
                $(this).removeClass("soldout");
                $(this).find(":radio").prop("disabled", false);
                $(this).find(":radio").prop("checked", true);
              }
            }
          );

          selectedValues = this._getCurrentOptions();
          found = _.find(variants, function (variant) {
            return selectedValues.every(function (values) {
              return _.isEqual(variant[values.index], values.value);
            });
          });

          if (found == undefined || found.available == false) {
            $(".selector-wrapper-3 .swatch-element", this.$container).each(
              function () {
            
                var swatchVal = $(this).data("value");
                var optionSoldout = variants.find(function (variant) {
                  return (
                    variant.option1 == selectedOption1 &&
                    variant.option3 == swatchVal &&
                    variant.available
                  );
                });

                if (optionSoldout == undefined) {
                  $(this).addClass("soldout");
                  $(this).find(":radio").prop("disabled", true);
                } else {
                  $(this).removeClass("soldout");
                  $(this).find(":radio").prop("disabled", false);
                  $(this).find(":radio").prop("checked", true);
                }
              }
            );

            selectedOption3 = $(".selector-wrapper-3", this.$container)
              .find("input:checked")
              .val();

            $(".selector-wrapper-2 .swatch-element", this.$container).each(
              function () {
                
                var swatchVal = $(this).data("value");
                var optionSoldout = variants.find(function (variant) {
                  return (
                    variant.option1 == selectedOption1 &&
                    variant.option3 == selectedOption3 &&
                    variant.option2 == swatchVal &&
                    variant.available
                  );
                });

                if (optionSoldout == undefined) {
                  $(this).addClass("soldout");
                  $(this).find(":radio").prop("disabled", true);
                } else {
                  $(this).removeClass("soldout");
                  $(this).find(":radio").prop("disabled", false);
                  $(this).find(":radio").prop("checked", true);
                }
              }
            );

            selectedValues = this._getCurrentOptions();
            found = _.find(variants, function (variant) {
              return selectedValues.every(function (values) {
                return _.isEqual(variant[values.index], values.value);
              });
            });
          }
        } else {
          selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("option:selected")
            .val();
          selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("option:selected")
            .val();
          selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("option:selected")
            .val();

          $(
            ".selector-wrapper-3 .single-option-selector option",
            this.$container
          ).each(function () {
            var swatchVal = $(this).val();
            var optionSoldout = variants.find(function (variant) {
              return (
                variant.option1 == selectedOption1 &&
                variant.option2 == selectedOption2 &&
                variant.option3 == swatchVal &&
                variant.available
              );
            });

            if (optionSoldout == undefined) {
              $(this)
                .attr("disabled", "disabled")
                .removeAttr("selected", "selected")
                .prop("selected", false);
            } else {
              $(this)
                .removeAttr("disabled", "disabled")
                .attr("selected", "selected")
                .prop("selected", true);
            }
          });

          selectedValues = this._getCurrentOptions();
          found = _.find(variants, function (variant) {
            return selectedValues.every(function (values) {
              return _.isEqual(variant[values.index], values.value);
            });
          });

          if (found == undefined || found.available == false) {
            $(
              ".selector-wrapper-3 .single-option-selector option",
              this.$container
            ).each(function () {
              var swatchVal = $(this).val();
              var optionSoldout = variants.find(function (variant) {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option3 == swatchVal &&
                  variant.available
                );
              });

              if (optionSoldout == undefined) {
                $(this)
                  .attr("disabled", "disabled")
                  .removeAttr("selected", "selected")
                  .prop("selected", false);
              } else {
                $(this)
                  .removeAttr("disabled", "disabled")
                  .attr("selected", "selected")
                  .prop("selected", true);
              }
            });

            selectedOption3 = $(".selector-wrapper-3", this.$container)
              .find("option:selected")
              .val();

            $(
              ".selector-wrapper-2 .single-option-selector option",
              this.$container
            ).each(function () {
              var swatchVal = $(this).val();
              var optionSoldout = variants.find(function (variant) {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option3 == selectedOption3 &&
                  variant.option2 == swatchVal &&
                  variant.available
                );
              });

              if (optionSoldout == undefined) {
                $(this)
                  .attr("disabled", "disabled")
                  .removeAttr("selected", "selected")
                  .prop("selected", false);
              } else {
                $(this)
                  .removeAttr("disabled", "disabled")
                  .attr("selected", "selected")
                  .prop("selected", true);
              }
            });

            selectedValues = this._getCurrentOptions();
            found = _.find(variants, function (variant) {
              return selectedValues.every(function (values) {
                return _.isEqual(variant[values.index], values.value);
              });
            });
          }
        }
      }

      return found;
    },

    _getVariantFromOptions2: function (selectedValues) {
      if (!selectedValues)
        selectedValues = $(".pr-selectors .pr-swatch.active").data("title");
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return _.isEqual(variant.title, selectedValues);
      });
      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
_onSelectChange: function (event) {
   const priceItems = document.querySelectorAll('.product-price');
    // Loop through each element and hide it
    priceItems.forEach(item => {
        //item.style.opacity = '0'; // Set opacity to 0 (completely transparent)   
    });
  var variant = this._getVariantFromOptions();
  this.$container.trigger({
    type: "variantChange",
    variant: variant,
  });

  if (!variant) {
    return;
  }

  this._updateMasterSelect(variant);
  this._updateImages(variant);
  this._updatePrice(variant);
  this._updateSKU(variant);
  this._updateVariant(variant);
  this.currentVariant = variant;

  if (this.enableHistoryState) {
    this._updateHistoryState(variant);
  }
  // Check if the click originated from .selector-wrapper-1
    const target = event?.target;
    if (target && target.closest('.selector-wrapper-1 .swatch-element')) {

        const wrapper1 = document.querySelector('.selector-wrapper-1');
        const wrapper2 = document.querySelector('.selector-wrapper-2 .custom-dropdown .dropdown-options');
        const wrapper3 = document.querySelector('.selector-wrapper-3 .custom-dropdown .dropdown-options');

        if (wrapper1 && wrapper2 && wrapper3) {
                // Trigger events on the first valid .swatch-element in wrapper2 and wrapper3
                [wrapper2, wrapper3].forEach(wrapper => {
                    let swatch = wrapper.querySelector('.swatch-element:not(.soldout) input[type="radio"]');

                    // If the first swatch is soldout, find the next available one
                    while (swatch && swatch.closest('.swatch-element').classList.contains('soldout')) {
                        swatch = swatch.closest('.swatch-element').nextElementSibling?.querySelector('input[type="radio"]');
                    }

                    if (swatch) {
                        const parentSwatch = swatch.closest('.swatch-element'); // Ensure the parent .swatch-element is selected
                        if (parentSwatch) {
                            // Trigger a click event on the parent swatch element
                            parentSwatch.dispatchEvent(new Event('click', { bubbles: true }));

                            // Trigger change and click events on the input
                            swatch.checked = true; // Ensure input is selected
                           setTimeout(() => {
                                swatch.dispatchEvent(new Event('change', { bubbles: true })); // Trigger change event
                                swatch.dispatchEvent(new Event('click', { bubbles: true })); // Trigger click event
                            }, 100);
                        }
                    }
                });
        }
    }
   // Loop through each element and hide it
  setTimeout(function(){
     priceItems.forEach(item => {
        //item.style.opacity = '1'; // Set opacity to 0 (completely transparent)    
     });
  },300);
   
},



    _onSelectChange2: function (e) {
      var variant = this._getVariantFromOptions2(
        $(e.currentTarget).data("title")
      );
      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateVariant2(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
       // Check if the click originated from .selector-wrapper-1
    const target = event?.target;
    if (target && target.closest('.selector-wrapper-1 .swatch-element')) {
        const wrapper1 = document.querySelector('.selector-wrapper-1');
        const wrapper2 = document.querySelector('.selector-wrapper-2');
        const wrapper3 = document.querySelector('.selector-wrapper-3');
     
        if (wrapper1 && wrapper2 && wrapper3) {
    
                // Trigger events on the first valid .swatch-element in wrapper2 and wrapper3
                [wrapper2, wrapper3].forEach(wrapper => {
                    let swatch = wrapper.querySelector('.swatch-element:not(.soldout) input[type="radio"]');

                    // If the first swatch is soldout, find the next available one
                    while (swatch && swatch.closest('.swatch-element').classList.contains('soldout')) {
                        swatch = swatch.closest('.swatch-element').nextElementSibling?.querySelector('input[type="radio"]');
                    }

                    if (swatch) {
                        const parentSwatch = swatch.closest('.swatch-element'); // Ensure the parent .swatch-element is selected
                        if (parentSwatch) {
                            // Trigger a click event on the parent swatch element
                            parentSwatch.dispatchEvent(new Event('click', { bubbles: true }));

                            // Trigger change and click events on the input
                            swatch.checked = true; // Ensure input is selected
                            setTimeout(() => {
                                swatch.dispatchEvent(new Event('change', { bubbles: true })); // Trigger change event
                                swatch.dispatchEvent(new Event('click', { bubbles: true })); // Trigger click event
                            }, 200);
                        }
                    }
                });
        }
    }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
     
     if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },

    _firstupdateVariant: function (_variant) {
      var self = this;
      var check_swatch_option = false;

      if ($(".selector-wrapper-1", this.$container).hasClass("swatch")) {
        check_swatch_option = true;
      }

      if (_variant) {
        if (check_swatch_option == true) {
          var variants = this.product.variants;
          var options = $(".selector-wrapper", this.$container);
          var selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("input:checked")
            .val();
          var selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("input:checked")
            .val();
          var selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("input:checked")
            .val();

          options.each(function () {
            var optionIndex = $(this).data("option-index");
            var swatch = $(this).find(".swatch-element");
            switch (optionIndex) {
              case 1:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return variant.option1 == swatchVal && variant.available;
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
              case 2:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == swatchVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
              case 3:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == swatchVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
            }
          });
        } else {
          var variants = this.product.variants;
          var options = $(".selector-wrapper", this.$container);
          var selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("option:selected")
            .val();
          var selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("option:selected")
            .val();
          var selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("option:selected")
            .val();

          options.each(function () {
            var optionIndex = $(this).data("option-index");
            var option = $(this).find("option");
            switch (optionIndex) {
              case 1:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return variant.option1 == optionVal && variant.available;
                  });
                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
              case 2:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == optionVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
              case 3:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == optionVal &&
                      variant.available
                    );
                  });

                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
            }
          });
        }
        if (_variant.featured_media == null) {
          return;
        } else {
          var imageId = _variant.featured_media.id;
          $(document).ready(function () {
            self._switchImage(imageId);
            self._setActiveThumbnail(imageId);
          });
        }
      }
    },

    _updateVariant: function (_variant) {
      var self = this;
      var check_swatch_option = false;

      if ($(".selector-wrapper-1", this.$container).hasClass("swatch")) {
        check_swatch_option = true;
      }

      if (_variant) {
        var option1 = _variant.option1;
        var option2 = _variant.option2;
        var option3 = _variant.option3;
        var option_change = "";
        var option_value = "";
      

        if (this.currentVariant.option1 != option1) {
          option_value = option1;
          option_change = "option1";
          $(".label-value-1", this.$container).html(option_value);
        } else if (this.currentVariant.option2 != option2) {
          option_value = option2;
          option_change = "option2";
          $(".label-value-2", this.$container).html(option_value);
        } else if (this.currentVariant.option3 != option3) {
          option_value = option3;
          option_change = "option3";
          $(".label-value-3", this.$container).html(option_value);
        }
        
        const fastBadge = window.document.querySelector('.fast-badge');
    
        if(fastBadge){
          const quantity = parseInt(window.document.querySelector(`.product-variants-data li.variant-${_variant.id}`).innerText);
  
          if(quantity > 0){
            fastBadge.style.display = 'block';
          }else{
            fastBadge.style.display = 'none';
          }
        }

        
        if (check_swatch_option == true) {
          var variants = this.product.variants;
          var options = $(".selector-wrapper", this.$container);
          var selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("input:checked")
            .val();
          var selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("input:checked")
            .val();
          var selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("input:checked")
            .val();

          options.each(function () {
            var optionIndex = $(this).data("option-index");
            var swatch = $(this).find(".swatch-element");
            switch (optionIndex) {
              case 1:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return variant.option1 == swatchVal && variant.available;
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
              case 2:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == swatchVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
              case 3:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == swatchVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
            }
          });
        } else {
          var variants = this.product.variants;
          var options = $(".selector-wrapper", this.$container);
          var selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("option:selected")
            .val();
          var selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("option:selected")
            .val();
          var selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("option:selected")
            .val();

          options.each(function () {
            var optionIndex = $(this).data("option-index");
            var option = $(this).find("option");
            switch (optionIndex) {
              case 1:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return variant.option1 == optionVal && variant.available;
                  });
                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
              case 2:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == optionVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
              case 3:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == optionVal &&
                      variant.available
                    );
                  });

                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
            }
          });
        }
      }
    },

    _updateVariant2: function (variant) {
      if (variant) {
        _.map(
          $(this.singleOptionSelector, this.$container),
          function (element) {
            var $element = $(element);
            var data_index = $element.data("index");
            var data_value = $element.val();

            if (_.isEqual(variant[data_index], data_value)) {
              if (variant.available) {
                $element.removeAttr("disabled");
                $element.parent().removeClass("soldout");
                $element.attr("checked", true);
              } else {
                $element.attr("disabled", "disabled");
                $element.parent().addClass("soldout");
                if ($element[0].checked) {
                  $("[name=" + $element.attr("name") + "]:first").attr(
                    "checked",
                    true
                  );
                }
              }
            }
          }
        );
      }
    },

    _switchImage: function (imageId) {
      var $newImage = $(
        ".product_template .product-single__photo[data-image-id='" +
          imageId +
          "']"
      );
      var $otherImages = $(
        ".product_template .product-single__photo:not([data-image-id='" +
          imageId +
          "'])"
      );
      if ($(".product_template .product-slider").hasClass("custom")) {
        $newImage.removeClass("hide");
        $otherImages.addClass("hide");
      }
    },

    _setActiveThumbnail: function (imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === "undefined") {
        imageId = $(".product_template .product-single__photo:not(.hide)").data(
          "image-id"
        );
      }

      var $thumbnailWrappers = $(
        ".product_template .product-single__thumbnails-item:not(.slick-cloned)"
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        ".product-single__thumbnail[data-thumbnail-id='" + imageId + "']"
      );

      $(".product-single__thumbnail")
        .removeClass("active-thumb")
        .removeAttr("aria-current");

      $activeThumbnail.addClass("active-thumb");
      $activeThumbnail.attr("aria-current", true);

      setTimeout(function () {
        if (!$thumbnailWrappers.hasClass("slick-slide")) {
          return;
        }

        var slideIndex = $activeThumbnail.parent().data("slick-index");
        //console.log($activeThumbnail.parent());
        $(".product_template .product-single__thumbnails").slick(
          "slickGoTo",
          slideIndex
        );
      }, 300);
    },
  });

  return Variants;
})();

slate.Variants2 = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants2(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this._firstupdateVariant(this.currentVariant);

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants2.prototype = _.assignIn({}, Variants2.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var selectedOption1;
      var selectedOption2;
      var selectedOption3;
      var check_swatch_option = false;

      if ($(".selector-wrapper-1", this.$container).hasClass("swatch")) {
        check_swatch_option = true;
      }

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      if (found == undefined || found.available == false) {
        if (check_swatch_option == true) {
          selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("input:checked")
            .val();
          selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("input:checked")
            .val();
          selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("input:checked")
            .val();

          $(".selector-wrapper-3 .swatch-element", this.$container).each(
            function () {
              var swatchVal = $(this).data("value");
              var optionSoldout = variants.find(function (variant) {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option2 == selectedOption2 &&
                  variant.option3 == swatchVal &&
                  variant.available
                );
              });

              if (optionSoldout == undefined) {
                $(this).addClass("soldout");
                $(this).find(":radio").prop("disabled", true);
              } else {
                $(this).removeClass("soldout");
                $(this).find(":radio").prop("disabled", false);
                $(this).find(":radio").prop("checked", true);
              }
            }
          );

          selectedValues = this._getCurrentOptions();
          found = _.find(variants, function (variant) {
            return selectedValues.every(function (values) {
              return _.isEqual(variant[values.index], values.value);
            });
          });

          if (found == undefined || found.available == false) {
            $(".selector-wrapper-3 .swatch-element", this.$container).each(
              function () {
                var swatchVal = $(this).data("value");
                var optionSoldout = variants.find(function (variant) {
                  return (
                    variant.option1 == selectedOption1 &&
                    variant.option3 == swatchVal &&
                    variant.available
                  );
                });

                if (optionSoldout == undefined) {
                  $(this).addClass("soldout");
                  $(this).find(":radio").prop("disabled", true);
                } else {
                  $(this).removeClass("soldout");
                  $(this).find(":radio").prop("disabled", false);
                  $(this).find(":radio").prop("checked", true);
                }
              }
            );

            selectedOption3 = $(".selector-wrapper-3", this.$container)
              .find("input:checked")
              .val();

            $(".selector-wrapper-2 .swatch-element", this.$container).each(
              function () {
                var swatchVal = $(this).data("value");
                var optionSoldout = variants.find(function (variant) {
                  return (
                    variant.option1 == selectedOption1 &&
                    variant.option3 == selectedOption3 &&
                    variant.option2 == swatchVal &&
                    variant.available
                  );
                });

                if (optionSoldout == undefined) {
                  $(this).addClass("soldout");
                  $(this).find(":radio").prop("disabled", true);
                } else {
                  $(this).removeClass("soldout");
                  $(this).find(":radio").prop("disabled", false);
                  $(this).find(":radio").prop("checked", true);
                }
              }
            );

            selectedValues = this._getCurrentOptions();
            found = _.find(variants, function (variant) {
              return selectedValues.every(function (values) {
                return _.isEqual(variant[values.index], values.value);
              });
            });
          }
        } else {
          selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("option:selected")
            .val();
          selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("option:selected")
            .val();
          selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("option:selected")
            .val();

          $(
            ".selector-wrapper-3 .single-option-selector option",
            this.$container
          ).each(function () {
            var swatchVal = $(this).val();
            var optionSoldout = variants.find(function (variant) {
              return (
                variant.option1 == selectedOption1 &&
                variant.option2 == selectedOption2 &&
                variant.option3 == swatchVal &&
                variant.available
              );
            });

            if (optionSoldout == undefined) {
              $(this)
                .attr("disabled", "disabled")
                .removeAttr("selected", "selected")
                .prop("selected", false);
            } else {
              $(this)
                .removeAttr("disabled", "disabled")
                .attr("selected", "selected")
                .prop("selected", true);
            }
          });

          selectedValues = this._getCurrentOptions();
          found = _.find(variants, function (variant) {
            return selectedValues.every(function (values) {
              return _.isEqual(variant[values.index], values.value);
            });
          });

          if (found == undefined || found.available == false) {
            $(
              ".selector-wrapper-3 .single-option-selector option",
              this.$container
            ).each(function () {
              var swatchVal = $(this).val();
              var optionSoldout = variants.find(function (variant) {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option3 == swatchVal &&
                  variant.available
                );
              });

              if (optionSoldout == undefined) {
                $(this)
                  .attr("disabled", "disabled")
                  .removeAttr("selected", "selected")
                  .prop("selected", false);
              } else {
                $(this)
                  .removeAttr("disabled", "disabled")
                  .attr("selected", "selected")
                  .prop("selected", true);
              }
            });

            selectedOption3 = $(".selector-wrapper-3", this.$container)
              .find("option:selected")
              .val();

            $(
              ".selector-wrapper-2 .single-option-selector option",
              this.$container
            ).each(function () {
              var swatchVal = $(this).val();
              var optionSoldout = variants.find(function (variant) {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option3 == selectedOption3 &&
                  variant.option2 == swatchVal &&
                  variant.available
                );
              });

              if (optionSoldout == undefined) {
                $(this)
                  .attr("disabled", "disabled")
                  .removeAttr("selected", "selected")
                  .prop("selected", false);
              } else {
                $(this)
                  .removeAttr("disabled", "disabled")
                  .attr("selected", "selected")
                  .prop("selected", true);
              }
            });

            selectedValues = this._getCurrentOptions();
            found = _.find(variants, function (variant) {
              return selectedValues.every(function (values) {
                return _.isEqual(variant[values.index], values.value);
              });
            });
          }
        }
      }

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      console.log('123selector-change');
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateVariant(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
       // Check if the click originated from .selector-wrapper-1
    const target = event?.target;
    if (target && target.closest('.selector-wrapper-1 .swatch-element')) {
        const wrapper1 = document.querySelector('.selector-wrapper-1');
        const wrapper2 = document.querySelector('.selector-wrapper-2 .dropdown-options');
        const wrapper3 = document.querySelector('.selector-wrapper-3 .dropdown-options');

        if (wrapper1 && wrapper2 && wrapper3) {
       
                // Trigger events on the first valid .swatch-element in wrapper2 and wrapper3
                [wrapper2, wrapper3].forEach(wrapper => {
                    let swatch = wrapper.querySelector('.swatch-element:not(.soldout) input[type="radio"]');
             
                    // If the first swatch is soldout, find the next available one
                    while (swatch && swatch.closest('.swatch-element').classList.contains('soldout')) {
                        swatch = swatch.closest('.swatch-element').nextElementSibling?.querySelector('input[type="radio"]');
                    }
                    console.log('here1');
                    if (swatch) {
                        const parentSwatch = swatch.closest('.swatch-element'); // Ensure the parent .swatch-element is selected
                      console.log('123');
                       
                        if (parentSwatch) {
                          console.log('triggering');
                            // Trigger a click event on the parent swatch element
                            parentSwatch.dispatchEvent(new Event('click', { bubbles: true }));

                            // Trigger change and click events on the input
                            swatch.checked = true; // Ensure input is selected
                            setTimeout(() => {
                                swatch.dispatchEvent(new Event('change', { bubbles: true })); // Trigger change event
                                swatch.dispatchEvent(new Event('click', { bubbles: true })); // Trigger click event
                            }, 200);
                        }
                    }
                });
        }
    }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
 
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },

    _firstupdateVariant: function (_variant) {
      var self = this;
      var check_swatch_option = false;

      if ($(".selector-wrapper-1", this.$container).hasClass("swatch")) {
        check_swatch_option = true;
      }

      if (_variant) {
        if (check_swatch_option == true) {
          var variants = this.product.variants;
          var options = $(".selector-wrapper", this.$container);
          var selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("input:checked")
            .val();
          var selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("input:checked")
            .val();
          var selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("input:checked")
            .val();

          options.each(function () {
            var optionIndex = $(this).data("option-index");
            var swatch = $(this).find(".swatch-element");
            switch (optionIndex) {
              case 1:
                swatch.each(function () {
                  
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return variant.option1 == swatchVal && variant.available;
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
              case 2:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == swatchVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
              case 3:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == swatchVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
            }
          });
        } else {
          var variants = this.product.variants;
          var options = $(".selector-wrapper", this.$container);
          var selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("option:selected")
            .val();
          var selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("option:selected")
            .val();
          var selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("option:selected")
            .val();

          options.each(function () {
            var optionIndex = $(this).data("option-index");
            var option = $(this).find("option");
            switch (optionIndex) {
              case 1:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return variant.option1 == optionVal && variant.available;
                  });
                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
              case 2:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == optionVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
              case 3:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == optionVal &&
                      variant.available
                    );
                  });

                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
            }
          });
        }
      }
    },

    _updateVariant: function (_variant) {
      var self = this;
      var check_swatch_option = false;

      if ($(".selector-wrapper-1", this.$container).hasClass("swatch")) {
        check_swatch_option = true;
      }

      if (_variant) {
        var option1 = _variant.option1;
        var option2 = _variant.option2;
        var option3 = _variant.option3;
        var option_change = "";
        var option_value = "";

        if (this.currentVariant.option1 != option1) {
          option_value = option1;
          option_change = "option1";
          $(".label-value-1", this.$container).html(option_value);
        } else if (this.currentVariant.option2 != option2) {
          option_value = option2;
          option_change = "option2";
          $(".label-value-2", this.$container).html(option_value);
        } else if (this.currentVariant.option3 != option3) {
          option_value = option3;
          option_change = "option3";
          $(".label-value-3", this.$container).html(option_value);
        }

        if (check_swatch_option == true) {
          var variants = this.product.variants;
          var options = $(".selector-wrapper", this.$container);
          var selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("input:checked")
            .val();
          var selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("input:checked")
            .val();
          var selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("input:checked")
            .val();

          options.each(function () {
            var optionIndex = $(this).data("option-index");
            var swatch = $(this).find(".swatch-element");
             
            switch (optionIndex) {
              case 1:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return variant.option1 == swatchVal && variant.available;
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
              case 2:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == swatchVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
              case 3:
                swatch.each(function () {
                  var swatchVal = $(this).data("value");
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == swatchVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).addClass("soldout");
                    $(this).find(":radio").prop("disabled", true);
                  } else {
                    $(this).removeClass("soldout");
                    $(this).find(":radio").prop("disabled", false);
                  }
                });
                break;
            }
          });
        } else {
          var variants = this.product.variants;
          var options = $(".selector-wrapper", this.$container);
          var selectedOption1 = $(".selector-wrapper-1", this.$container)
            .find("option:selected")
            .val();
          var selectedOption2 = $(".selector-wrapper-2", this.$container)
            .find("option:selected")
            .val();
          var selectedOption3 = $(".selector-wrapper-3", this.$container)
            .find("option:selected")
            .val();

          options.each(function () {
            var optionIndex = $(this).data("option-index");
            var option = $(this).find("option");
            switch (optionIndex) {
              case 1:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return variant.option1 == optionVal && variant.available;
                  });
                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
              case 2:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == optionVal &&
                      variant.available
                    );
                  });
                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
              case 3:
                option.each(function () {
                  var optionVal = $(this).val();
                  var optionSoldout = variants.find(function (variant) {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == optionVal &&
                      variant.available
                    );
                  });

                  if (optionSoldout == undefined) {
                    $(this).attr("disabled", "disabled");
                  } else {
                    $(this).removeAttr("disabled", "disabled");
                  }
                });
                break;
            }
          });
        }
      }
    },
  });

  return Variants2;
})();

/* ================ GLOBAL ================ */
/*============================================================================
    Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var defaults = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position,
    };

    this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer"),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on("click", $.proxy(this.open, this));
    this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + " " + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + " " + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", false);
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === "function"
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function (evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function () {
      return false;
    });

    this.nodes.$page.on(
      "click.drawer",
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

/* ================ MODULES ================ */

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: ".search",
    searchSubmit: ".search__submit",
    searchInput: ".search__input",

    siteHeader: ".site-header",
    siteHeaderSearchToggle: ".site-header__search-toggle",
    siteHeaderSearch: ".site-header__search",

    searchDrawer: ".search-bar",
    searchDrawerInput: ".search-bar__input",

    searchHeader: ".search-header",
    searchHeaderInput: ".search-header__input",
    searchHeaderSubmit: ".search-header__submit",

    searchResultSubmit: "#SearchResultSubmit",
    searchResultInput: "#SearchInput",
    searchResultMessage: "[data-search-error-message]",

    mobileNavWrapper: ".mobile-nav-wrapper",
  };

  var classes = {
    focus: "search--focus",
    hidden: "hide",
    mobileNavIsOpen: "js-menu--is-open",
    searchTemplate: "template-search",
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    var isSearchPage =
      slate.utils.getParameterByName("q") !== null &&
      $("body").hasClass(classes.searchTemplate);

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      "click",
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on("focus blur", function () {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on("click", function () {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + "px",
        top: searchOffset + "px",
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $("#PageContainer").addClass("drawer-page-content");
    $(".js-drawer-open-top")
      .attr("aria-controls", "SearchDrawer")
      .attr("aria-expanded", "false")
      .attr("aria-haspopup", "dialog");

    theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose,
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr("aria-describedby")
      .removeAttr("aria-invalid");
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr("aria-describedby", "error-search-form")
      .attr("aria-invalid", true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== "undefined") {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init,
  };
})();

(function () {
  var selectors = {
    backButton: ".return-link",
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one("click", function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement("a");
    anchor.ref = url;

    return anchor.hostname;
  }
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

theme.Video = (function () {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: "opaque",
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  };
  var classes = {
    playing: "video-is-playing",
    paused: "video-is-paused",
    loading: "video-is-loading",
    loaded: "video-is-loaded",
    backgroundVideoWrapper: "video-background-wrapper",
    videoWithImage: "video--image_with_play",
    backgroundVideo: "video--background",
    userPaused: "is-paused",
    supportsAutoplay: "autoplay",
    supportsNoAutoplay: "no-autoplay",
    wrapperMinHeight: "video-section-wrapper--min-height",
  };

  var selectors = {
    section: ".video-section",
    videoWrapper: ".video-section-wrapper",
    playVideoBtn: ".video-control__play",
    closeVideoBtn: ".video-control__close-wrapper",
    pauseVideoBtn: ".video__pause",
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr("id")] = {
      id: $video.attr("id"),
      videoId: $video.data("id"),
      type: $video.data("type"),
      status:
        $video.data("type") === "image_with_play" ? "closed" : "background", // closed, open, background
      $video: $video,
      $videoWrapper: $video.closest(selectors.videoWrapper),
      $section: $video.closest(selectors.section),
      controls: $video.data("type") === "background" ? 0 : 1,
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === "function"
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $videoWrapper = videoData.$videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      $videoWrapper.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement)
      .removeClass(classes.supportsAutoplay)
      .removeClass(classes.supportsNoAutoplay)
      .addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080");
    var videoData = getVideoOptions(evt);
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $("#" + videoData.id).attr("tabindex", "-1");

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    if (videoData.type === "background") {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.$videoWrapper.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === "background" &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
        evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.$videoWrapper.removeClass(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function () {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0);
        break;
      case "image_with_play":
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $videoWrapper = videoData.$videoWrapper;
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);

    $videoWrapper.removeClass(classes.loading);

    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === "background") {
      return;
    }

    $("#" + videoData.id).attr("tabindex", "0");

    if (videoData.type === "image_with_play") {
      $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function () {
      $videoWrapper.find(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var $videoWrapper = videoData.$videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === "image_with_play") {
      if (videoData.status === "closed") {
        $videoWrapper.removeClass(classes.paused);
      } else {
        $videoWrapper.addClass(classes.paused);
      }
    }

    $videoWrapper.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $videoWrapper = videoData.$videoWrapper;
    var classesToRemove = [classes.paused, classes.playing].join(" ");

    if (isMobile()) {
      $videoWrapper.removeAttr("style");
    }

    $("#" + videoData.id).attr("tabindex", "-1");

    videoData.status = "closed";

    switch (videoData.type) {
      case "image_with_play":
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case "background":
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    $videoWrapper.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    var $target = evt.target.a ? evt.target.a : evt.target.f;
    return videos[$target.id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop = video.$videoWrapper.offset().top;
    var $playButton = video.$videoWrapper.find(selectors.playVideoBtn);
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
      video.$videoWrapper.parent().toggleClass("page-width", !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = $(window).width() / videoOptions.ratio;
      } else {
        newHeight = video.$videoWrapper.width() / videoOptions.ratio;
      }
      offset = ($(window).height() - newHeight) / 2;

      video.$videoWrapper
        .removeClass(classes.wrapperMinHeight)
        .animate({ height: newHeight }, 600);

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        $("html, body").animate(
          {
            scrollTop: elementTop - offset,
          },
          videoOptions.scrollAnimationDuration
        );
      }
    } else {
      if (isMobile()) {
        newHeight = video.$videoWrapper.data("mobile-height");
      } else {
        newHeight = video.$videoWrapper.data("desktop-height");
      }

      video.$videoWrapper
        .height(video.$videoWrapper.width() / videoOptions.ratio)
        .animate({ height: newHeight }, 600);
      setTimeout(function () {
        video.$videoWrapper.addClass(classes.wrapperMinHeight);
      }, 600);
      $playButton.focus();
    }
  }

  function togglePause(playerId) {
    var $pauseButton = videos[playerId].$videoWrapper.find(
      selectors.pauseVideoBtn
    );
    var paused = $pauseButton.hasClass(classes.userPaused);
    if (paused) {
      $pauseButton.removeClass(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      $pauseButton.addClass(classes.userPaused);
      pauseVideo(playerId);
    }
    $pauseButton.attr("aria-pressed", !paused);
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.$videoWrapper.addClass(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.$videoWrapper.attr(
      "style",
      "height: " + video.$videoWrapper.height() + "px"
    );

    video.status = "open";

    switch (video.type) {
      case "image_with_play":
        privatePlayVideo(playerId, true);
        break;
      case "background":
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    $(document).on("keydown.videoPlayer", function (evt) {
      var playerId = $(document.activeElement).data("controls");
      if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
        return;
      }

      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });
  }

  function sizeBackgroundVideos() {
    $("." + classes.backgroundVideo).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      $videoPlayer.removeAttr("style");
    } else {
      var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = $videoWrapper.width();
      var playerWidth = $videoPlayer.width();
      var desktopHeight = $videoWrapper.data("desktop-height");

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        $videoPlayer
          .width(playerWidth)
          .height(desktopHeight)
          .css({
            left: (videoWidth - playerWidth) / 2,
            top: 0,
          }); // player width is greater, offset left; reset top
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        $videoPlayer
          .width(videoWidth)
          .height(desktopHeight)
          .css({
            left: 0,
            top: (desktopHeight - desktopHeight) / 2,
          }); // player height is greater, offset top; reset left
      }

      $videoPlayer.prepareTransition();
      $videoWrapper.addClass(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    $("#" + playerId)
      .removeClass(classes.backgroundVideo)
      .addClass(classes.videoWithImage);

    setTimeout(function () {
      $("#" + playerId).removeAttr("style");
    }, 600);

    videos[playerId].$videoWrapper
      .removeClass(classes.backgroundVideoWrapper)
      .addClass(classes.playing);

    videos[playerId].status = "open";
  }

  function setBackgroundVideo(playerId) {
    $("#" + playerId)
      .removeClass(classes.videoWithImage)
      .addClass(classes.backgroundVideo);

    videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);

    videos[playerId].status = "background";
    sizeBackgroundVideo($("#" + playerId));
  }

  function isMobile() {
    return $(window).width() < 750 || window.mobileCheck();
  }

  function initEvents() {
    $(document).on("click.videoPlayer", selectors.playVideoBtn, function (evt) {
      var playerId = $(evt.currentTarget).data("controls");

      startVideoOnClick(playerId);
    });

    $(document).on(
      "click.videoPlayer",
      selectors.closeVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data("controls");

        $(evt.currentTarget).blur();
        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
      }
    );

    $(document).on(
      "click.videoPlayer",
      selectors.pauseVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data("controls");
        togglePause(playerId);
      }
    );

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      "resize.videoPlayer",
      $.debounce(200, function () {
        if (!youtubeLoaded) return;
        var key;
        var fullscreen = window.innerHeight === screen.height;

        sizeBackgroundVideos();

        if (isMobile()) {
          for (key in videos) {
            if (videos.hasOwnProperty(key)) {
              if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                if (!fullscreen) {
                  pauseVideo(key);
                  setAsPaused(videos[key]);
                }
              }
              videos[key].$videoWrapper.height(
                $(document).width() / videoOptions.ratio
              );
            }
          }
          setAutoplaySupport(false);
        } else {
          setAutoplaySupport(true);
          for (key in videos) {
            if (
              videos[key].$videoWrapper.find("." + classes.videoWithImage)
                .length
            ) {
              continue;
            }
            videoPlayers[key].playVideo();
            setAsPlaying(videos[key]);
          }
        }
      })
    );

    $(window).on(
      "scroll.videoPlayer",
      $.debounce(50, function () {
        if (!youtubeLoaded) return;

        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var $videoWrapper = videos[key].$videoWrapper;

            // Close the video if more than 75% of it is scrolled out of view
            if (
              $videoWrapper.hasClass(classes.playing) &&
              ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
                $(window).scrollTop() ||
                $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
                  $(window).scrollTop() + $(window).height())
            ) {
              closeVideo(key);
              toggleExpandVideo(key, false);
            }
          }
        }
      })
    );
  }

  function createPlayer(key) {
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    $(document).off(".videoPlayer");
    $(window).off(".videoPlayer");
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents,
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function () {
  var selectors = {
    statusMessage: "[data-form-status]",
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.attr("tabindex", -1).focus();

    this.$statusMessage.on("blur", handleBlur.bind(this));
  }

  function handleBlur() {
    this.$statusMessage.removeAttr("tabindex");
  }

  return {
    init: init,
  };
})();

/* ================ TEMPLATES ================ */
(function () {
  var $filterBy = $("#BlogTagFilter");

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on("change", function () {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function () {
  var selectors = {
    RecoverHeading: "#RecoverHeading",
    RecoverEmail: "#RecoverEmail",
    LoginHeading: "#LoginHeading",
  };

  function initEventListeners() {
    this.$RecoverHeading = $(selectors.RecoverHeading);
    this.$RecoverEmail = $(selectors.RecoverEmail);
    this.$LoginHeading = $(selectors.LoginHeading);

    // Show reset password form
    $("#RecoverPassword").on(
      "click",
      function (evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
        this.$RecoverHeading.attr("tabindex", "-1").focus();
      }.bind(this)
    );

    // Hide reset password form
    $("#HideRecoverPasswordLink").on(
      "click",
      function (evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
        this.$LoginHeading.attr("tabindex", "-1").focus();
      }.bind(this)
    );

    this.$RecoverHeading.on("blur", function () {
      $(this).removeAttr("tabindex");
    });

    this.$LoginHeading.on("blur", function () {
      $(this).removeAttr("tabindex");
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    $("#RecoverPasswordForm").removeClass("hide");
    $("#CustomerLoginForm").addClass("hide");
    $("#CustomerRegisterForm").addClass("hide");

    if (this.$RecoverEmail.attr("aria-invalid") === "true") {
      this.$RecoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    $("#RecoverPasswordForm").addClass("hide");
    $("#CustomerLoginForm").removeClass("hide");
    $("#CustomerRegisterForm").removeClass("hide");
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide").focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $("#AddressNewForm");
    var $newAddressFormButton = $("#AddressNewButton");

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew",
        }
      );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function () {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function () {
      var isExpanded = $newAddressFormButton.attr("aria-expanded") === "true";

      $newAddressForm.toggleClass("hide");
      $newAddressFormButton.attr("aria-expanded", !isExpanded).focus();
    });

    $(".address-edit-toggle").on("click", function () {
      var formId = $(this).data("form-id");
      var $editButton = $("#EditFormButton_" + formId);
      var $editAddress = $("#EditAddress_" + formId);
      var isExpanded = $editButton.attr("aria-expanded") === "true";

      $editAddress.toggleClass("hide");
      $editButton.attr("aria-expanded", !isExpanded).focus();
    });

    $(".address-delete").on("click", function () {
      var $el = $(this);
      var target = $el.data("target");
      var confirmMessage = $el.data("confirm-message");

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || "Are you sure you wish to delete this address?"
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: "delete" },
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function () {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    },
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    cartCount: "[data-cart-count]",
    cartCountBubble: "[data-cart-count-bubble]",
    cartDiscount: "[data-cart-discount]",
    cartDiscountTitle: "[data-cart-discount-title]",
    cartDiscountAmount: "[data-cart-discount-amount]",
    cartDiscountWrapper: "[data-cart-discount-wrapper]",
    cartErrorMessage: "[data-cart-error-message]",
    cartErrorMessageWrapper: "[data-cart-error-message-wrapper]",
    cartItem: "[data-cart-item]",
    cartItemDetails: "[data-cart-item-details]",
    cartItemDiscount: "[data-cart-item-discount]",
    cartItemDiscountedPriceGroup: "[data-cart-item-discounted-price-group]",
    cartItemDiscountTitle: "[data-cart-item-discount-title]",
    cartItemDiscountAmount: "[data-cart-item-discount-amount]",
    cartItemDiscountList: "[data-cart-item-discount-list]",
    cartItemFinalPrice: "[data-cart-item-final-price]",
    cartItemImage: "[data-cart-item-image]",
    cartItemLinePrice: "[data-cart-item-line-price]",
    cartItemOriginalPrice: "[data-cart-item-original-price]",
    cartItemPrice: "[data-cart-item-price]",
    cartItemPriceList: "[data-cart-item-price-list]",
    cartItemProperty: "[data-cart-item-property]",
    cartItemPropertyName: "[data-cart-item-property-name]",
    cartItemPropertyValue: "[data-cart-item-property-value]",
    cartItemRegularPriceGroup: "[data-cart-item-regular-price-group]",
    cartItemRegularPrice: "[data-cart-item-regular-price]",
    cartItemTitle: "[data-cart-item-title]",
    cartItemOption: "[data-cart-item-option]",
    cartLineItems: "[data-cart-line-items]",
    cartNote: "[data-cart-notes]",
    cartQuantityErrorMessage: "[data-cart-quantity-error-message]",
    cartQuantityErrorMessageWrapper:
      "[data-cart-quantity-error-message-wrapper]",
    cartRemove: "[data-cart-remove]",
    cartupdate: "[data-qtt]",
    cartStatus: "[data-cart-status]",
    cartSubtotal: "[data-cart-subtotal]",
    cartTableCell: "[data-cart-table-cell]",
    cartWrapper: "[data-cart-wrapper]",
    emptyPageContent: "[data-empty-page-content]",
    quantityInput: "[data-quantity-input]",
    quantityInputMobile: "[data-quantity-input-mobile]",
    quantityInputDesktop: "[data-quantity-input-desktop]",
    quantityLabelMobile: "[data-quantity-label-mobile]",
    quantityLabelDesktop: "[data-quantity-label-desktop]",
    inputQty: "[data-quantity-input]",
    thumbnails: ".cart__image",
    unitPrice: "[data-unit-price]",
    unitPriceBaseUnit: "[data-unit-price-base-unit]",
    unitPriceGroup: "[data-unit-price-group]",
    editCart: "[data-cart-edit]",
    termsConditions: "[data-terms-conditions]",
    updateCartPC: "[data-cart-pc]",
    updateCartMB: "[data-mobile-cart]",
  };

  var classes = {
    cartNoCookies: "cart--no-cookies",
    cartRemovedProduct: "cart__removed-product",
    hide: "hide",
    inputError: "input--error",
  };

  var attributes = {
    cartItemIndex: "data-cart-item-index",
    cartItemKey: "data-cart-item-key",
    cartItemQuantity: "data-cart-item-quantity",
    cartItemTitle: "data-cart-item-title",
    cartItemUrl: "data-cart-item-url",
    quantityItem: "data-quantity-item",
  };

  theme.breakpoints = theme.breakpoints || {};

  if (
    isNaN(theme.breakpoints.medium) ||
    theme.breakpoints.medium === undefined
  ) {
    theme.breakpoints.medium = 768;
  }

  var mediumUpQuery = "(min-width: " + theme.breakpoints.medium + "px)";

  function Cart(container) {
    this.$container = $(container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);
    this.ajaxEnabled = this.$container.data("ajax-enabled");

    if (!this.cookiesEnabled()) {
      this.$container.addClass(classes.cartNoCookies);
    }

    this.$thumbnails.css("cursor", "pointer");

    this.$container.on(
      "click",
      selectors.thumbnails,
      this._handleThumbnailClick
    );

    this.$container.on(
      "change",
      selectors.inputQty,
      $.debounce(500, this._handleInputQty.bind(this))
    );

    this.mql = window.matchMedia(mediumUpQuery);

    this.mql.addListener(this.setQuantityFormControllers.bind(this));
    this.setQuantityFormControllers();

    if (this.ajaxEnabled) {
      /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */

      this.$container.on(
        "change",
        selectors.cartNote,
        this._onNoteChange.bind(this)
      );

      this.$container.on(
        "click",
        selectors.cartRemove,
        this._onRemoveItem.bind(this)
      );

      this._setupCartTemplates();
    }

    this._cartTermsConditions();
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    checkNeedToConvertCurrency: function () {
      return (
        (window.show_multiple_currencies &&
          Currency.currentCurrency != shopCurrency) ||
        window.show_auto_currency
      );
    },

    _showErrorMessage: function (errorMessage, $container) {
      $("[data-error-message]", $container).html(errorMessage);

      $("[data-error-message-wrapper]", $container)
        .removeClass("product-form__error-message-wrapper--hidden")
        .attr("aria-hidden", true)
        .removeAttr("aria-hidden");
    },

    _hideErrorMessage: function ($container) {
      $("[data-error-message-wrapper]", $container).addClass(
        "product-form__error-message-wrapper--hidden"
      );
    },

    _setupCartTemplates: function () {
      this.$itemTemplate = $(selectors.cartItem, this.$container)
        .first()
        .clone();
      this.$itemDiscountTemplate = $(
        selectors.cartItemDiscount,
        this.$itemTemplate
      ).clone();
      this.$itemOptionTemplate = $(
        selectors.cartItemOption,
        this.$itemTemplate
      ).clone();
      this.$itemPropertyTemplate = $(
        selectors.cartItemProperty,
        this.$itemTemplate
      ).clone();
      this.$itemPriceListTemplate = $(
        selectors.cartItemPriceList,
        this.$itemTemplate
      ).clone();
      this.$itemLinePriceTemplate = $(
        selectors.cartItemLinePrice,
        this.$itemTemplate
      ).clone();
      this.$cartDiscountTemplate = $(
        selectors.cartDiscount,
        this.$container
      ).clone();

      if (this.checkNeedToConvertCurrency()) {
        Currency.convertAll(
          window.shop_currency,
          $("#currencies .active").attr("data-currency"),
          "span.money",
          "money_format"
        );
      }
    },

    _handleInputQty: function (evt) {
      var $input = $(evt.target);
      var itemIndex = $input.data("quantity-item");
      var $itemElement = $input.closest(selectors.cartItem);
      var $itemQtyInputs = $("[data-quantity-item=" + itemIndex + "]");
      var value = parseInt($input.val());
      var isValidValue = !(value < 0 || isNaN(value));
      $itemQtyInputs.val(value);

      this._hideCartError();
      this._hideQuantityErrorMessage();

      if (!isValidValue) {
        this._showQuantityErrorMessages($itemElement);
        return;
      }

      if (isValidValue && this.ajaxEnabled) {
        this._updateItemQuantity(
          itemIndex,
          $itemElement,
          $itemQtyInputs,
          value
        );
      }
    },

    _updateItemQuantity: function (
      itemIndex,
      $itemElement,
      $itemQtyInputs,
      value
    ) {
      var key = $itemElement.attr(attributes.cartItemKey);
      var index = $itemElement.attr(attributes.cartItemIndex);

      var params = {
        url: "/cart/change.js",
        data: { quantity: value, line: index },
        dataType: "json",
        async: false,
      };

      $.post(params)
        .done(
          function (state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);
              if (value === 0) {
                this._showRemoveMessage($itemElement.clone());
              } else {
                var $lineItem = $('[data-cart-item-key="' + key + '"]');
                var item = this.getItem(key, state);

                if (value != item.quantity) {
                  this._showQuantityErrorMessages2(item.quantity, $lineItem);
                }

                $(selectors.quantityInput, $lineItem).focus();
                this._updateLiveRegion(item);
              }
            }
            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .fail(
          function () {
            this._showCartError($itemQtyInputs);
          }.bind(this)
        );
    },

    getItem: function (key, state) {
      return state.items.find(function (item) {
        return item.key === key;
      });
    },

    _liveRegionText: function (item) {
      // Dummy content for live region
      var liveRegionText =
        theme.strings.update +
        ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]";

      // Update Quantity
      liveRegionText = liveRegionText
        .replace("[QuantityLabel]", theme.strings.quantity)
        .replace("[Quantity]", item.quantity);

      // Update pricing information
      var regularLabel = "";
      var regularPrice = theme.Currency.formatMoney(
        item.original_line_price,
        theme.moneyFormat
      );
      var discountLabel = "";
      var discountPrice = "";
      var discountInformation = "";

      if (item.original_line_price > item.final_line_price) {
        regularLabel = theme.strings.regularTotal;

        discountLabel = theme.strings.discountedTotal;
        discountPrice = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );

        discountInformation = theme.strings.priceColumn;
      }

      liveRegionText = liveRegionText
        .replace("[Regular]", regularLabel)
        .replace("[$$]", regularPrice)
        .replace("[DiscountedPrice]", discountLabel)
        .replace("[$]", discountPrice)
        .replace("[PriceInformation]", discountInformation)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function (item) {
      var $liveRegion = $(selectors.cartStatus);
      $liveRegion.html(this._liveRegionText(item)).attr("aria-hidden", false);

      // hide content from accessibility tree after announcement
      setTimeout(function () {
        $liveRegion.attr("aria-hidden", true);
      }, 1000);
    },

    _createCart: function (state) {
      var cartDiscountList = this._createCartDiscountList(state);

      $(selectors.emptyPageContent).addClass(classes.hide);
      $(selectors.cartWrapper).removeClass(classes.hide);

      $(selectors.cartLineItems, this.$container).html(
        this._createLineItemList(state)
      );

      this.setQuantityFormControllers();

      $(selectors.cartNote, this.$container).val(state.note);

      if (cartDiscountList.length === 0) {
        $(selectors.cartDiscountWrapper, this.$container)
          .html("")
          .addClass(classes.hide);
      } else {
        $(selectors.cartDiscountWrapper, this.$container)
          .html(cartDiscountList)
          .removeClass(classes.hide);
      }

      $(selectors.cartSubtotal, this.$container).html(
        theme.Currency.formatMoney(
          state.total_price,
          theme.moneyFormatWithCurrency
        )
      );

      if (this.checkNeedToConvertCurrency()) {
        Currency.convertAll(
          window.shop_currency,
          $("#currencies .active").attr("data-currency"),
          "span.money",
          "money_format"
        );
      }
    },

    _createCartDiscountList: function (cart) {
      return $.map(
        cart.cart_level_discount_applications,
        function (discount) {
          var $discount = this.$cartDiscountTemplate.clone();
          $discount.find(selectors.cartDiscountTitle).text(discount.title);
          $discount
            .find(selectors.cartDiscountAmount)
            .html(
              theme.Currency.formatMoney(
                discount.total_allocated_amount,
                theme.moneyFormat
              )
            );
          return $discount[0];
        }.bind(this)
      );
    },

    _createLineItemList: function (state) {
      return $.map(
        state.items,
        function (item, index) {
          var $item = this.$itemTemplate.clone();
          var $itemPriceList = this.$itemPriceListTemplate.clone();

          this._setLineItemAttributes($item, item, index);
          this._setLineItemImage($item, item.featured_image);

          $(selectors.cartItemTitle, $item)
            .text(item.product_title)
            .attr("href", item.url);

          var productDetailsList = this._createProductDetailsList(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties
          );
          this._setProductDetailsList($item, productDetailsList);

          this._setItemRemove($item, item.title);

          $itemPriceList.html(
            this._createItemPrice(
              item.original_price,
              item.final_price,
              this.$itemPriceListTemplate
            )
          );

          if (item.unit_price_measurement) {
            $itemPriceList.append(
              this._createUnitPrice(
                item.unit_price,
                item.unit_price_measurement,
                this.$itemPriceListTemplate
              )
            );
          }

          this._setItemPrice($item, $itemPriceList);

          var itemDiscountList = this._createItemDiscountList(item);
          this._setItemDiscountList($item, itemDiscountList);

          this._setQuantityInputs($item, item, index);

          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price,
            this.$itemLinePriceTemplate
          );
          this._setItemLinePrice($item, itemLinePrice);

          return $item[0];
        }.bind(this)
      );
    },

    _setLineItemAttributes: function ($item, item, index) {
      $item
        .attr(attributes.cartItemKey, item.key)
        .attr(attributes.cartItemUrl, item.url)
        .attr(attributes.cartItemTitle, item.title)
        .attr(attributes.cartItemIndex, index + 1)
        .attr(attributes.cartItemQuantity, item.quantity);
    },

    _setLineItemImage: function ($item, featuredImage) {
      var $image = $(selectors.cartItemImage, $item);

      var sizedImageUrl =
        featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, "x190")
          : null;

      if (sizedImageUrl) {
        $image
          .attr("alt", featuredImage.alt)
          .attr("src", sizedImageUrl)
          .removeClass(classes.hide);
      } else {
        $image.remove();
      }
    },

    _setProductDetailsList: function ($item, productDetailsList) {
      var $itemDetails = $(selectors.cartItemDetails, $item);

      if (productDetailsList.length === 0) {
        $itemDetails.addClass(classes.hide).text("");
      } else {
        $itemDetails.removeClass(classes.hide).html(productDetailsList);
      }
    },

    _setItemPrice: function ($item, price) {
      $(selectors.cartItemPrice, $item).html(price);
    },

    _setItemDiscountList: function ($item, discountList) {
      var $itemDiscountList = $(selectors.cartItemDiscountList, $item);

      if (discountList.length === 0) {
        $itemDiscountList.html("").addClass(classes.hide);
      } else {
        $itemDiscountList.html(discountList).removeClass(classes.hide);
      }
    },

    _setItemRemove: function ($item, title) {
      $(selectors.cartRemove, $item).attr(
        "aria-label",
        theme.strings.removeLabel.replace("[product]", title)
      );
    },

    _setQuantityInputs: function ($item, item, index) {
      $(selectors.quantityInputMobile, $item)
        .attr("id", "updates_" + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity);

      $(selectors.quantityInputDesktop, $item)
        .attr("id", "updates_large_" + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity);

      $(selectors.quantityLabelMobile, $item).attr(
        "for",
        "updates_" + item.key
      );

      $(selectors.quantityLabelDesktop, $item).attr(
        "for",
        "updates_large_" + item.key
      );
    },

    setQuantityFormControllers: function () {
      if (this.mql.matches) {
        $(selectors.quantityInputDesktop).attr("name", "updates[]");
        $(selectors.quantityInputMobile).removeAttr("name");
      } else {
        $(selectors.quantityInputMobile).attr("name", "updates[]");
        $(selectors.quantityInputDesktop).removeAttr("name");
      }
    },

    _setItemLinePrice: function ($item, price) {
      $(selectors.cartItemLinePrice, $item).html(price);
    },

    _createProductDetailsList: function (
      product_has_only_default_variant,
      options,
      properties
    ) {
      var optionsPropertiesHTML = [];

      if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getOptionList(options)
        );
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getPropertyList(properties)
        );
      }

      return optionsPropertiesHTML;
    },

    _getOptionList: function (options) {
      return $.map(
        options,
        function (option) {
          var $optionElement = this.$itemOptionTemplate.clone();

          $optionElement.text(option.value).removeClass(classes.hide);

          return $optionElement[0];
        }.bind(this)
      );
    },

    _getPropertyList: function (properties) {
      var propertiesArray =
        properties !== null ? Object.entries(properties) : [];

      return $.map(
        propertiesArray,
        function (property) {
          var $propertyElement = this.$itemPropertyTemplate.clone();

          // Line item properties prefixed with an underscore are not to be displayed
          if (property[0].charAt(0) === "_") return;

          // if the property value has a length of 0 (empty), don't display it
          if (property[1].length === 0) return;

          $propertyElement
            .find(selectors.cartItemPropertyName)
            .text(property[0]);

          if (property[0].indexOf("/uploads/") === -1) {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .text(": " + property[1]);
          } else {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .html(
                ': <a href="' +
                  property[1] +
                  '"> ' +
                  property[1].split("/").pop() +
                  "</a>"
              );
          }

          $propertyElement.removeClass(classes.hide);

          return $propertyElement[0];
        }.bind(this)
      );
    },

    _createItemPrice: function (original_price, final_price, $priceTemplate) {
      if (original_price !== final_price) {
        var $discountedPrice = $(
          selectors.cartItemDiscountedPriceGroup,
          $priceTemplate
        ).clone();

        $(selectors.cartItemOriginalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat)
        );
        $(selectors.cartItemFinalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(final_price, theme.moneyFormat)
        );
        $discountedPrice.removeClass(classes.hide);

        return $discountedPrice[0];
      } else {
        var $regularPrice = $(
          selectors.cartItemRegularPriceGroup,
          $priceTemplate
        ).clone();

        $(selectors.cartItemRegularPrice, $regularPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat)
        );

        $regularPrice.removeClass(classes.hide);

        return $regularPrice[0];
      }
    },

    _createUnitPrice: function (
      unitPrice,
      unitPriceMeasurement,
      $itemPriceGroup
    ) {
      var $unitPriceGroup = $(
        selectors.unitPriceGroup,
        $itemPriceGroup
      ).clone();

      var unitPriceBaseUnit =
        (unitPriceMeasurement.reference_value !== 1
          ? unitPriceMeasurement.reference_value
          : "") + unitPriceMeasurement.reference_unit;

      $(selectors.unitPriceBaseUnit, $unitPriceGroup).text(unitPriceBaseUnit);
      $(selectors.unitPrice, $unitPriceGroup).html(
        theme.Currency.formatMoney(unitPrice, theme.moneyFormat)
      );

      $unitPriceGroup.removeClass(classes.hide);

      return $unitPriceGroup[0];
    },

    _createItemDiscountList: function (item) {
      return $.map(
        item.line_level_discount_allocations,
        function (discount) {
          var $discount = this.$itemDiscountTemplate.clone();
          $discount
            .find(selectors.cartItemDiscountTitle)
            .text(discount.discount_application.title);
          $discount
            .find(selectors.cartItemDiscountAmount)
            .html(
              theme.Currency.formatMoney(discount.amount, theme.moneyFormat)
            );
          return $discount[0];
        }.bind(this)
      );
    },

    _showQuantityErrorMessages: function (itemElement) {
      $(selectors.cartQuantityErrorMessage, itemElement).text(
        theme.strings.quantityMinimumMessage
      );

      $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(
        classes.hide
      );

      $(selectors.inputQty, itemElement).addClass(classes.inputError).focus();
    },

    _showQuantityErrorMessages2: function (quantity, itemElement) {
      $(selectors.cartQuantityErrorMessage, itemElement).text(
        theme.strings.cartErrorMaximum.replace("[quantity]", quantity)
      );

      $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(
        classes.hide
      );

      $(selectors.inputQty, itemElement).addClass(classes.inputError).focus();
    },

    _hideQuantityErrorMessage: function () {
      var $errorMessages = $(
        selectors.cartQuantityErrorMessageWrapper
      ).addClass(classes.hide);

      $(selectors.cartQuantityErrorMessage, $errorMessages).text("");

      $(selectors.inputQty, this.$container).removeClass(classes.inputError);
    },

    _handleThumbnailClick: function (evt) {
      var url = $(evt.target).closest(selectors.cartItem).data("cart-item-url");

      window.location.href = url;
    },

    _onNoteChange: function (evt) {
      var note = evt.currentTarget.value;
      this._hideCartError();
      this._hideQuantityErrorMessage();

      var params = {
        url: "/cart/update.js",
        data: { note: note },
        dataType: "json",
      };

      $.post(params).fail(
        function () {
          this._showCartError(evt.currentTarget);
        }.bind(this)
      );
    },

    _showCartError: function (elementToFocus) {
      $(selectors.cartErrorMessage).text(theme.strings.cartError);

      $(selectors.cartErrorMessageWrapper).removeClass(classes.hide);

      elementToFocus.focus();
    },

    _hideCartError: function () {
      $(selectors.cartErrorMessageWrapper).addClass(classes.hide);
      $(selectors.cartErrorMessage).text("");
    },

    _onRemoveItem: function (evt) {
      evt.preventDefault();
      var $remove = $(evt.target);
      var $lineItem = $remove.closest(selectors.cartItem);
      var index = $lineItem.attr(attributes.cartItemIndex);
      this._hideCartError();

      var params = {
        url: "/cart/change.js",
        data: { quantity: 0, line: index },
        dataType: "json",
      };

      $.post(params)
        .done(
          function (state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);
              this._showRemoveMessage($lineItem.clone());
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .fail(
          function () {
            this._showCartError(null);
          }.bind(this)
        );
    },

    _showRemoveMessage: function (lineItem) {
      var index = lineItem.data("cart-item-index");
      var removeMessage = this._getRemoveMessage(lineItem);
      var $lineItemAtIndex;

      if (index - 1 === 0) {
        $lineItemAtIndex = $('[data-cart-item-index="1"]', this.$container);
        $(removeMessage).insertBefore($lineItemAtIndex);
      } else {
        $lineItemAtIndex = $(
          '[data-cart-item-index="' + (index - 1) + '"]',
          this.$container
        );
        removeMessage.insertAfter($lineItemAtIndex);
      }
      removeMessage.focus();
    },

    _getRemoveMessage: function (lineItem) {
      var formattedMessage = this._formatRemoveMessage(lineItem);

      var $tableCell = $(selectors.cartTableCell, lineItem).clone();
      $tableCell
        .removeClass()
        .addClass(classes.cartRemovedProduct)
        .attr("colspan", "4")
        .html(formattedMessage);

      lineItem.attr("role", "alert").html($tableCell).attr("tabindex", "-1");

      return lineItem;
    },

    _formatRemoveMessage: function (lineItem) {
      var quantity = lineItem.data("cart-item-quantity");
      var url = lineItem.attr(attributes.cartItemUrl);
      var title = lineItem.attr(attributes.cartItemTitle);

      return theme.strings.removedItemMessage
        .replace("[quantity]", quantity)
        .replace(
          "[link]",
          "<a " +
            'href="' +
            url +
            '" class="text-link text-link--accent">' +
            title +
            "</a>"
        );
    },

    _setCartCountBubble: function (quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(selectors.cartCount);
      if (quantity > 0) {
        this.$cartCountBubble.removeClass(classes.hide);
        this.$cartCount.html(quantity);
      } else {
        this.$cartCountBubble.addClass(classes.hide);
        this.$cartCount.html("0");
      }
    },

    _emptyCart: function () {
      this.$emptyPageContent =
        this.$emptyPageContent ||
        $(selectors.emptyPageContent, this.$container);
      this.$cartWrapper =
        this.$cartWrapper || $(selectors.cartWrapper, this.$container);

      $(selectors.emptyPageContent).removeClass(classes.hide);
      $(selectors.cartWrapper).addClass(classes.hide);
    },

    _cartTermsConditions: function () {
      // if($('.cart__submit-controls .product__terms-conditions').length) {
      //     var checkBox = $('.cart__submit-controls .product__terms-conditions input[type="checkbox"]');
      //     checkBox.each(function(){
      //         if ($(this).prop('checked')) {
      //             $(this).parents('.cart__submit-controls').find('.btn--checkout').removeClass('disabled');
      //         } else {
      //             $(this).parents('.cart__submit-controls').find('.btn--checkout').addClass('disabled');
      //         }
      //     });
      //     $(document).on('click', '.cart__submit-controls .product__terms-conditions .title', function(event) {
      //         event.preventDefault();
      //         var self = $(this),
      //             ipt = self.prev();
      //         if(!ipt.prop('checked')) {
      //             ipt.prop('checked', true);
      //             self.parents('.cart__submit-controls').find('.btn--checkout').removeClass('disabled');
      //         } else {
      //             ipt.prop('checked', false);
      //             self.parents('.cart__submit-controls').find('.btn--checkout').addClass('disabled');
      //         };
      //     })
      // }
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      }
      return cookieEnabled;
    },
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: "screen and (min-width: 750px)",
  };

  var constants = {
    SORT_BY: "sort_by",
  };

  var selectors = {
    mainContent: "#MainContent",
    filterSelection: "#FilterTags",
    sortSelection: "#SortBy",
    pagination: "#showPagination",
  };

  var data = {
    sortBy: "data-default-sortby",
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$pagination = $(selectors.pagination, $container);
    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.pagination, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass("hidden");

    // this.$filterSelect.on('change', this._onFilterChange.bind(this));
    // this.$sortSelect.on('change', this._onSortChange.bind(this));
    this.$pagination.on("change", this._onPaginationChange.bind(this));
    this._initBreakpoints();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function () {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function () {
          self._resizeSelect(self.$selects);
        },
      });
    },

    _onPaginationChange: function () {
      var number = this._getPaginationValue();
      $.ajax({
        type: "Post",
        url: window.router + "/cart.js",
        data: {
          "attributes[pagination]": number,
        },
        success: function (data) {
          window.location.reload();
        },
        dataType: "json",
      });
    },

    _getPaginationValue: function () {
      return this.$pagination.val();
    },

    _onSortChange: function () {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, "");
      var queryStringValue = slate.utils.getParameterByName("q");
      var query = queryStringValue !== null ? queryStringValue : "";

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, "");
        query = query !== "" ? "?q=" + query + "&" : "?";

        window.location.href =
          urlStripped + query + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _onFilterChange: function () {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, "");

      // only add the search parameters to the url if they exist
      search = search !== "" ? "?" + search : "";

      document.location.href = filter + search + selectors.mainContent;
    },

    _getFilterValue: function () {
      return this.$filterSelect.val();
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return this.$sortSelect.attr(data.sortBy);
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = "";

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + "=" + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find("option:selected").text();
        var $test = $("<span>").html(text);

        // add to body, get width, and get out
        $test.appendTo("body");
        var width = $test.width();
        $test.remove();

        // set select width
        // $this.width(width + arrowWidth);
      });
    },

    onUnload: function () {
      // this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off("change", this._onSortChange);
    },
  });

  return Filters;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14,
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError,
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: "[data-map]",
    mapOverlay: "[data-map-overlay]",
  };

  var classes = {
    mapError: "map-section--load-error",
    errorMsg: "map-section__error errors text-center",
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        "</div>"
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data("api-key");

    if (typeof this.key === "undefined") {
      return;
    }

    if (apiStatus === "loaded") {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== "loading") {
        apiStatus = "loading";
        if (typeof window.google === "undefined") {
          $.getScript(
            "https://maps.googleapis.com/maps/api/js?key=" + this.key
          ).then(function () {
            apiStatus = "loaded";
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data("address-setting");

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            });

            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function () {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
                $map.removeAttr("style");
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = errors.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = errors.addressQueryLimit;
              break;
            case "REQUEST_DENIED":
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  "</div>"
              );
          }
        });
    },

    onUnload: function () {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, "resize");
    },
  });

  return Map;
})();

theme.Product = (function () {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: "screen and (min-width: 1025px)",
      mediaQuerySmall: "screen and (max-width: 1024px)",
      bpSmall: false,
      enableHistoryState: $container.data("enable-history-state") || false,
      namespace: ".slideshow-" + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
    };

    this.selectors = {
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      cartCount: "[data-cart-count]",
      cartCountBubble: "[data-cart-count-bubble]",
      cartPopup: "[data-cart-popup]",
      cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
      cartPopupClose: "[data-cart-popup-close]",
      cartPopupDismiss: "[data-cart-popup-dismiss]",
      cartPopupImage: "[data-cart-popup-image]",
      cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
      cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
      cartPopupProductDetails: "[data-cart-popup-product-details]",
      cartPopupQuantity: "[data-cart-popup-quantity]",
      cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
      cartPopupTitle: "[data-cart-popup-title]",
      cartPopupWrapper: "[data-cart-popup-wrapper]",
      loader: "[data-loader]",
      loaderStatus: "[data-loader-status]",
      labelSale: "[data-label-sale]",
      quantity: "[data-quantity-input]",
      SKU: ".variant-sku",
      productStatus: "[data-product-status]",
      originalSelectorId: "#ProductSelect-" + sectionId,
      productForm: "[data-product-form]",
      errorMessage: "[data-error-message]",
      errorMessageWrapper: "[data-error-message-wrapper]",
      productImage: ".product-single__photo img",
      productImageWraps: ".product-single__photo",
      productMainImageWraps: ".product-single__photo.number__1",
      productThumbImages: ".product-single__thumbnail--" + sectionId,
      productThumbs: ".product-single__thumbnails-" + sectionId,
      productThumbListItem: ".product-single__thumbnails-item",
      productFeaturedImage: ".product-featured-img",
      productThumbsWrapper: ".thumbnails-wrapper",
      saleLabel: ".product-price__sale-label-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId,
      shopifyPaymentButton: ".shopify-payment-button",
      priceContainer: "[data-price]",
      regularPrice: "[data-regular-price]",
      salePrice: "[data-sale-price]",
      unitPrice: "[data-unit-price]",
      totalPrice: "[data-total-price]",
      unitPriceBaseUnit: "[data-unit-price-base-unit]",
    };

    this.classes = {
      cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
      hidden: "hide",
      inputError: "input--error",
      productOnSale: "price--on-sale",
      productUnitAvailable: "price--unit-available",
      productUnavailable: "price--unavailable",
      productFormErrorMessageWrapperHidden:
        "product-form__error-message-wrapper--hidden",
      activeClass: "active-thumb",
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );
    this.$addToCart = $(this.selectors.addToCart, $container);
    this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
    this.$loader = $(this.selectors.loader, this.$addToCart);
    this.$loaderStatus = $(this.selectors.loaderStatus, $container);
    this.$shopifyPaymentButton = $(
      this.selectors.shopifyPaymentButton,
      $container
    );

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      "js-zoom-enabled"
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._initsetMainImage();
    // this._setActiveThumbnail();
    this._next_prev_button();
    this._setNumberQuantity();

    this._setProductCarousel();
    this._initSoldOutProductShop();
    this._setShowmore_description();
    this._initCustomerViewProductShop();
    this._initCountdown();
    this._scrollToReview();
    this._productVideo();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _productVideo: function () {
      if (!$("#video_product.halo_modal").length) {
        return;
      }

      var src = $("#video_product .popup-video").children("iframe").attr("src");

      $("#video_product").on("click", function () {
        if (
          $(event.target).closest("#video_product .popup-video").length === 0
        ) {
          $("#video_product .popup-video").children("iframe").attr("src", "");
        }
      });

      $('.video-link[data-target="#video_product"]').on("click", function () {
        $("#video_product .popup-video").children("iframe").attr("src", src);
      });
    },

    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function () {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function () {
          self.settings.bpSmall = false;
        },
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _enableZoom(this);
            });
          }
        },
      });
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data("enable-history-state") || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        "variantChange" + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        "variantImageChange" + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        "variantPriceChange" + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        "variantSKUChange" + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initsetMainImage: function () {
      if (!$(".product-slider").hasClass("custom")) {
        return;
      }

      var $newImage = $(this.selectors.productMainImageWraps, this.$container);
      var $otherImages = $(this.selectors.productImageWraps, this.$container);
      if ($(".product-slider").hasClass("custom")) {
        $otherImages.addClass(this.classes.hidden);
        $newImage.removeClass(this.classes.hidden);
      }
    },

    _initImageSwitch: function () {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on("click", function (evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data("thumbnail-id");
          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on("keyup", self._handleImageFocus.bind(self));
    },

    _initAddToCart: function () {
      $(this.selectors.productForm, this.$container).on(
        "submit",
        function (evt) {
          evt.preventDefault();
          this.$previouslyFocusedElement = $(":focus");

          var isInvalidQuantity = this.$quantityInput.val() <= 0;

          if (this.$addToCart.is("[aria-disabled]")) return;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
          } else {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var $data = $(this.selectors.productForm, this.$container);
            this._addItemToCart($data);
          }
        }.bind(this)
      );
    },

    _addItemToCart: function (data) {
      var params = {
        url: window.router + "/cart/add.js",
        data: $(data).serialize(),
        dataType: "json",
      };

      $.post(params)
        .done(
          function (item) {
            this._hideErrorMessage();
            this._setupCartPopup(item);
            this._updateTotalPrice();
            if (typeof __supercart?.open_cart == "function") {
              __supercart.open_cart();
            }
          }.bind(this)
        )
        .fail(
          function (response) {
            this.$previouslyFocusedElement.focus();
            this._showErrorMessage(response.responseJSON.description);
            this._handleButtonLoadingState(false);
          }.bind(this)
        );
    },

    _handleButtonLoadingState: function (isLoading) {
      if (isLoading) {
        this.$addToCart.attr("aria-disabled", true);
        this.$addToCartText.addClass(this.classes.hidden);
        this.$loader.removeClass(this.classes.hidden);
        this.$shopifyPaymentButton.attr("disabled", true);
        this.$loaderStatus.attr("aria-hidden", false);
      } else {
        this.$addToCart.removeAttr("aria-disabled");
        this.$addToCartText.removeClass(this.classes.hidden);
        this.$loader.addClass(this.classes.hidden);
        this.$shopifyPaymentButton.removeAttr("disabled");
        this.$loaderStatus.attr("aria-hidden", true);
      }
    },

    _showErrorMessage: function (errorMessage) {
      $(this.selectors.errorMessage, this.$container).html(errorMessage);

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError);
      }

      this.$errorMessageWrapper
        .removeClass(this.classes.productFormErrorMessageWrapperHidden)
        .attr("aria-hidden", true)
        .removeAttr("aria-hidden");
    },

    _hideErrorMessage: function () {
      this.$errorMessageWrapper.addClass(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.removeClass(this.classes.inputError);
      }
    },

    _updateTotalPrice: function () {
      if (!$(".navUser-action-total-price").length) {
        return;
      }
      Shopify.getCart(function (cart) {
        $(".navUser-action-total-price .total-price").html(
          theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
        );
      });
    },

    _setupCartPopup: function (item) {
      this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
      this.$cartPopupWrapper =
        this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
      this.$cartPopupTitle =
        this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
      this.$cartPopupQuantity =
        this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
      this.$cartPopupQuantityLabel =
        this.$cartPopupQuantityLabel ||
        $(this.selectors.cartPopupQuantityLabel);
      this.$cartPopupClose =
        this.$cartPopupClose || $(this.selectors.cartPopupClose);
      this.$cartPopupDismiss =
        this.cartPopupDismiss || $(this.selectors.cartPopupDismiss);

      this._setupCartPopupEventListeners();

      this._updateCartPopupContent(item);
    },

    _updateCartPopupContent: function (item) {
      var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

      this.$cartPopupTitle.text(item.product_title);
      this.$cartPopupQuantity.text(quantity);
      this.$cartPopupQuantityLabel.text(
        theme.strings.quantityLabel.replace("[count]", quantity)
      );

      this._setCartPopupImage(item.image, item.title);
      this._setCartPopupProductDetails(item.variant_options, item.properties);

      $.getJSON("/cart.js").then(
        function (cart) {
          this._setCartQuantity(cart.item_count);
          this._setCartCountBubble(cart.item_count);
          this._showCartPopup();
        }.bind(this)
      );

      var close = this.$cartPopupClose;
      setTimeout(function () {
        close.trigger("click");
      }, 3000);
    },

    _setupCartPopupEventListeners: function () {
      this.$cartPopupWrapper.on(
        "keyup",
        function (event) {
          if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            this._hideCartPopup(event);
          }
        }.bind(this)
      );

      this.$cartPopupClose.on("click", this._hideCartPopup.bind(this));
      this.$cartPopupDismiss.on("click", this._hideCartPopup.bind(this));
      $("body").on("click", this._onBodyClick.bind(this));
    },

    _setCartPopupImage: function (imageUrl, productTitle) {
      this.$cartPopupImageWrapper =
        this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

      this.$cartPopupImagePlaceholder =
        this.$cartPopupImagePlaceholder ||
        $(this.selectors.cartPopupImagePlaceholder);

      if (imageUrl === null) {
        this.$cartPopupImageWrapper.addClass(this.classes.hidden);
        return;
      }

      this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, "200x");
      var image = document.createElement("img");
      image.src = sizedImageUrl;
      image.alt = productTitle;
      image.dataset.cartPopupImage = "";

      image.onload = function () {
        this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
        this.$cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function (variantOptions, properties) {
      this.$cartPopupProductDetails =
        this.$cartPopupProductDetails ||
        $(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = "";

      if (variantOptions[0] !== "Default Title") {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(variantOptions);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.$cartPopupProductDetails.html("");
        this.$cartPopupProductDetails.attr("hidden", "");
      } else {
        this.$cartPopupProductDetails.html(variantPropertiesHTML);
        this.$cartPopupProductDetails.removeAttr("hidden");
      }
    },

    _getVariantOptionList: function (variantOptions) {
      var variantOptionListHTML = "";

      variantOptions.forEach(function (variantOption) {
        variantOptionListHTML =
          variantOptionListHTML +
          '<li class="product-details__item product-details__item--variant-option">' +
          variantOption +
          "</li>";
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function (properties) {
      var propertyListHTML = "";
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function (property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === "_") return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          '<li class="product-details__item product-details__item--property">' +
          '<span class="product-details__property-label">' +
          property[0] +
          ": </span>" +
          property[1];
        ": " + "</li>";
      });

      return propertyListHTML;
    },

    _setCartQuantity: function (quantity) {
      this.$cartPopupCartQuantity =
        this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace("[count]", quantity);
      }

      this.$cartPopupCartQuantity.text(quantity).attr("aria-label", ariaLabel);
    },

    _setNumberQuantity: function () {
      var buttonSlt = "[data-qtt]",
        buttonElm = $(buttonSlt);

      $(document).on("click", buttonSlt, function (e) {
        e.preventDefault();
        e.stopPropagation();

        var self = $(this),
          input = $("[data-quantity-input]"),
          oldVal = parseInt(input.val()),
          newVal = 1;

        switch (true) {
          case self.hasClass("plus"): {
            newVal = oldVal + 1;
            break;
          }
          case self.hasClass("minus") && oldVal > 1: {
            newVal = oldVal - 1;
            break;
          }
        }
        input.val(newVal).trigger("change");

        var $totalPrice = $("[data-total-price]");
        var oldPrice = $("[data-total-price]").attr("data-price-value");
        $totalPrice.html(
          theme.Currency.formatMoney(oldPrice * newVal, theme.moneyFormat)
        );

        if (checkNeedToConvertCurrency()) {
          Currency.convertAll(
            window.shop_currency,
            $("#currencies .active").attr("data-currency"),
            "span.money",
            "money_format"
          );
        }
      });
    },

    _setCartCountBubble: function (quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(this.selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

      this.$cartCountBubble.removeClass(this.classes.hidden);
      this.$cartCount.text(quantity);
    },

    _showCartPopup: function () {
      this.$cartPopupWrapper
        .prepareTransition()
        .removeClass(this.classes.cartPopupWrapperHidden);
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        $container: this.$cartPopupWrapper,
        $elementToFocus: this.$cartPopup,
        namespace: "cartPopupFocus",
      });
    },

    _hideCartPopup: function (event) {
      var setFocus = event.detail === 0 ? true : false;
      this.$cartPopupWrapper
        .prepareTransition()
        .addClass(this.classes.cartPopupWrapperHidden);

      $(this.selectors.cartPopupImage).remove();
      this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

      slate.a11y.removeTrapFocus({
        $container: this.$cartPopupWrapper,
        namespace: "cartPopupFocus",
      });

      if (setFocus) this.$previouslyFocusedElement[0].focus();

      this.$cartPopupWrapper.off("keyup");
      this.$cartPopupClose.off("click");
      this.$cartPopupDismiss.off("click");
      $("body").off("click");
    },

    _onBodyClick: function (event) {
      var $target = $(event.target);

      if (
        $target[0] !== this.$cartPopupWrapper[0] &&
        !$target.parents(this.selectors.cartPopup).length
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function (imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === "undefined") {
        imageId = $(
          this.selectors.productImageWraps + ":not(.hide)",
          this.$container
        ).data("image-id");
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ":not(.slick-cloned)",
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(this.classes.activeClass)
        .removeAttr("aria-current");

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr("aria-current", true);

      if (!$thumbnailWrappers.hasClass("slick-slide")) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data("slick-index");
      $(this.selectors.productThumbs).slick("slickGoTo", slideIndex);
    },

    _next_prev_button: function () {
      if ($(".product-slider").hasClass("custom")) {
        return;
      }

      var $buttonPrevNext = $(this.selectors.productThumbs).find(
          ".slick-arrow"
        ),
        $productThumbImages = $(this.selectors.productThumbImages);

      $(document).on("click", $buttonPrevNext, function () {
        var $activeThumbnail = $(".product-single__thumbnails").find(
          ".slick-current"
        );

        $productThumbImages
          .removeClass("active-thumb")
          .removeAttr("aria-current");

        $activeThumbnail.children().addClass("active-thumb");
        $activeThumbnail.children().attr("aria-current", true);
      });
    },

    _switchImage: function (imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      if ($(".product-slider").hasClass("custom")) {
        $newImage.removeClass(this.classes.hidden);
        $otherImages.addClass(this.classes.hidden);
      }
    },

    _handleImageFocus: function (evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ":visible").focus();
    },

    _liveRegionText: function (variant) {
      // Dummy content for live region
      var liveRegionText =
        "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";

      // Update availability
      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      var availability = variant.available ? "" : theme.strings.soldOut + ",";

      liveRegionText = liveRegionText.replace("[Availability]", availability);

      // Update pricing information
      var regularLabel = "";
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = "";
      var salePrice = "";
      var unitLabel = "";
      var unitPrice = "";

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ",";
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
          
        );
      }
     

      if (variant.unit_price) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          " " +
          theme.strings.unitPriceSeparator +
          " " +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
        .replace("[Regular]", regularLabel)
        .replace("[$$]", regularPrice)
        .replace("[Sale]", saleLabel)
        .replace("[$]", salePrice)
        .replace("[UnitPrice]", unitLabel)
        .replace("[$$$]", unitPrice)
        .trim();

      return liveRegionText;
    },
    
    _updateLiveRegion: function (evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute("aria-hidden", false);

      // hide content from accessibility tree after announcement
      setTimeout(function () {
        liveRegion.setAttribute("aria-hidden", true);
      }, 1000);
    },

    _updateAddToCart: function (evt) {
      var variant = evt.variant;
      if (variant) {
        if (variant.available) {
          this.$addToCart
            .removeAttr("aria-disabled")
            .attr("aria-label", theme.strings.addToCart);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.addToCart
          );
          this.$shopifyPaymentButton.show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          this.$addToCart
            .attr("aria-disabled", true)
            .attr("aria-label", theme.strings.soldOut);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.soldOut
          );
          this.$shopifyPaymentButton.hide();
        }
      } else {
        this.$addToCart
          .attr("aria-disabled", true)
          .attr("aria-label", theme.strings.unavailable);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.unavailable
        );
        this.$shopifyPaymentButton.hide();
      }
    },

    _updateAvailability: function (evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function (evt) {
      var variant = evt.variant;
      var imageId = variant.featured_media.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);
      var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
      var $totalPrice = $(this.selectors.totalPrice, $priceContainer);
      var $labelSale = $(this.selectors.labelSale, this.$container);
      var $unitPriceBaseUnit = $(
        this.selectors.unitPriceBaseUnit,
        $priceContainer
      );

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeClass(this.classes.productUnitAvailable)
        .removeAttr("aria-hidden");

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr("aria-hidden", true);
        return;
      }

      // On sale
      var quantity = parseInt($("[data-quantity-input]").val());
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $("[data-total-price]").attr("data-price-value", variant.price);
        $("[data-total-price]").html(
          theme.Currency.formatMoney(
            variant.price * quantity,
            theme.moneyFormat
          )
        );
        
        $priceContainer.addClass(this.classes.productOnSale);
        // label Sale
        $labelSale.show();
        $labelSale.html(
          "-" +
            Math.floor(
              ((variant.compare_at_price - variant.price) /
                variant.compare_at_price) *
                100
            ) +
            "%"
        );
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $salePrice.html("");
        $("[data-total-price]").attr("data-price-value", variant.price);
        $("[data-total-price]").html(
          theme.Currency.formatMoney(
            variant.price * quantity,
            theme.moneyFormat
          )
        );
        $labelSale.hide();
      }

      if (checkNeedToConvertCurrency()) {
        Currency.convertAll(
          window.shop_currency,
          $("#currencies .active").attr("data-currency"),
          "span.money",
          "money_format"
        );
      }

      // Unit price
      // if (variant.unit_price) {
      //     $unitPrice.html(
      //         theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
      //     );
      //     $unitPriceBaseUnit.html(this._getBaseUnit(variant));
      //     $priceContainer.addClass(this.classes.productUnitAvailable);
      // }
    },

    _getBaseUnit: function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function (evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    _setProductCarousel: function () {
      if (!$(".product-slider").length) {
        return;
      }

      $(".product-slider").each(function (index) {
        if ($(this).hasClass("custom")) {
          if ($(window).width() < 1025) {
            var $carousel_nav = $(this).find(".slider-nav"),
              $carousel_for = $(this).find(".slider-for"),
              $column = $carousel_nav.data("rows");
            if ($carousel_for.length) {
              $carousel_for.slick({
                fade: true,
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: $carousel_nav,
                adaptiveHeight: true,
                responsive: [
                  {
                    breakpoint: 992,
                    settings: {
                      dots: true,
                    },
                  },
                  {
                    breakpoint: 550,
                    settings: {
                      dots: true,
                    },
                  },
                ],
              });

              $carousel_nav.slick({
                rows: 0,
                arrows: false,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                focusOnSelect: true,
                asNavFor: $carousel_for,
                responsive: [
                  {
                    breakpoint: 550,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                    },
                  },
                ],
              });
            }
          }
        } else {
          var $carousel_nav = $(this).find(".slider-nav"),
            $carousel_for = $(this).find(".slider-for"),
            $column = $carousel_nav.data("rows");
          if ($carousel_for.length) {
            $carousel_for.slick({
              fade: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              asNavFor: $carousel_nav,
              adaptiveHeight: true,
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    dots: true,
                  },
                },
                {
                  breakpoint: 550,
                  settings: {
                    dots: true,
                  },
                },
              ],
            });

            $carousel_nav.slick({
              infinite: true,
              slidesToShow: $column,
              slidesToScroll: 1,
              arrows: true,
              rows: 0,
              focusOnSelect: true,
              asNavFor: $carousel_for,
              prevArrow:
                '<div class="slick-prev slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-left"></svg></div>',
              nextArrow:
                '<div class="slick-next slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-right"></svg></div>',
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 550,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          }
        }
      });
    },

    _initSoldOutProductShop: function () {
      var soldProduct = $("[data-soldOut-product]");

      if (soldProduct.length) {
        soldProduct.each(function () {
          var self = $(this);

          var items = self.data("items").toString().split(","),
            hours = self.data("hours").toString().split(","),
            i = Math.floor(Math.random() * items.length),
            j = Math.floor(Math.random() * hours.length);

          self.find(".items-count").text(items[i]);
          self.find(".hours-num").text(hours[j]);
        });
      }
    },

    _initCustomerViewProductShop: function () {
      var customerView = $("[data-customer-view]");

      if (customerView.length) {
        customerView.each(function () {
          var self = $(this);

          setInterval(function () {
            var views = self.data("customer-view").split(","),
              i = Math.floor(Math.random() * views.length);

            self.find("label").text(views[i]);
          }, 5000);
        });
      }
    },

    _setShowmore_description: function () {
      if (!$(".description_showmore").length) {
        return;
      }

      if ($(window).width() <= 767) {
        var $showmore = $(".showmore"),
          $showless = $(".showless"),
          $showmore_wrapper = $(".description_showmore").parent();

        $showmore_wrapper.css("max-height", 370);

        $showmore.on("click", function () {
          $showmore_wrapper.css("max-height", "none");
          $showmore.removeClass("show").addClass("hide");
          $showless.removeClass("hide").addClass("show");
        });

        $showless.on("click", function () {
          $showmore_wrapper.css("max-height", 370);
          $showless.removeClass("show").addClass("hide");
          $showmore.removeClass("hide").addClass("show");
        });
      }
    },

    _initCountdown: function () {
      var countdownElm = $(".product-countdown[data-countdown]");
      countdownElm.each(function () {
        // Set the date we're counting down to
        if ($(this).hasClass("has-value")) {
          return;
        }

        var self = $(this),
          countDownDate = new Date(self.attr("data-countdown-value")).getTime();
        // Update the count down every 1 second
        var countdownfunction = setInterval(function () {
          // Get todays date and time
          var now = new Date().getTime();

          // Find the distance between now an the count down date
          var distance = countDownDate - now;

          // If the count down is over, write some text
          if (distance < 0) {
            clearInterval(countdownfunction);
            document.getElementById("product-countdown").innerHTML =
              "<span></span>";
          } else {
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor(
              (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            var minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // days = this.$container.on( this._setShowDateFormat(days).bind(this));
            // Output the result in an element with id="countDowntimer"
            var strCountDown =
              "<span class='block-time'>" +
              _setShowDateFormat(days) +
              "<span class='block-label'>days</span></span><span class='block-time'>" +
              _setShowTime(hours) +
              "<span class='block-label'>hours</span></span><span class='block-time'>" +
              _setShowTime(minutes) +
              "<span class='block-label'>mins</span></span><span class='block-time'>" +
              _setShowTime(seconds) +
              "<span class='block-label'>secs</span></span>";
            self.html(strCountDown);
            self.addClass("has-value");
          }
        }, 1000);
      });
    },

    _scrollToReview: function () {
      // if(!$('.product_template .product_shop .spr-badge').length) {
      //     return;
      // }

      $(document).on(
        "click",
        ".product_template .product_shop .spr-badge",
        function (event) {
          event.preventDefault();
          if ($(".product_layout_1").length) {
            var offset = $(".product-review__inner").offset();
          } else if ($(".product_layout_2").length) {
            if ($(".toggle_reviews").length) {
              var offset = $(".tab-vertical").offset();
              $(".tab-vertical .toggle-content.show")
                .prev()
                .find(".toggleLink")
                .trigger("click");
              $(".toggle_reviews .toggleLink").trigger("click");
            }
          } else {
            if ($(".tab-pane-review").length) {
              var offset = $(".productView-description").offset();
              if ($(window).width() > 767) {
                $(".tab_review .tab-title").trigger("click");
                offset.top = offset.top - 70;
              } else {
                $(".tab-content .toggle-content.show")
                  .prev()
                  .find(".toggleLink")
                  .trigger("click");
                $(".tab-pane-review .toggleLink").trigger("click");
              }
            }
          }
          $("body,html").animate(
            {
              scrollTop: offset.top - 70,
            },
            1000
          );
        }
      );
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
    },
  });

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function _enableZoom(el) {
    var zoomUrl = $(el).data("zoom");
    $(el).zoom({
      url: zoomUrl,
      magnify: 1.5,
    });
    // setTimeout(function(){
    // $(el).elevateZoom({
    //     // zoomType: "inner",
    //     // zoomType: "lens",
    //     scrollZoom: true,
    //     cursor: "crosshair"
    // });
    // }, 100);
  }

  function _destroyZoom(el) {
    $(el).trigger("zoom.destroy");
  }

  function _setShowTime(t) {
    if (t < 10) {
      return "<span class='num'>0</span><span class='num'>" + t + "</span>";
    }
    return (
      "<span class='num'>" +
      parseInt(t / 10) +
      "</span><span class='num'>" +
      (t % 10) +
      "</span>"
    );
  }

  function _setShowDateFormat(t) {
    if (t < 10) {
      return "<span class='num'>0</span><span class='num'>" + t + "</span>";
    }
    if (t > 100) {
      return (
        _setShowDateFormat(parseInt(t / 10)) +
        "<span class='num'>" +
        (t % 10) +
        "</span>"
      );
    }
    return (
      "<span class='num'>" +
      parseInt(t / 10) +
      "</span><span class='num'>" +
      (t % 10) +
      "</span>"
    );
  }

  return Product;
})();

theme.product_quickview = (function () {
  function product_quickview() {
    var $container = $(".product_quickview");
    var sectionId = $container.attr("data-section-id");

    this.settings = {
      mediaQueryMediumUp: "screen and (min-width: 1025px)",
      mediaQuerySmall: "screen and (max-width: 1024px)",
      bpSmall: false,
      enableHistoryState: $container.data("enable-history-state") || false,
      namespace: ".slideshow-" + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
    };

    this.selectors = {
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      cartCount: "[data-cart-count]",
      cartCountBubble: "[data-cart-count-bubble]",
      cartPopup: "[data-cart-popup]",
      cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
      cartPopupClose: "[data-cart-popup-close]",
      cartPopupDismiss: "[data-cart-popup-dismiss]",
      cartPopupImage: "[data-cart-popup-image]",
      cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
      cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
      cartPopupProductDetails: "[data-cart-popup-product-details]",
      cartPopupQuantity: "[data-cart-popup-quantity]",
      cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
      cartPopupTitle: "[data-cart-popup-title]",
      cartPopupWrapper: "[data-cart-popup-wrapper]",
      labelSale: "[data-label-sale]",
      loader: "[data-loader]",
      loaderStatus: "[data-loader-status]",
      quantity: "[data-quantity-input]",
      SKU: ".variant-sku",
      productStatus: "[data-product-status]",
      originalSelectorId: "#ProductSelect-" + sectionId,
      productForm: "[data-product-form]",
      errorMessage: "[data-error-message]",
      errorMessageWrapper: "[data-error-message-wrapper]",
      productImageWraps: ".product-single__photo",
      productMainImageWraps: ".product-single__photo.number__1",
      productThumbImages: ".product-single__thumbnail--" + sectionId,
      productThumbs: ".product-single__thumbnails-" + sectionId,
      productThumbListItem: ".product-single__thumbnails-item",
      productFeaturedImage: ".product-featured-img",
      productThumbsWrapper: ".thumbnails-wrapper",
      saleLabel: ".product-price__sale-label-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId,
      shopifyPaymentButton: ".shopify-payment-button",
      priceContainer: "[data-price-qv]",
      regularPrice: "[data-regular-price-qv]",
      salePrice: "[data-sale-price-qv]",
      unitPrice: "[data-unit-price]",
      unitPriceBaseUnit: "[data-unit-price-base-unit]",
    };

    this.classes = {
      cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
      hidden: "hide",
      inputError: "input--error",
      productOnSale: "price--on-sale",
      productUnitAvailable: "price--unit-available",
      productUnavailable: "price--unavailable",
      productFormErrorMessageWrapperHidden:
        "product-form__error-message-wrapper--hidden",
      activeClass: "active-thumb",
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );
    this.$addToCart = $(this.selectors.addToCart, $container);
    this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
    this.$loader = $(this.selectors.loader, this.$addToCart);
    this.$loaderStatus = $(this.selectors.loaderStatus, $container);
    this.$shopifyPaymentButton = $(
      this.selectors.shopifyPaymentButton,
      $container
    );

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      "js-zoom-enabled"
    );

    _initBreakpoints();
    _stringOverrides();
    _initVariants();
    _initImageSwitch();
    _initAddToCart();
    _next_prev_button();
    _setNumberQuantity();

    _setProductCarousel();
    // _setActiveThumbnail();
    _initCountdown();
    _initSoldOutProductShop();
    _initCustomerViewProductShop();
    _addonSocial();

    if ($(".shopify-product-reviews-badge").length && $(".spr-badge").length) {
      return (
        window.SPR.registerCallbacks(),
        window.SPR.initRatingHandler(),
        window.SPR.initDomEls(),
        window.SPR.loadProducts(),
        window.SPR.loadBadges()
      );
    }
  }

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function _initQuickView() {
    var quickview = "[data-quickview]";
    $(document).on("click", quickview, function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      var href = $(this).attr("id");
      _doAjaxShowQuickView(href);
    });
  }

  function _doAjaxShowQuickView(href) {
    $.ajax({
      type: "get",
      url: window.router + "/products/" + href + "?view=quickview",

      beforeSend: function () {
        _initShowLoading();
      },

      success: function (data) {
        var quickviewModal = $("#product_quickview"),
          modalContent = quickviewModal.find(".product_template");

        modalContent.html(data);

        setTimeout(function () {
          product_quickview();
        }, 1000);

        _initHideLoading();

        theme.wishlist.init();

        $("#product_quickview").modal("show");

        _setupQuickViewPopupEventListeners();
      },
    });
  }

  function _setupQuickViewPopupEventListeners() {
    $("#product_quickview").on(
      "keyup",
      function (event) {
        if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
          _hideQuickviewPopup();
        }
      }.bind(this)
    );

    $("#product_quickview .close-modal").on(
      "click",
      _hideQuickviewPopup.bind(this)
    );
    $("#product_quickview").on("click", function (event) {
      if (
        $(event.target).closest("#product_quickview .modal-quickview")
          .length === 0
      ) {
        _hideQuickviewPopup();
      }
    });
  }

  function _hideQuickviewPopup() {
    $("#product_quickview").modal("hide");

    setTimeout(function () {
      $("#product_quickview .product_template").html("");
    }, 500);
  }

  function _initShowLoading() {
    $(".loading-modal").show();
  }

  function _initHideLoading() {
    $(".loading-modal").hide();
  }

  function _setProductCarousel() {
    if (!$(".product_quickview .product-slider").length) {
      return;
    }

    var $carousel_nav = $(".product_quickview .product-slider").find(
        ".slider-nav"
      ),
      $carousel_for = $(".product_quickview .product-slider").find(
        ".slider-for"
      ),
      $column = $carousel_nav.data("rows");
    if ($carousel_for.length) {
      $carousel_for.slick({
        fade: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: $carousel_nav,
      });
      $carousel_nav.slick({
        rows: 0,
        infinite: true,
        slidesToShow: $column,
        slidesToScroll: 1,
        arrows: true,
        focusOnSelect: true,
        asNavFor: $carousel_for,
        prevArrow:
          '<div class="slick-prev slick-arrow"><i class="fas fa-chevron-left iconos_generales"></i></div>',
        nextArrow:
          '<div class="slick-next slick-arrow"><i class="fas fa-chevron-right iconos_generales"></i></div>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  }

  function _initCountdown() {
    var countdownElm = $(".product-countdown[data-countdown]");
    countdownElm.each(function () {
      // Set the date we're counting down to
      if ($(this).hasClass("has-value")) {
        return;
      }

      var self = $(this),
        countDownDate = new Date(self.attr("data-countdown-value")).getTime();
      // Update the count down every 1 second
      var countdownfunction = setInterval(function () {
        // Get todays date and time
        var now = new Date().getTime();

        // Find the distance between now an the count down date
        var distance = countDownDate - now;

        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(countdownfunction);
          document.getElementById("product-countdown").innerHTML =
            "<span></span>";
        } else {
          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // days = this.$container.on( this._setShowDateFormat(days).bind(this));

          // Output the result in an element with id="countDowntimer"
          var strCountDown =
            "<span class='block-time'>" +
            _setShowDateFormat(days) +
            "<span class='block-label'>days</span></span><span class='block-time'>" +
            _setShowTime(hours) +
            "<span class='block-label'>hours</span></span><span class='block-time'>" +
            _setShowTime(minutes) +
            "<span class='block-label'>mins</span></span><span class='block-time'>" +
            _setShowTime(seconds) +
            "<span class='block-label'>secs</span></span>";
          self.html(strCountDown);
          self.addClass("has-value");
        }
      }, 1000);
    });
  }

  function _initSoldOutProductShop() {
    var soldProduct = $("[data-soldOut-product]");

    if (soldProduct.length) {
      soldProduct.each(function () {
        var self = $(this);

        var items = self.data("items").toString().split(","),
          hours = self.data("hours").toString().split(","),
          i = Math.floor(Math.random() * items.length),
          j = Math.floor(Math.random() * hours.length);

        self.find(".items-count").text(items[i]);
        self.find(".hours-num").text(hours[j]);
      });
    }
  }

  function _initCustomerViewProductShop() {
    var customerView = $("[data-customer-view]");

    if (customerView.length) {
      customerView.each(function () {
        var self = $(this);

        setInterval(function () {
          var views = self.data("customer-view").split(","),
            i = Math.floor(Math.random() * views.length);

          self.find("label").text(views[i]);
        }, 5000);
      });
    }
  }

  function _stringOverrides() {
    theme.productStrings = theme.productStrings || {};
    $.extend(theme.strings, theme.productStrings);
  }

  function _initBreakpoints() {
    var self = this;

    enquire.register(this.settings.mediaQuerySmall, {
      match: function () {
        // destroy image zooming if enabled
        if (self.settings.zoomEnabled) {
          $(self.selectors.productImageWraps).each(function () {
            _destroyZoom(this);
          });
        }

        self.settings.bpSmall = true;
      },
      unmatch: function () {
        self.settings.bpSmall = false;
      },
    });

    enquire.register(this.settings.mediaQueryMediumUp, {
      match: function () {
        if (self.settings.zoomEnabled) {
          $(self.selectors.productImageWraps).each(function () {
            _enableZoom(this);
          });
        }
      },
    });
  }

  function _initVariants() {
    var options = {
      $container: $(".product_quickview"),
      enableHistoryState:
        $(".product_quickview").data("enable-history-state") || false,
      singleOptionSelector: this.selectors.singleOptionSelector,
      originalSelectorId: this.selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.variants = new slate.Variants2(options);

    $(".product_quickview").on(
      "variantChange" + this.settings.namespace,
      _updateAvailability.bind(this)
    );
    $(".product_quickview").on(
      "variantImageChange" + this.settings.namespace,
      _updateImages.bind(this)
    );
    $(".product_quickview").on(
      "variantPriceChange" + this.settings.namespace,
      _updatePrice.bind(this)
    );
    $(".product_quickview").on(
      "variantSKUChange" + this.settings.namespace,
      _updateSKU.bind(this)
    );
  }

  function _initImageSwitch() {
    if (!$(this.selectors.productThumbImages).length) {
      return;
    }

    var self = this;

    $(this.selectors.productThumbImages)
      .on("click", function (evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data("thumbnail-id");
        _switchImage(imageId);
        _setActiveThumbnail(imageId);
      })
      .on("keyup", _handleImageFocus.bind(self));
  }

  function _initAddToCart() {
    $(this.selectors.productForm, this.$container).on(
      "submit",
      function (evt) {
        evt.preventDefault();
        this.$previouslyFocusedElement = $(":focus");

        var isInvalidQuantity = this.$quantityInput.val() <= 0;

        if (this.$addToCart.is("[aria-disabled]")) return;

        if (isInvalidQuantity) {
          this._showErrorMessage(theme.strings.quantityMinimumMessage);
        } else {
          // disable the addToCart and dynamic checkout button while
          // request/cart popup is loading and handle loading state
          _handleButtonLoadingState(true);
          var $data = $(this.selectors.productForm, this.$container);
          _addItemToCart($data);
        }
      }.bind(this)
    );
  }

  function _addItemToCart(data) {
    var params = {
      url: window.router + "/cart/add.js",
      data: $(data).serialize(),
      dataType: "json",
    };

    $.post(params)
      .done(
        function (item) {
          _hideErrorMessage();
          _setupCartPopup(item);
          _updateTotalPrice();
          _hideQuickviewPopup();
        }.bind(this)
      )
      .fail(
        function (response) {
          this.$previouslyFocusedElement.focus();
          _showErrorMessage(response.responseJSON.description);
          _handleButtonLoadingState(false);
        }.bind(this)
      );
  }

  function _handleButtonLoadingState(isLoading) {
    if (isLoading) {
      this.$addToCart.attr("aria-disabled", true);
      this.$addToCartText.addClass(this.classes.hidden);
      this.$loader.removeClass(this.classes.hidden);
      this.$shopifyPaymentButton.attr("disabled", true);
      this.$loaderStatus.attr("aria-hidden", false);
    } else {
      this.$addToCart.removeAttr("aria-disabled");
      this.$addToCartText.removeClass(this.classes.hidden);
      this.$loader.addClass(this.classes.hidden);
      this.$shopifyPaymentButton.removeAttr("disabled");
      this.$loaderStatus.attr("aria-hidden", true);
    }
  }

  function _showErrorMessage(errorMessage) {
    $(this.selectors.errorMessage, this.$container).html(errorMessage);

    if (this.$quantityInput.length !== 0) {
      this.$quantityInput.addClass(this.classes.inputError);
    }

    this.$errorMessageWrapper
      .removeClass(this.classes.productFormErrorMessageWrapperHidden)
      .attr("aria-hidden", true)
      .removeAttr("aria-hidden");
  }

  function _hideErrorMessage() {
    this.$errorMessageWrapper.addClass(
      this.classes.productFormErrorMessageWrapperHidden
    );

    if (this.$quantityInput.length !== 0) {
      this.$quantityInput.removeClass(this.classes.inputError);
    }
  }

  function _updateTotalPrice() {
    if (!$(".navUser-action-total-price").length) {
      return;
    }
    Shopify.getCart(function (cart) {
      $(".navUser-action-total-price .total-price").html(
        theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
      );
    });
  }

  function _setupCartPopup(item) {
    this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
    this.$cartPopupWrapper =
      this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
    this.$cartPopupTitle =
      this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
    this.$cartPopupQuantity =
      this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
    this.$cartPopupQuantityLabel =
      this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel);
    this.$cartPopupClose =
      this.$cartPopupClose || $(this.selectors.cartPopupClose);
    this.$cartPopupDismiss =
      this.cartPopupDismiss || $(this.selectors.cartPopupDismiss);

    _setupCartPopupEventListeners();
    _updateCartPopupContent(item);
  }

  function _updateCartPopupContent(item) {
    var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

    this.$cartPopupTitle.text(item.product_title);
    this.$cartPopupQuantity.text(quantity);
    this.$cartPopupQuantityLabel.text(
      theme.strings.quantityLabel.replace("[count]", quantity)
    );

    _setCartPopupImage(item.image, item.title);
    _setCartPopupProductDetails(item.variant_options, item.properties);

    $.getJSON("/cart.js").then(
      function (cart) {
        _setCartQuantity(cart.item_count);
        _setCartCountBubble(cart.item_count);
        _showCartPopup();
      }.bind(this)
    );

    var close = this.$cartPopupClose;
    setTimeout(function () {
      close.trigger("click");
    }, 3000);
  }

  function _setupCartPopupEventListeners() {
    this.$cartPopupWrapper.on(
      "keyup",
      function (event) {
        if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
          _hideCartPopup(event);
        }
      }.bind(this)
    );

    this.$cartPopupClose.on("click", _hideCartPopup.bind(this));
    this.$cartPopupDismiss.on("click", _hideCartPopup.bind(this));
    $("body").on("click", _onBodyClick.bind(this));
  }

  function _setCartPopupImage(imageUrl, productTitle) {
    this.$cartPopupImageWrapper =
      this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

    this.$cartPopupImagePlaceholder =
      this.$cartPopupImagePlaceholder ||
      $(this.selectors.cartPopupImagePlaceholder);

    if (imageUrl === null) {
      this.$cartPopupImageWrapper.addClass(this.classes.hidden);
      return;
    }

    this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
    var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, "200x");
    var image = document.createElement("img");
    image.src = sizedImageUrl;
    image.alt = productTitle;
    image.dataset.cartPopupImage = "";

    image.onload = function () {
      this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
      this.$cartPopupImageWrapper.append(image);
    }.bind(this);
  }

  function _setCartPopupProductDetails(variantOptions, properties) {
    this.$cartPopupProductDetails =
      this.$cartPopupProductDetails ||
      $(this.selectors.cartPopupProductDetails);
    var variantPropertiesHTML = "";

    if (variantOptions[0] !== "Default Title") {
      variantPropertiesHTML =
        variantPropertiesHTML + _getVariantOptionList(variantOptions);
    }

    if (properties !== null && Object.keys(properties).length !== 0) {
      variantPropertiesHTML =
        variantPropertiesHTML + _getPropertyList(properties);
    }

    if (variantPropertiesHTML.length === 0) {
      this.$cartPopupProductDetails.html("");
      this.$cartPopupProductDetails.attr("hidden", "");
    } else {
      this.$cartPopupProductDetails.html(variantPropertiesHTML);
      this.$cartPopupProductDetails.removeAttr("hidden");
    }
  }

  function _getVariantOptionList(variantOptions) {
    var variantOptionListHTML = "";

    variantOptions.forEach(function (variantOption) {
      variantOptionListHTML =
        variantOptionListHTML +
        '<li class="product-details__item product-details__item--variant-option">' +
        variantOption +
        "</li>";
    });

    return variantOptionListHTML;
  }

  function _getPropertyList(properties) {
    var propertyListHTML = "";
    var propertiesArray = Object.entries(properties);

    propertiesArray.forEach(function (property) {
      // Line item properties prefixed with an underscore are not to be displayed
      if (property[0].charAt(0) === "_") return;

      // if the property value has a length of 0 (empty), don't display it
      if (property[1].length === 0) return;

      propertyListHTML =
        propertyListHTML +
        '<li class="product-details__item product-details__item--property">' +
        '<span class="product-details__property-label">' +
        property[0] +
        ": </span>" +
        property[1];
      ": " + "</li>";
    });

    return propertyListHTML;
  }

  function _setCartQuantity(quantity) {
    this.$cartPopupCartQuantity =
      this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
    var ariaLabel;

    if (quantity === 1) {
      ariaLabel = theme.strings.oneCartCount;
    } else if (quantity > 1) {
      ariaLabel = theme.strings.otherCartCount.replace("[count]", quantity);
    }

    this.$cartPopupCartQuantity.text(quantity).attr("aria-label", ariaLabel);
  }

  function _setNumberQuantity() {
    var buttonSlt = "#product_quickview [data-qtt]",
      buttonElm = $(buttonSlt);

    var input = $("#product_quickview [data-quantity-input]"),
      oldVal = 1,
      newVal = 1;
    if (checkNeedToConvertCurrency()) {
      Currency.convertAll(
        window.shop_currency,
        $("#currencies .active").attr("data-currency"),
        "span.money",
        "money_format"
      );
    }
    $(document).on("click", buttonSlt, function (e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(this);

      switch (true) {
        case self.hasClass("plus"): {
          newVal = oldVal + 1;
          break;
        }
        case self.hasClass("minus") && oldVal > 1: {
          newVal = oldVal - 1;
          break;
        }
      }
      oldVal = newVal;
      input.val(newVal).trigger("change");

      var $totalPrice = $("[data-total-price-qv]");
      var oldPrice = $("[data-total-price-qv]").attr("data-price-value");
      $totalPrice.html(
        theme.Currency.formatMoney(oldPrice * newVal, theme.moneyFormat)
      );

      if (checkNeedToConvertCurrency()) {
        Currency.convertAll(
          window.shop_currency,
          $("#currencies .active").attr("data-currency"),
          "span.money",
          "money_format"
        );
      }
    });
  }

  function _setCartCountBubble(quantity) {
    this.$cartCountBubble =
      this.$cartCountBubble || $(this.selectors.cartCountBubble);
    this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

    this.$cartCountBubble.removeClass(this.classes.hidden);
    this.$cartCount.text(quantity);
  }

  function _showCartPopup() {
    this.$cartPopupWrapper
      .prepareTransition()
      .removeClass(this.classes.cartPopupWrapperHidden);
    _handleButtonLoadingState(false);

    slate.a11y.trapFocus({
      $container: this.$cartPopupWrapper,
      $elementToFocus: this.$cartPopup,
      namespace: "cartPopupFocus",
    });
  }

  function _hideCartPopup(event) {
    var setFocus = event.detail === 0 ? true : false;
    this.$cartPopupWrapper
      .prepareTransition()
      .addClass(this.classes.cartPopupWrapperHidden);

    $(this.selectors.cartPopupImage).remove();
    this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

    slate.a11y.removeTrapFocus({
      $container: this.$cartPopupWrapper,
      namespace: "cartPopupFocus",
    });

    if (setFocus) this.$previouslyFocusedElement[0].focus();

    this.$cartPopupWrapper.off("keyup");
    this.$cartPopupClose.off("click");
    this.$cartPopupDismiss.off("click");
    $("body").off("click");
  }

  function _onBodyClick(event) {
    var $target = $(event.target);

    if (
      $target[0] !== this.$cartPopupWrapper[0] &&
      !$target.parents(this.selectors.cartPopup).length
    ) {
      _hideCartPopup(event);
    }
  }

  function _setActiveThumbnail(imageId) {
    // If there is no element passed, find it by the current product image
    if (typeof imageId === "undefined") {
      imageId = $(
        this.selectors.productImageWraps + ":not(.hide)",
        this.$container
      ).data("image-id");
    }

    var $thumbnailWrappers = $(
      this.selectors.productThumbListItem + ":not(.slick-cloned)",
      this.$container
    );

    var $activeThumbnail = $thumbnailWrappers.find(
      this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
    );

    $(this.selectors.productThumbImages)
      .removeClass(this.classes.activeClass)
      .removeAttr("aria-current");

    $activeThumbnail.addClass(this.classes.activeClass);
    $activeThumbnail.attr("aria-current", true);

    if (!$thumbnailWrappers.hasClass("slick-slide")) {
      return;
    }

    var slideIndex = $activeThumbnail.parent().data("slick-index");
    $(this.selectors.productThumbs).slick("slickGoTo", slideIndex);
  }

  function _next_prev_button() {
    if ($(".product-slider").hasClass("custom")) {
      return;
    }

    var $buttonPrevNext = $(this.selectors.productThumbs).find(".slick-arrow"),
      $productThumbImages = $(this.selectors.productThumbImages);

    $(document).on("click", $buttonPrevNext, function () {
      var $activeThumbnail = $(".product-single__thumbnails").find(
        ".slick-current"
      );

      $productThumbImages
        .removeClass("active-thumb")
        .removeAttr("aria-current");

      $activeThumbnail.children().addClass("active-thumb");
      $activeThumbnail.children().attr("aria-current", true);
    });
  }

  function _switchImage(imageId) {
    var $newImage = $(
      this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
      this.$container
    );
    var $otherImages = $(
      this.selectors.productImageWraps +
        ":not([data-image-id='" +
        imageId +
        "'])",
      this.$container
    );
    if ($(".product-slider").hasClass("custom")) {
      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    }
  }

  function _handleImageFocus(evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

    $(this.selectors.productFeaturedImage + ":visible").focus();
  }

  function _liveRegionText(variant) {
    // Dummy content for live region
    var liveRegionText =
      "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";

    // Update availability
    if (!variant) {
      liveRegionText = theme.strings.unavailable;
      return liveRegionText;
    }

    var availability = variant.available ? "" : theme.strings.soldOut + ",";

    liveRegionText = liveRegionText.replace("[Availability]", availability);

    // Update pricing information
    var regularLabel = "";
    var regularPrice = theme.Currency.formatMoney(
      variant.price,
      theme.moneyFormat
    );
    var saleLabel = "";
    var salePrice = "";
    var unitLabel = "";
    var unitPrice = "";

    if (variant.compare_at_price > variant.price) {
      regularLabel = theme.strings.regularPrice;
      regularPrice =
        theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.moneyFormat
        ) + ",";
      saleLabel = theme.strings.sale;
      salePrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
    }

    if (variant.unit_price) {
      unitLabel = theme.strings.unitPrice;
      unitPrice =
        theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
        " " +
        theme.strings.unitPriceSeparator +
        " " +
        _getBaseUnit(variant);
    }

    liveRegionText = liveRegionText
      .replace("[Regular]", regularLabel)
      .replace("[$$]", regularPrice)
      .replace("[Sale]", saleLabel)
      .replace("[$]", salePrice)
      .replace("[UnitPrice]", unitLabel)
      .replace("[$$$]", unitPrice)
      .trim();

    return liveRegionText;
  }

  function _updateLiveRegion(evt) {
    var variant = evt.variant;
    var liveRegion = $(".product_quickview").querySelector(
      this.selectors.productStatus
    );
    liveRegion.textContent = _liveRegionText(variant);
    liveRegion.setAttribute("aria-hidden", false);

    // hide content from accessibility tree after announcement
    setTimeout(function () {
      liveRegion.setAttribute("aria-hidden", true);
    }, 1000);
  }

  function _updateAddToCart(evt) {
    var variant = evt.variant;
    if (variant) {
      if (variant.available) {
        this.$addToCart
          .removeAttr("aria-disabled")
          .attr("aria-label", theme.strings.addToCart);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.addToCart
        );
        this.$shopifyPaymentButton.show();
      } else {
        // The variant doesn't exist, disable submit button and change the text.
        // This may be an error or notice that a specific variant is not available.
        this.$addToCart
          .attr("aria-disabled", true)
          .attr("aria-label", theme.strings.soldOut);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.soldOut
        );
        this.$shopifyPaymentButton.hide();
      }
    } else {
      this.$addToCart
        .attr("aria-disabled", true)
        .attr("aria-label", theme.strings.unavailable);
      $(this.selectors.addToCartText, this.$container).text(
        theme.strings.unavailable
      );
      this.$shopifyPaymentButton.hide();
    }
  }

  function _updateAvailability(evt) {
    // remove error message if one is showing
    _hideErrorMessage();

    // update form submit
    _updateAddToCart(evt);

    // update live region
    // _updateLiveRegion(evt);

    _updatePrice(evt);
  }

  function _updateImages(evt) {
    var variant = evt.variant;
    var imageId = variant.featured_media.id;

    _switchImage(imageId);
    _setActiveThumbnail(imageId);
  }

  function _updatePrice(evt) {
    var variant = evt.variant;

    var $priceContainer = $(this.selectors.priceContainer, this.$container);
    var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
    var $salePrice = $(this.selectors.salePrice, $priceContainer);
    var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
    var $labelSale = $("#product_quickview").find(this.selectors.labelSale);
    var $unitPriceBaseUnit = $(
      this.selectors.unitPriceBaseUnit,
      $priceContainer
    );

    // Reset product price state
    $priceContainer
      .removeClass(this.classes.productUnavailable)
      .removeClass(this.classes.productOnSale)
      .removeClass(this.classes.productUnitAvailable)
      .removeAttr("aria-hidden");

    // Unavailable
    if (!variant) {
      $priceContainer
        .addClass(this.classes.productUnavailable)
        .attr("aria-hidden", true);
      return;
    }

    var quantity = parseInt(
      $(".product_quickview [data-quantity-input]").val()
    );
    if (variant.compare_at_price > variant.price) {
      $regularPrice.html(
        theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)
      );
      $salePrice.html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );
      $("[data-total-price-qv]").attr("data-price-value", variant.price);
      $("[data-total-price-qv]").html(
        theme.Currency.formatMoney(variant.price * quantity, theme.moneyFormat)
      );
      $priceContainer.addClass(this.classes.productOnSale);
      $labelSale.show();
      $labelSale.html(
        "-" +
          Math.floor(
            ((variant.compare_at_price - variant.price) /
              variant.compare_at_price) *
              100
          ) +
          "%"
      );
    } else {
      // Regular price
      $regularPrice.html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );
      $salePrice.html("");
      $("[data-total-price-qv]").attr("data-price-value", variant.price);
      $("[data-total-price-qv]").html(
        theme.Currency.formatMoney(variant.price * quantity, theme.moneyFormat)
      );
      $labelSale.hide();
    }

    if (checkNeedToConvertCurrency()) {
      Currency.convertAll(
        window.shop_currency,
        $("#currencies .active").attr("data-currency"),
        "span.money",
        "money_format"
      );
    }

    // Unit price
    // if (variant.unit_price) {
    //     $unitPrice.html(
    //         theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
    //     );
    //     $unitPriceBaseUnit.html(this._getBaseUnit(variant));
    //     $priceContainer.addClass(this.classes.productUnitAvailable);
    // }
  }

  function _getBaseUnit(variant) {
    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  function _updateSKU(evt) {
    var variant = evt.variant;

    // Update the sku
    $(this.selectors.SKU).html(variant.sku);
  }

  function _enableZoom(el) {
    var zoomUrl = $(el).data("zoom");
    $(el).zoom({
      url: zoomUrl,
    });
  }

  function _destroyZoom(el) {
    $(el).trigger("zoom.destroy");
  }

  function _setShowTime(t) {
    if (t < 10) {
      return "<span class='num'>0</span><span class='num'>" + t + "</span>";
    }
    return (
      "<span class='num'>" +
      parseInt(t / 10) +
      "</span><span class='num'>" +
      (t % 10) +
      "</span>"
    );
  }

  function _setShowDateFormat(t) {
    if (t < 10) {
      return "<span class='num'>0</span><span class='num'>" + t + "</span>";
    }
    if (t > 100) {
      return (
        _setShowDateFormat(parseInt(t / 10)) +
        "<span class='num'>" +
        (t % 10) +
        "</span>"
      );
    }
    return (
      "<span class='num'>" +
      parseInt(t / 10) +
      "</span><span class='num'>" +
      (t % 10) +
      "</span>"
    );
  }

  function _addonSocial() {
    if (!$(".product_quickview .share_toolbox").length) return;

    $.getScript(
      "https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-595b0ea2fb9c5869"
    ).done(function () {
      if (typeof addthis !== "undefined") {
        addthis.init();
        addthis.layers.refresh();
      }
    });
  }

  return {
    init: function () {
      _initQuickView();
    },
  };
})();

theme.product_card = (function () {
  function _initAddToCart_quick() {
    this.selectors = {
      cartCount: "[data-cart-count]",
      cartCountBubble: "[data-cart-count-bubble]",
      cartPopup: "[data-cart-popup]",
      cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
      cartPopupClose: "[data-cart-popup-close]",
      cartPopupDismiss: "[data-cart-popup-dismiss]",
      cartPopupImage: "[data-cart-popup-image]",
      cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
      cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
      cartPopupProductDetails: "[data-cart-popup-product-details]",
      cartPopupQuantity: "[data-cart-popup-quantity]",
      cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
      cartPopupTitle: "[data-cart-popup-title]",
      cartPopupWrapper: "[data-cart-popup-wrapper]",
    };

    this.classes = {
      cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
      hidden: "hide",
    };

    var addToCart_quick = "[data-btn-addToCart]";
    $(document).on("click", addToCart_quick, function (event) {
      event.preventDefault();
      event.stopPropagation();
      var self = $(this),
        thisForm = $(self.data("form-id")),
        $data = thisForm.serialize();

      var params = {
        url: window.router + "/cart/add.js",
        data: $data,
        dataType: "json",
      };

      $.post(params).done(
        function (item) {
          _setupCartPopup(item);
        }.bind(this)
      );
    });
  }

  function _setupCartPopup(item) {
    document.documentElement.dispatchEvent(new Event('supercart:open'));
    
    this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
    this.$cartPopupWrapper =
      this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
    this.$cartPopupTitle =
      this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
    this.$cartPopupQuantity =
      this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
    this.$cartPopupQuantityLabel =
      this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel);
    this.$cartPopupClose =
      this.$cartPopupClose || $(this.selectors.cartPopupClose);
    this.$cartPopupDismiss =
      this.cartPopupDismiss || $(this.selectors.cartPopupDismiss);

    _setupCartPopupEventListeners();

    _updateCartPopupContent(item);
  }

  function _updateCartPopupContent(item) {
    var quantity = 1;

    this.$cartPopupTitle.text(item.product_title);
    this.$cartPopupQuantity.text(quantity);
    this.$cartPopupQuantityLabel.text(
      theme.strings.quantityLabel.replace("[count]", quantity)
    );

    _setCartPopupImage(item.image, item.title);
    _setCartPopupProductDetails(item.properties);

    $.getJSON("/cart.js").then(
      function (cart) {
        _setCartQuantity(cart.item_count);
        _setCartCountBubble(cart.item_count);
        _showCartPopup();
        $(".navUser-action-total-price .total-price").html(
          theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
        );
      }.bind(this)
    );

    var close = this.$cartPopupClose;
    setTimeout(function () {
      close.trigger("click");
    }, 3000);
  }

  function _setupCartPopupEventListeners() {
    this.$cartPopupWrapper.on(
      "keyup",
      function (event) {
        if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
          this._hideCartPopup(event);
        }
      }.bind(this)
    );

    this.$cartPopupClose.on("click", _hideCartPopup.bind(this));
    this.$cartPopupDismiss.on("click", _hideCartPopup.bind(this));
    $("body").on("click", _onBodyClick.bind(this));
  }

  function _setCartPopupImage(imageUrl, productTitle) {
    this.$cartPopupImageWrapper =
      this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

    this.$cartPopupImagePlaceholder =
      this.$cartPopupImagePlaceholder ||
      $(this.selectors.cartPopupImagePlaceholder);

    if (imageUrl === null) {
      this.$cartPopupImageWrapper.addClass(this.classes.hidden);
      return;
    }

    this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
    var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, "200x");
    var image = document.createElement("img");
    image.src = sizedImageUrl;
    image.alt = productTitle;
    image.dataset.cartPopupImage = "";

    image.onload = function () {
      this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
      this.$cartPopupImageWrapper.append(image);
    }.bind(this);
  }

  function _setCartPopupProductDetails(properties) {
    this.$cartPopupProductDetails =
      this.$cartPopupProductDetails ||
      $(this.selectors.cartPopupProductDetails);
    var variantPropertiesHTML = "";

    if (properties !== null && Object.keys(properties).length !== 0) {
      variantPropertiesHTML =
        variantPropertiesHTML + _getPropertyList(properties);
    }

    if (variantPropertiesHTML.length === 0) {
      this.$cartPopupProductDetails.html("");
      this.$cartPopupProductDetails.attr("hidden", "");
    } else {
      this.$cartPopupProductDetails.html(variantPropertiesHTML);
      this.$cartPopupProductDetails.removeAttr("hidden");
    }
  }

  function _getPropertyList(properties) {
    var propertyListHTML = "";
    var propertiesArray = Object.entries(properties);

    propertiesArray.forEach(function (property) {
      // Line item properties prefixed with an underscore are not to be displayed
      if (property[0].charAt(0) === "_") return;

      // if the property value has a length of 0 (empty), don't display it
      if (property[1].length === 0) return;

      propertyListHTML =
        propertyListHTML +
        '<li class="product-details__item product-details__item--property">' +
        '<span class="product-details__property-label">' +
        property[0] +
        ": </span>" +
        property[1];
      ": " + "</li>";
    });

    return propertyListHTML;
  }

  function _setCartQuantity(quantity) {
    this.$cartPopupCartQuantity =
      this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
    var ariaLabel;

    if (quantity === 1) {
      ariaLabel = theme.strings.oneCartCount;
    } else if (quantity > 1) {
      ariaLabel = theme.strings.otherCartCount.replace("[count]", quantity);
    }

    this.$cartPopupCartQuantity.text(quantity).attr("aria-label", ariaLabel);
  }

  function _setCartCountBubble(quantity) {
    this.$cartCountBubble =
      this.$cartCountBubble || $(this.selectors.cartCountBubble);
    this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

    this.$cartCountBubble.removeClass(this.classes.hidden);
    this.$cartCount.text(quantity);
  }

  function _showCartPopup() {
    this.$cartPopupWrapper
      .prepareTransition()
      .removeClass(this.classes.cartPopupWrapperHidden);

    slate.a11y.trapFocus({
      $container: this.$cartPopupWrapper,
      $elementToFocus: this.$cartPopup,
      namespace: "cartPopupFocus",
    });
  }

  function _hideCartPopup(event) {
    var setFocus = event.detail === 0 ? true : false;
    this.$cartPopupWrapper
      .prepareTransition()
      .addClass(this.classes.cartPopupWrapperHidden);

    $(this.selectors.cartPopupImage).remove();
    this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

    slate.a11y.removeTrapFocus({
      $container: this.$cartPopupWrapper,
      namespace: "cartPopupFocus",
    });

    if (setFocus) this.$previouslyFocusedElement[0].focus();

    this.$cartPopupWrapper.off("keyup");
    this.$cartPopupClose.off("click");
    this.$cartPopupDismiss.off("click");
    $("body").off("click");
  }

  function _onBodyClick(event) {
    var $target = $(event.target);

    if (
      $target[0] !== this.$cartPopupWrapper[0] &&
      !$target.parents(this.selectors.cartPopup).length
    ) {
      _hideCartPopup(event);
    }
  }

  return {
    init: function () {
      _initAddToCart_quick();
    },
  };
})();

theme.product_sticky_atc = (function () {
  function showHideVariantsOptions() {
    var blockSticky = $("[data-sticky-add-to-cart]"),
      sltVariantActive = blockSticky.find(".pr-active"),
      variantElm = blockSticky.find(".pr-swatch");

    sltVariantActive
      .off("click.showListVariant")
      .on("click.showListVariant", function (e) {
        e.preventDefault();

        blockSticky.toggleClass("open-sticky");
      });

    $(document)
      .off("click.hideVariantsOption")
      .on("click.hideVariantsOption", function (e) {
        if (
          !sltVariantActive.is(e.target) &&
          sltVariantActive.has(e.target).length === 0
        ) {
          blockSticky.removeClass("open-sticky");
        }
      });
  }

  function handleActiveVariant() {
    var blockSticky = $("[data-sticky-add-to-cart]"),
      sltVariantActive = blockSticky.find(".pr-active"),
      variantElm = blockSticky.find(".pr-swatch");

    variantElm.on("click", function (e) {
      var self = $(this),
        text = self.text(),
        value = self.data("value"),
        title = self.data("title"),
        newImage = self.data("img");

      variantElm.removeClass("active");
      self.addClass("active");
      blockSticky.toggleClass("open-sticky");

      blockSticky.find(".action-wrapper input[type=hidden]").val(value);
      sltVariantActive.attr("data-value", value).text(text);

      if (self.hasClass("sold-out")) {
        blockSticky
          .find(".btn-sticky-add-to-cart")
          .val(theme.strings.soldOut)
          .addClass("disabled")
          .attr("disabled", "disabled");
      } else {
        blockSticky
          .find(".btn-sticky-add-to-cart")
          .removeClass("disabled")
          .removeAttr("disabled")
          .val(theme.strings.addToCart);
      }

      $(".sticky-add-to-cart .product-on-cart .product-image img").attr({
        src: newImage,
      });

      return false;
    });
  }

  function stickyAddToCart() {
    $(document).on("click", "[data-sticky-btn-addToCart]", function (e) {
      e.preventDefault();

      if ($("[data-product-form] [data-add-to-cart]").length) {
        $("[data-product-form] [data-add-to-cart]").click();
      }
    });
  }

  function activeVariantSelected() {
    var blockSticky = $("[data-sticky-add-to-cart]"),
      sltVariantActive = blockSticky.find(".pr-active"),
      variantElm = blockSticky.find(".pr-swatch");

    var optionSelected = $(".product-form__variants option:selected"),
      value = optionSelected.val(),
      stickyActive = blockSticky.find('.pr-swatch[data-value="' + value + '"]'),
      stickyText = stickyActive.html();

    sltVariantActive.html(stickyText);
    stickyActive.addClass("active");

    var str = stickyActive.data("img");

    $(".sticky-add-to-cart .product-on-cart .product-image img").attr({
      src: str,
    });

    $(".selector-wrapper").change(function () {
      var n = $(".product-form__variants").val(),
        image;

      $(".sticky_form .pr-selectors li").each(function (e) {
        var t = $(this).find("a").data("value");

        if (t == n) {
          $(this).find("a").addClass("active");
          image = $(this).find("a").data("img");
        } else {
          $(this).find("a").removeClass("active");
        }
      });

      if (image != null) {
        $(".sticky-add-to-cart .product-on-cart .product-image img").attr({
          src: image,
        });
      }

      if (variantElm.hasClass("active")) {
        var h = $(".sticky_form .pr-swatch.active").html();

        $(".sticky_form .action input[type=hidden]").val(n);
        sltVariantActive.html(h);
        sltVariantActive.attr("data-value", n);
      }
    });
  }

  function ShowSickyAtc() {
    if (!$("[data-sticky-add-to-cart]").length) {
      return;
    }

    var offSetTop =
      $("[data-add-to-cart]").offset().top + $("[data-add-to-cart]").height();

    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();

      if (scrollTop > offSetTop) {
        $("body").addClass("show_sticky");
      } else {
        $("body").removeClass("show_sticky");
      }
    });
  }

  return {
    init: function () {
      activeVariantSelected();
      showHideVariantsOptions();
      handleActiveVariant();
      stickyAddToCart();
      ShowSickyAtc();
    },
  };
})();

theme.products_frequently_by_together = (function () {
  var btnAddToCartSlt = "[data-bundle-addToCart]",
    bundleImagesSlide = $("[data-bundle-images-slider]"),
    btnToggleOptionsSlt = ".fbt-toogle-options",
    bundlePrice = $(".products-grouped-action .bundle-price"),
    carousel = $(".products-grouped-info[data-slick]"),
    bundleCheckbox = ".fbt-checkbox label",
    bundleCheckbox2 = ".fbt-checkbox input",
    $bundleContainer = $(".frequently-bought-together-block"),
    cartCount = $("[data-cart-count]"),
    cartCountBubble = $("[data-cart-count-bubble]"),
    cartPopup = $("[data-cart-popup-frequently]"),
    cartPopupCartQuantity = $("[data-cart-popup-cart-quantity]"),
    cartPopupClose = $("[data-cart-popup-close-frequently]"),
    cartPopupDismiss = $("[data-cart-popup-dismiss-frequently]"),
    cartPopupImage = $("[data-cart-popup-image]"),
    cartPopupImageWrapper = $("[data-cart-popup-image-wrapper]"),
    cartPopupImagePlaceholder = $("[data-cart-popup-image-placeholder]"),
    cartPopupProductDetails = $("[data-cart-popup-product-details]"),
    cartPopupQuantity = $("[data-cart-popup-quantity]"),
    cartPopupQuantityLabel = $("[data-cart-popup-quantity-label]"),
    cartPopupTitle = $("[data-cart-popup-title]"),
    cartPopupWrapper = $("[data-cart-popup-frequently-wrapper]");

  var $addToCart = $("[data-bundle-addtocart]", $bundleContainer);
  var $addToCartText = $("[data-add-to-cart-text]", $bundleContainer);
  var classes = {
    cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
    hidden: "hide",
    inputError: "input--error",
    productOnSale: "price--on-sale",
    productUnitAvailable: "price--unit-available",
    productUnavailable: "price--unavailable",
    productFormErrorMessageWrapperHidden:
      "product-form__error-message-wrapper--hidden",
    activeClass: "active-thumb",
  };
  var $errorMessageWrapper = $(
    "[data-error-message-wrapper]",
    $bundleContainer
  );
  var $loader = $("[data-loader]", $addToCart);
  var $loaderStatus = $("[data-loader-status]", $bundleContainer);

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function bundleSlider() {
    if (!carousel.length) {
      return;
    }
    if (!carousel.hasClass("slick-slider")) {
      carousel.slick();
    }
  }

  function toggleVariantOptions() {
    $(document).on("click", btnToggleOptionsSlt, function (e) {
      e.preventDefault();
      $(this).parents(".product-content").next().slideToggle();
    });

    $(document).on("click", ".close-options", function (e) {
      e.preventDefault();
      $(this).parent().slideToggle();
    });
  }

  function replaceDiscountRate() {
    if (bundlePrice.length > 0) {
      var discountRate = bundlePrice.data("discount-rate") * 100;
      var discountText = $(".products-grouped-action .discount-text");
      if (discountText.length > 0) {
        discountText.each(function () {
          $(this).text($(this).text().replace("[discount]", discountRate));
        });
      }
    }
  }

  function handleCheckedProduct() {
    $(document).on("click", bundleCheckbox, function (e) {
      e.preventDefault();

      var self = $(this),
        ipt = self.prev(),
        dataId = self.closest(".fbt-item").data("bundle-product-id");

      if (!ipt.prop("checked")) {
        ipt.prop("checked", true);
        $('[data-bundle-product-id="' + dataId + '"]').addClass("isChecked");
      } else {
        ipt.prop("checked", false);

        $('[data-bundle-product-id="' + dataId + '"]').removeClass("isChecked");
      }
      updateTotalPrice();
    });
  }

  function updateTotalPrice() {
    var bundleProItem = $bundleContainer.find(".fbt-item.isChecked");
    var bundlePrice = $(".products-grouped-action .bundle-price");
    var oldPrice = $(".products-grouped-action .old-price");
    var regularPrice = $(".products-grouped-action .price-item--regular.price");
    var discountRate = bundlePrice.data("discount-rate");
    var totalPrice = 0;
    var checkedProductLength = $(".fbt-item.isChecked").length;
    var maxProduct = $(".fbt-item").length;

    bundleProItem.each(function () {
      var price = parseFloat(
        $(this).find("[data-fbt-price-change]").attr("data-price")
      );

      if (price) {
        totalPrice += price;
      }
    });

    if ($(bundleCheckbox).length == bundleProItem.length) {
      window.bundleMatch = true;
      oldPrice
        .html(theme.Currency.formatMoney(totalPrice, theme.moneyFormat))
        .show();
      bundlePrice.html(
        theme.Currency.formatMoney(
          totalPrice * (1 - discountRate),
          theme.moneyFormat
        )
      );
    } else {
      window.bundleMatch = false;
      oldPrice.html("").hide();
      bundlePrice.html(
        theme.Currency.formatMoney(totalPrice, theme.moneyFormat)
      );
    }

    if (checkNeedToConvertCurrency()) {
      Currency.convertAll(
        window.shop_currency,
        $("#currencies .active").attr("data-currency"),
        "span.money",
        "money_format"
      );
    }
  }

  /*============================*/

  function _getCurrentOptionsFBT(productId) {
    var $bundle_product = $bundleContainer.find(
      '[data-bundle-product-id="' + productId + '"]'
    );

    var currentOptions = _.map(
      $(".single-option-selector-frequently", $bundle_product),
      function (element) {
        var $element = $(element);
        var type = $element.attr("type");
        var currentOption = {};

        if (type === "radio" || type === "checkbox") {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data("index");

          return currentOption;
        }
      }
    );

    // remove any unchecked input values if using radio buttons or checkboxes
    currentOptions = _.compact(currentOptions);

    return currentOptions;
  }

  function _getVariantFromOptionsFBT(productId) {
    var selectedValues = _getCurrentOptionsFBT(productId);

    var variants = window.productVariants[productId];

    if (!variants) {
      return;
    }

    var found = _.find(variants, function (variant) {
      return selectedValues.every(function (values) {
        return _.isEqual(variant[values.index], values.value);
      });
    });

    return found;
  }

  function _updateVariantFBT(productId, variant, option_change, option_value) {
    if (variant && productId) {
      var variants = window.productVariants[productId];
      var $bundle_product = $bundleContainer.find(
        '[data-bundle-product-id="' + productId + '"]'
      );

      _.map(
        $(".single-option-selector-frequently", $bundle_product),
        function (element) {
          var $element = $(element);
          var data_index = $element.data("index");

          if (data_index != option_change) {
            _.find(variants, function (variant) {
              if (
                _.isEqual(variant[option_change], option_value) &&
                _.isEqual(variant[data_index], $element.val())
              ) {
                if (variant.available) {
                  $element.removeAttr("disabled");
                  $element.parent().removeClass("soldout");
                } else {
                  $element.attr("disabled", "disabled");
                  $element.parent().addClass("soldout");
                  if ($element[0].checked) {
                    $("[name=" + $element.attr("name") + "]:first").attr(
                      "checked",
                      true
                    );
                  }
                }
                return false;
              }
            });
          }
        }
      );
    }
  }

  /**
   * Update hidden master select of variant change
   *
   * @param  {variant} variant - Currently selected variant
   */
  function _updateMasterSelectFBT(productId, variant) {
    $bundleContainer
      .find("#ProductSelect-" + productId)
      .val(variant.id)
      .trigger("change");
  }

  /**
   * Trigger event when variant image changes
   *
   * @param  {object} variant - Currently selected variant
   * @return {event}  variantImageChange
   */

  var currentVariantFBT = {};

  function _updateImagesFBT(productId, variant) {
    var variantImage = variant.featured_image || {};
    var currentVariantImage = currentVariantFBT.featured_image || {};

    if (
      !variant.featured_image ||
      variantImage.src === currentVariantImage.src
    ) {
      return;
    }
    $bundleContainer
      .find('[data-bundle-product-id="' + productId + '"] img')
      .attr("src", variantImage.src);
  }

  function _getBaseUnit(variant) {
    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  /**
   * Trigger event when variant price changes.
   *
   * @param  {object} variant - Currently selected variant
   * @return {event} variantPriceChange
   */
  function _updatePriceFBT(productId, variant) {
    if (
      variant.price === currentVariantFBT.price &&
      variant.compare_at_price === currentVariantFBT.compare_at_price
    ) {
      return;
    }

    var $priceContainer = $(
      ".product-price",
      $bundleContainer.find('[data-bundle-product-id="' + productId + '"]')
    );
    var $regularPrice = $(".price-item--regular", $priceContainer);
    var $salePrice = $(".price-item--sale", $priceContainer);
    var $unitPrice = $("[data-unit-price]", $priceContainer);
    var $unitPriceBaseUnit = $("[data-unit-price-base-unit]", $priceContainer);

    // Reset product price state
    $priceContainer
      .removeClass(classes.productUnavailable)
      .removeClass(classes.productOnSale)
      .removeClass(classes.productUnitAvailable)
      .removeAttr("aria-hidden");

    // Unavailable
    if (!variant) {
      $priceContainer
        .addClass(classes.productUnavailable)
        .attr("aria-hidden", true);
      return;
    }

    // On sale
    if (variant.compare_at_price > variant.price) {
      $regularPrice.html(
        theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)
      );
      $salePrice.html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );
      $priceContainer.addClass(classes.productOnSale);
    } else {
      // Regular price
      $regularPrice.html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );
      $salePrice.html("");
    }
    $("[data-fbt-price-change]", $priceContainer).attr(
      "data-price",
      variant.price
    );

    // Unit price
    if (variant.unit_price) {
      $unitPrice.html(
        theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
      );
      $unitPriceBaseUnit.html(_getBaseUnit(variant));
      $priceContainer.addClass(classes.productUnitAvailable);
    }
  }

  function _onSelectChangeFBT() {
    $(".single-option-selector-frequently", this.$bundleContainer).on(
      "change",
      function (e) {
        const productId = $(e.currentTarget)
          .closest("[data-bundle-product-id]")
          .data("bundle-product-id");
        const option_change = $(e.currentTarget).data("index");
        const option_value = $(e.currentTarget).val();
        if (productId) {
          var variants = window.productVariants[productId];
          for (var i = 0; i < variants.length; i++) {
            if (
              variants[i].id ==
              $bundleContainer.find("#ProductSelect-" + productId).val()
            ) {
              currentVariantFBT = variants[i];
            }
          }
          var variant = _getVariantFromOptionsFBT(productId);
          // remove error message if one is showing
          _hideErrorMessage();

          if (!variant) {
            return;
          }
          _updateMasterSelectFBT(productId, variant);
          _updateImagesFBT(productId, variant);
          _updatePriceFBT(productId, variant);
          _updateVariantFBT(productId, variant, option_change, option_value);
          updateTotalPrice();
        }
      }
    );
  }

  function _handleButtonLoadingState(isLoading) {
    if (isLoading) {
      $addToCart.attr("aria-disabled", true);
      $addToCartText.addClass(classes.hidden);
      $loader.removeClass(classes.hidden);

      $loaderStatus.attr("aria-hidden", false);
    } else {
      $addToCart.removeAttr("aria-disabled");
      $addToCartText.removeClass(classes.hidden);
      $loader.addClass(classes.hidden);

      $loaderStatus.attr("aria-hidden", true);
    }
  }

  function _showErrorMessage(errorMessage) {
    $(this.selectors.errorMessage, this.$container).html(errorMessage);

    $errorMessageWrapper
      .removeClass(this.classes.productFormErrorMessageWrapperHidden)
      .attr("aria-hidden", true)
      .removeAttr("aria-hidden");
  }

  function _hideErrorMessage() {
    $errorMessageWrapper.addClass(classes.productFormErrorMessageWrapperHidden);
  }

  function _initAddToCartFBT() {
    $(".frequently-bought-together_form", this.$bundleContainer).on(
      "submit",
      function (evt) {
        evt.preventDefault();
        // disable the addToCart and dynamic checkout button while
        // request/cart popup is loading and handle loading state
        _handleButtonLoadingState(true);

        var ProductFBT = $(evt.currentTarget).find(".fbt-item.isChecked");
        Shopify.queue = [];
        var i = 0;
        var number = ProductFBT.length;
        ProductFBT.each(function () {
          var variantId = $(this).find('[name="group_id"]').val();

          if (variantId !== "") {
            Shopify.queue.push({
              variantId: variantId,
              quantity: 1,
            });
          }
        });
        _addItemToCartFBT(number);
      }.bind(this)
    );
  }

  function _addItemToCartFBT(number) {
    if (Shopify.queue.length) {
      var data = Shopify.queue.shift();

      var params = {
        url: "/cart/add.js",
        data:
          "quantity=" +
          data.quantity +
          "&id=" +
          data.variantId +
          "&form_type=product",
        dataType: "json",
        //async: false,
      };

      $.post(params)
        .done(
          function (item) {
            _addItemToCartFBT();
            _hideErrorMessage();
            _setupCartPopup(item, number);
          }.bind(this)
        )
        .fail(
          function (response) {
            _showErrorMessage(response.responseJSON.description);
            _handleButtonLoadingState(false);
          }.bind(this)
        );
      if (Shopify.queue.length == 0) {
        try {
          var discount_code = "FBT-BUNDLE-" + meta.product.id;
          //console.log(discount_code);
          apply_discount(discount_code);
        } catch (e) {}
      }
    } else {
      _handleButtonLoadingState(false);
      return false;
    }
  }

  function apply_discount(discount_code) {
    if (window.bundleMatch) {
      $.ajax({
        url: "/discount/" + discount_code,
        success: function (response) {
          //console.log("Discount code added");
        },
      });
    }
  }

  function _setupCartPopup(item, number) {
    this.$cartPopup = this.$cartPopup || cartPopup;
    this.$cartPopupWrapper = this.$cartPopupWrapper || cartPopupWrapper;
    this.$cartPopupTitle = this.$cartPopupTitle || cartPopupTitle;
    this.$cartPopupQuantity = this.$cartPopupQuantity || cartPopupQuantity;
    this.$cartPopupQuantityLabel =
      this.$cartPopupQuantityLabel || cartPopupQuantityLabel;
    this.$cartPopupClose = this.$cartPopupClose || cartPopupClose;
    this.$cartPopupDismiss = this.cartPopupDismiss || cartPopupDismiss;

    _setupCartPopupEventListeners();
    _updateCartPopupContent(item, number);
  }

  function _setupCartPopupEventListeners() {
    this.$cartPopupWrapper.on(
      "keyup",
      function (event) {
        if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
          this._hideCartPopup(event);
        }
      }.bind(this)
    );

    this.$cartPopupClose.on("click", _hideCartPopup.bind(this));
    this.$cartPopupDismiss.on("click", _hideCartPopup.bind(this));
    $("body").on("click", _onBodyClick.bind(this));
  }

  function _updateCartPopupContent(item, number) {
    $("[data-cart-popup-frequently-wrapper] .cart-popup-content").prepend(
      _getHTMLProducts(theme, item)
    );

    $.getJSON("/cart.js").then(
      function (cart) {
        _setCartCountBubble(cart.item_count);
        setTimeout(function () {
          _showCartPopup();
        }, 500);
      }.bind(this)
    );

    var close = this.$cartPopupClose;
    // setTimeout(function() {
    //     close.trigger("click");
    // }, 3000);
  }

  function _getHTMLProducts(theme, product) {
    var productHTML = "";

    productHTML += '<div class="cart-popup-item">';
    productHTML +=
      '<div class="cart-popup-item__image-wrapper" data-cart-popup-image-wrapper>';
    productHTML += '<img src="' + product.image + '" alt="">';
    productHTML += "</div>";
    productHTML += '<div class="cart-popup-item__description">';
    productHTML += "<div>";
    productHTML +=
      '<div class="cart-popup-item__title" data-cart-popup-title>' +
      product.product_title +
      "</div>";
    productHTML +=
      '<ul class="product-details" data-cart-popup-product-details>' +
      _getVariantOptionList(product.variant_options) +
      "</ul>";
    productHTML +=
      '<div class="cart-popup-desciption">' +
      theme.strings.added_to_cart +
      "</div>";
    productHTML += "</div></div></div>";

    return productHTML;
  }

  function _getVariantOptionList(variantOptions) {
    var variantOptionListHTML = "";
    variantOptions.forEach(function (variantOption) {
      variantOptionListHTML =
        variantOptionListHTML +
        '<li class="product-details__item product-details__item--variant-option">' +
        variantOption +
        "</li>";
    });

    return variantOptionListHTML;
  }

  function _setCartCountBubble(quantity) {
    this.$cartCountBubble = this.$cartCountBubble || cartCountBubble;
    this.$cartCount = this.$cartCount || cartCount;

    this.$cartCountBubble.removeClass(this.classes.hidden);
    this.$cartCount.text(quantity);
  }

  function _showCartPopup() {
    this.$cartPopupWrapper
      .prepareTransition()
      .removeClass(this.classes.cartPopupWrapperHidden);
    _handleButtonLoadingState(false);

    slate.a11y.trapFocus({
      $container: this.$cartPopupWrapper,
      $elementToFocus: this.$cartPopup,
      namespace: "cartPopupFocus",
    });
  }

  function _hideCartPopup(event) {
    var setFocus = event.detail === 0 ? true : false;
    this.$cartPopupWrapper
      .prepareTransition()
      .addClass(this.classes.cartPopupWrapperHidden);

    setTimeout(function () {
      $("[data-cart-popup-frequently-wrapper] .cart-popup-content").html("");
    }, 500);

    slate.a11y.removeTrapFocus({
      $container: this.$cartPopupWrapper,
      namespace: "cartPopupFocus",
    });

    if (setFocus) this.$previouslyFocusedElement[0].focus();

    this.$cartPopupWrapper.off("keyup");
    this.$cartPopupClose.off("click");
    this.$cartPopupDismiss.off("click");
    $("body").off("click");
  }

  function _onBodyClick(event) {
    var $target = $(event.target);

    if (
      $target[0] !== this.$cartPopupWrapper[0] &&
      !$target.parents(this.selectors.cartPopup).length
    ) {
      _hideCartPopup(event);
    }
  }

  return {
    init: function () {
      bundleSlider();
      toggleVariantOptions();
      replaceDiscountRate();
      handleCheckedProduct();
      _onSelectChangeFBT();
      updateTotalPrice();
      _initAddToCartFBT();
    },
  };
})();

theme.ProductRecommendations = (function () {
  var selectors = {
    productCard: "[data-product-card]",
  };

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function customArrowButton() {
    $(".product-recommendations__inner .btn-arrow-prev").on(
      "click",
      function (e) {
        e.preventDefault();
        $(".product-recommendations__inner .slick-slider").slick("slickPrev");
      }
    );

    $(".product-recommendations__inner .btn-arrow-next").on(
      "click",
      function (e) {
        e.preventDefault();
        $(".product-recommendations__inner .slick-slider").slick("slickNext");
      }
    );
  }

  function ProductRecommendations(container) {
    this.$container = $(container);

    var productId = this.$container.data("productId");
    var recommendationsSectionUrl =
      window.router +
      "/recommendations/products?&section_id=product-recommendations&product_id=" +
      productId +
      "&limit=5";

    $.get(recommendationsSectionUrl).then(
      function (section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== "") {
          this.$container.html(recommendationsMarkup);
          this.sendTrekkieEvent();
        }

        theme.wishlist.init();
        if (checkNeedToConvertCurrency()) {
          Currency.convertAll(
            window.shop_currency,
            $("#currencies .active").attr("data-currency"),
            "span.money",
            "money_format"
          );
        }
        $(".product-recommendations__inner").each(function (index) {
          var $carousel = $(this).find("[data-slick]");
          if ($(window).width() < 1025) {
            if ($carousel.length) {
              if ($carousel.hasClass("slick-slider")) {
                $carousel.slick("unslick");
              }
            }
          } else {
            if ($carousel.length) {
              if (!$carousel.hasClass("slick-slider")) {
                $carousel.slick();
              }
            }
          }
          customArrowButton();
        });
      }.bind(this)
    );
  }

  ProductRecommendations.prototype = _.assignIn(
    {},
    ProductRecommendations.prototype,
    {
      sendTrekkieEvent: function () {
        if (
          !window.ShopifyAnalytics ||
          !window.ShopifyAnalytics.lib ||
          !window.ShopifyAnalytics.lib.track
        ) {
          return;
        }

        var didPageJumpOccur =
          this.$container[0].getBoundingClientRect().top <= window.innerHeight;
        var numberOfRecommendationsDisplayed = this.$container.find(
          selectors.productCard
        ).length;

        window.ShopifyAnalytics.lib.track("Product Recommendations Displayed", {
          theme: "debut",
          didPageJumpOccur: didPageJumpOccur,
          numberOfRecommendationsDisplayed: numberOfRecommendationsDisplayed,
        });
      },
    }
  );

  return ProductRecommendations;
})();

theme.VideoSection = (function () {
  function VideoSection(container) {
    var $container = (this.$container = $(container));

    $(".video", $container).each(function () {
      var $el = $(this);
      theme.Video.init($el);
      theme.Video.editorLoadVideo($el.attr("id"));
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onUnload: function () {
    theme.Video.removeEvents();
  },
});

theme.SlideshowSection = (function () {
  // class YoutubeSlick {
  //     constructor(slick) {
  //         console.log(this);
  //         this.$slick = $(slick);
  //         this.$videos = this.$slick.find('[data-youtube]');
  //         this.onSlickInit = this.onSlickInit.bind(this);
  //         this.onSlickBeforeChange = this.onSlickBeforeChange.bind(this);
  //         this.onSlickAfterChange = this.onSlickAfterChange.bind(this);
  //         this.onPlayerReady = this.onPlayerReady.bind(this);
  //         this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
  //         this.bindEvents();
  //     }

  //     bindEvents() {
  //         if (this.$slick.hasClass('slick-initialized')) {
  //             this.onSlickInit();
  //         }

  //         this.$slick.on('init', this.onSlickInit);
  //         this.$slick.on('beforeChange', this.onSlickBeforeChange);
  //         this.$slick.on('afterChange', this.onSlickAfterChange);
  //     }

  //     onPlayerReady(event) {
  //         // store player object for use later
  //         $(event.target.getIframe()).closest('.slick-slide').data('youtube-player', event.target);

  //         // On desktop: Play video if first slide is video
  //         if ($(window).width() > 767) {
  //             setTimeout(() => {
  //                 if ($(event.target.getIframe()).closest('.slick-slide').hasClass('slick-active')) {
  //                     this.$slick.slick('slickPause');
  //                     event.target.playVideo();
  //                 }
  //             }, 300);
  //         }
  //     }

  //     onPlayerStateChange(event) {
  //         // Stop slick autoplay when video start playing

  //         if (event.data === YT.PlayerState.PLAYING) {
  //             this.$slick.addClass('slick-video-playing');
  //             this.$slick.slick('slickPause');
  //         }

  //         if (event.data === YT.PlayerState.PAUSED) {
  //             this.$slick.removeClass('slick-video-playing');
  //         }

  //         // go to next slide and enable autoplay back when video ended
  //         if (event.data === YT.PlayerState.ENDED) {
  //             this.$slick.removeClass('slick-video-playing');
  //             this.$slick.slick('slickPlay');
  //             this.$slick.slick('slickNext');
  //         }
  //     }

  //     onSlickInit() {
  //         this.$videos.each((j, vid) => {
  //             const $vid = $(vid);
  //             const id = "youtube_player_"+_.uniqueId();

  //             $vid.attr('id', id);

  //             // init player
  //             const player = new YT.Player(id, { // eslint-disable-line
  //                 // host: 'http://www.youtube.com',
  //                 videoId: $vid.data('youtube'),
  //                 wmode: 'transparent',
  //                 height: '100%',
  //                 width: '100%',
  //                 playerVars: {
  //                     controls: 0,
  //                     disablekb: 1,
  //                     enablejsapi: 1,
  //                     fs: 0,
  //                     rel: 0,
  //                     showinfo: 0,
  //                     iv_load_policy: 3,
  //                     modestbranding: 1,
  //                     autohide: 1,
  //                     wmode: 'transparent',
  //                 },
  //                 events: {
  //                     onReady: this.onPlayerReady,
  //                     onStateChange: this.onPlayerStateChange,
  //                 },
  //             });
  //         });
  //     }

  //     onSlickBeforeChange() {
  //         const player = this.$slick.find('.slick-slide.slick-active').data('youtube-player');
  //         if (player) {
  //             player.stopVideo();
  //         }
  //     }

  //     onSlickAfterChange() {
  //         // Enable auto slide
  //         this.$slick.slick('slickPlay');

  //         // On desktop:
  //         // - Auto play video when open next slide
  //         // - Stop auto slide
  //         if ($(window).width() > 767) {
  //             const player = this.$slick.find('.slick-slide.slick-active').data('youtube-player');
  //             if (player) {
  //                 this.$slick.slick('slickPause');
  //                 player.playVideo();
  //             }
  //         }
  //     }
  // };

  function initCarousel($carousel) {
    $carousel.each(function () {
      // const $slick = $(slick);
      var self = $(this);
      if (self.find(".youtube").length > 0) {
        self.addClass("slick-slider--video");
        // new YoutubeSlick(slick);

        function postMessageToPlayer(player, command) {
          if (player == null || command == null) return;
          player.contentWindow.postMessage(JSON.stringify(command), "*");
        }

        // When the slide is changing
        function playPauseVideo(slick, control) {
          var currentSlide, player, video;

          currentSlide = slick.find(".slick-current .slide-video");
          player = currentSlide.find("iframe").get(0);

          if (currentSlide.hasClass("youtube")) {
            switch (control) {
              case "play":
                postMessageToPlayer(player, {
                  event: "command",
                  func: "mute",
                });
                postMessageToPlayer(player, {
                  event: "command",
                  func: "playVideo",
                });
                break;

              case "pause":
                postMessageToPlayer(player, {
                  event: "command",
                  func: "pauseVideo",
                });
                break;
            }
          } else if (currentSlide.hasClass("mp4")) {
            video = currentSlide.children("video").get(0);

            if (video != null) {
              if (control === "play") {
                video.play();
              } else {
                video.pause();
              }
            }
          }
        }

        self.on("init", function (slick) {
          slick = $(slick.currentTarget);

          setTimeout(function () {
            playPauseVideo(slick, "play");
          }, 1000);
        });

        self.on("beforeChange", function (event, slick) {
          slick = $(slick.$slider);
          playPauseVideo(slick, "pause");
        });

        self.on("afterChange", function (event, slick) {
          slick = $(slick.$slider);
          playPauseVideo(slick, "play");
        });
      }
    });
  }

  function youtubeCarouselFactory($carousel) {
    if ($carousel.find(".youtube").length > 0) {
      if (typeof YT == "undefined" || typeof YT.Player == "undefined") {
        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = initCarousel.bind(window, $carousel);
      } else {
        initCarousel($carousel);
      }
    }
  }

  function mp4CarouselFactory($carousel) {
    // if ($carousel.find('.slide-video.mp4').length > 0) {
    //     currentSlide = $carousel.find('.slick-current');
    //     video = currentSlide.children("video").get(0);
    //     if (video != null) {
    //         if (control === "play"){
    //             video.play();
    //         } else {
    //             video.pause();
    //         }
    //     }
    // }
    // $carousel.on('init', function() {
    // });
    // $carousel.on('beforeChange', function() {
    // });
    // $carousel.on('afterChange', function() {
    // });
  }

  function SlideshowSection() {
    var $carousel = $(".slideshow[data-slick]");
    $carousel.each(function () {
      if ($(this).length) {
        if (!$(this).hasClass("slick-slider")) {
          $(this).slick();
        }
        youtubeCarouselFactory($(this));
        mp4CarouselFactory($(this));
      }
    });

    $carousel.each(function () {
      var self = $(this);
      if (self.find(".slide-video").length) {
        self.find(".slide-video").css("height", self.height());
      }
    });
  }

  return SlideshowSection;
})();

theme.collection = (function () {
  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function bannerCarousel() {
    $("[data-section-type='collection-tabs'] .collection-tab-banner").each(
      function () {
        var $carousel = $(this).find("[data-slick]");
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    );
  }

  function custom_html() {
    if ($(".custom-html").length) {
      var $html = $(".custom-html"),
        showChar = 600,
        ellipsestext = "...";

      var moretext = theme.strings.showMore,
        lesstext = theme.strings.showLess,
        button =
          '<div class="button-group text-center"><a id="button-showmore-html" class="btn btn--secondary btn--big" href="#"><span class="text">' +
          theme.strings.showMore +
          '</span><svg class="icon"><use xlink:href="#icon-chevron-down" /></svg></a>';

      $html.each(function () {
        var content = $(this).html();
        if (content.length > showChar) {
          var c = content.substr(0, showChar);
          var h = content.substr(showChar, content.length - showChar);

          var html =
            c +
            '<span class="moreellipses">' +
            ellipsestext +
            '&nbsp;</span><span class="morecontent"><span>' +
            h +
            "</span></span>";
          html = html + button;
          $(this).html(html);
        }
      });

      $("#button-showmore-html").on("click", function (event) {
        event.preventDefault();
        if ($(this).hasClass("less")) {
          $(this).removeClass("less");
          $(this).find(".text").html(moretext);
          $html.removeClass("showmore");
        } else {
          $(this).addClass("less");
          $(this).find(".text").html(lesstext);
          $html.addClass("showmore");
        }
      });
    }
  }

  function layout_ListGrid() {
    var layout = $("#collection-page");
    $(document).on("click", ".view-as-btn a", function () {
      var column = $(this).attr("data-layout");
      document.getElementById("collection-page").className = "";
      layout.addClass(column);
    });
  }

  function showTime(t) {
    if (t < 10) {
      return "<span class='num'>0</span><span class='num'>" + t + "</span>";
    }
    return (
      "<span class='num'>" +
      parseInt(t / 10) +
      "</span><span class='num'>" +
      (t % 10) +
      "</span>"
    );
  }

  function showDateFormat(t) {
    if (t < 10) {
      return "<span class='num'>0</span><span class='num'>" + t + "</span>";
    }
    if (t > 100) {
      return (
        showDateFormat(parseInt(t / 10)) +
        "<span class='num'>" +
        (t % 10) +
        "</span>"
      );
    }
    return (
      "<span class='num'>" +
      parseInt(t / 10) +
      "</span><span class='num'>" +
      (t % 10) +
      "</span>"
    );
  }

  function initCountdown() {
    var countdownElm = $(".product-countdown[data-countdown]");
    countdownElm.each(function () {
      // Set the date we're counting down to
      if ($(this).hasClass("has-value")) {
        return;
      }

      var self = $(this),
        countDownDate = new Date(self.attr("data-countdown-value")).getTime();
      // Update the count down every 1 second
      var countdownfunction = setInterval(function () {
        // Get todays date and time
        var now = new Date().getTime();

        // Find the distance between now an the count down date
        var distance = countDownDate - now;

        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(countdownfunction);
          document.getElementsByClassName("product-countdown").innerHTML =
            "<span></span>";
        } else {
          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // Output the result in an element with id="countDowntimer"
          var strCountDown =
            "<span class='block-time'>" +
            showDateFormat(days) +
            "<span class='block-label'>days</span></span><span class='block-time'>" +
            showTime(hours) +
            "<span class='block-label'>hours</span></span><span class='block-time'>" +
            showTime(minutes) +
            "<span class='block-label'>mins</span></span><span class='block-time'>" +
            showTime(seconds) +
            "<span class='block-label'>secs</span></span>";
          self.html(strCountDown);
          self.addClass("has-value");
        }
      }, 1000);
    });
  }

  function initInfiniteScrolling() {
    var infiniteScrolling = $(".infinite-scrolling");
    var infiniteScrollingLinkSlt = ".infinite-scrolling a";
    if (infiniteScrolling.length) {
      $(document).on("click", infiniteScrollingLinkSlt, function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!$(this).hasClass("disabled")) {
          var url = $(this).attr("href");
          doAjaxInfiniteScrollingGetContent(url);
        }
      });
    }
  }

  function doAjaxInfiniteScrollingGetContent(url) {
    $.ajax({
      type: "get",
      url: url,

      beforeSend: function () {
        showLoading();
      },
      success: function (data) {
        ajaxInfiniteScrollingMapData(data);
      },
      complete: function () {
        hideLoading();
      },
    });
  }

  function ajaxInfiniteScrollingMapData(data) {
    var collectionTemplate = $(".page-collections"),
      currentProductColl = collectionTemplate.find(".halo-column-product"),
      newCollectionTemplate = $(data).find(".page-collections"),
      newProductColl = newCollectionTemplate.find(".halo-column-product"),
      newProductItem = newProductColl.children(".halo-item"),
      newPagination = newCollectionTemplate.find(".pagination-wrapper");

    var showMoreButton = $(".infinite-scrolling a");

    if (newProductColl.length) {
      currentProductColl.append(newProductItem);

      if ($(data).find(".infinite-scrolling").length > 0) {
        showMoreButton.attr(
          "href",
          newCollectionTemplate.find(".infinite-scrolling a").attr("href")
        );
      } else {
        showMoreButton.addClass("hide");
      }

      $(".pagination-wrapper").html(newPagination.html());

      theme.wishlist.init();

      if (checkNeedToConvertCurrency()) {
        Currency.convertAll(
          window.shop_currency,
          $("#currencies .active").attr("data-currency"),
          "span.money",
          "money_format"
        );
      }

      if (
        $(".shopify-product-reviews-badge").length &&
        $(".spr-badge").length
      ) {
        return (
          window.SPR.registerCallbacks(),
          window.SPR.initRatingHandler(),
          window.SPR.initDomEls(),
          window.SPR.loadProducts(),
          window.SPR.loadBadges()
        );
      }
    }
  }

  function showLoading() {
    $(".loading-modal").show();
  }

  function hideLoading() {
    $(".loading-modal").hide();
  }

  return {
    init: function () {
      custom_html();
      layout_ListGrid();
      initCountdown();
      bannerCarousel();
      initInfiniteScrolling();
    },
  };
})();

theme.homepage_section = (function () {
  function logoList() {
    if (!$("[data-section-type='logolist']").length) {
      return;
    }

    $("[data-section-type='logolist']").each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });
  }

  function testimonialList() {
    if (!$("[data-section-type='quotes']").length) {
      return;
    }

    $("[data-section-type='quotes']").each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($carousel.length) {
        if (!$carousel.hasClass("slick-slider")) {
          $carousel.slick();
        }
      }
    });
  }

  function blogList() {
    $("[data-section-type='featured-blog-section']").each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });

    $("[data-gallery-images]").each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });

    $("[data-gallery-images2]").each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($carousel.length) {
        if (!$carousel.hasClass("slick-slider")) {
          $carousel.slick();
        }
      }
    });

    $(
      "[data-section-type='featured-blog-section'] .halo-blog-layout-video"
    ).each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });
  }

  function customBlockCarousel() {
    if (!$("[data-section-type='customBlockCarousel']").length) {
      return;
    }

    $("[data-section-type='customBlockCarousel']").each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });
  }

  function popup_video() {
    if (!$("[data-section-type='hero-section']").length) {
      return;
    }

    $(".btn-popup-video").on("click", function () {
      var video_id = $(this).attr("data-id"),
        video_src = $(this).attr("data-src"),
        modal = $("#popup_video_" + video_id + " .modal-video");

      const $content =
        '<div class="modal-content">\
                        <a data-dismiss="modal" class="close close-modal" href="javascript:void(0)">&#215;</a>\
                        <div class="popup-video" data-video-gallery>\
                            <div id="popup-video-content">\
                                <div class="popup-video-main">\
                                    <iframe\
                                        id="player"\
                                        type="text/html"\
                                        width="100%"\
                                        frameborder="0"\
                                        webkitAllowFullScreen\
                                        mozallowfullscreen\
                                        allowFullScreen\
                                        src="' +
        video_src +
        '"\
                                        data-video-player>\
                                    </iframe>\
                                </div>\
                            </div>\
                        </div>\
                    </div>';

      modal.html($content);
    });

    $(document).on("click", function (event) {
      if ($(".halo_modal_video .modal-video .modal-content").length) {
        if (
          $(event.target).closest(".btn-popup-video").length === 0 &&
          $(event.target).closest(".halo_modal_video .close-modal").length === 0
        ) {
          $(".halo_modal_video .modal-video .modal-content").remove();
        }
      }
    });

    $(".hero-custom-block [data-slick]").each(function (index) {
      var $carousel = $(this);
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });
  }

  function popup_product() {
    $(".points_popup .point").on("click", function () {
      var $productWrapper = $(this).parent(),
        $position = $productWrapper.position(),
        $product = $(this).siblings();

      if ($(window).width() < 1024) {
        $product.css({ top: 100 - $position.top, left: 30 - $position.left });
      }

      $productWrapper.addClass("is-open");
    });

    $(".custom-product-card .close").on("click", function () {
      $(this).parents(".points_popup").removeClass("is-open");
    });

    $(document).on("click", function (event) {
      if (
        $(event.target).closest(".custom-product-card").length === 0 &&
        $(event.target).closest(".points_popup").length === 0
      ) {
        $(".points_popup").removeClass("is-open");
      }
    });
  }

  function collectionList() {
    if (!$("[data-section-type='collection-list']").length) {
      return;
    }

    $("[data-section-type='collection-list']").each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });
  }

  function customArrowButton(collection) {
    $(".btn-arrow-prev").on("click", function (e) {
      e.preventDefault();
      var wrapper = $(this).parents("[data-carousel]");
      wrapper.find("[data-slick]").slick("slickPrev");
    });

    $(".btn-arrow-next").on("click", function (e) {
      e.preventDefault();
      var wrapper = $(this).parents("[data-carousel]");
      wrapper.find("[data-slick]").slick("slickNext");
    });
  }

  function collection_carousel() {
    $("[data-section-type='collection'] [data-slick]").each(function (index) {
      var $carousel = $(this);
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });
  }

  function backToTop() {
    const backToTopBtn = document.querySelector("#back-to-top");

    if (!backToTopBtn) {
      return;
    }

    const offset = window.innerHeight / 2;

    window.addEventListener("scroll", () => {
      if (window.pageYOffset > offset) {
        backToTopBtn.classList.add("is-visible");
      } else {
        backToTopBtn.classList.remove("is-visible");
      }
    });

    backToTopBtn.addEventListener("click", (event) => {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  function closeEmailModalWindow(newsletterWrapper, expire) {
    newsletterWrapper.hide(700);
    var inputChecked = newsletterWrapper
      .find('input[name="dismiss"]')
      .prop("checked");
    if (inputChecked || !newsletterWrapper.find('input[name="dismiss"]').length)
      $.cookie("emailSubcribeModal", "closed", {
        expires: expire,
        path: "/",
      });
  }

  function newsLetterPopup() {
    if (!$("#halo_newsletter").length) {
      return;
    }

    var newsletterWrapper = $("#halo_newsletter"),
      overlay = newsletterWrapper.find(".popup-overlay"),
      closeWindow = newsletterWrapper.find(".close"),
      delay = $(".newsletterPopup").data("delay"),
      expire = $(".newsletterPopup").data("expire"),
      modalContent = newsletterWrapper.find(".newsletterPopup");

    if ($.cookie("emailSubcribeModal") != "closed") {
      setTimeout(function () {
        newsletterWrapper.show(700);
      }, delay);
    }

    closeWindow.on("click", function (e) {
      e.preventDefault();
      closeEmailModalWindow(newsletterWrapper, expire);
    });

    overlay.on("click", function (e) {
      e.preventDefault();
      closeEmailModalWindow(newsletterWrapper, expire);
    });

    $("#mc_embed_signup form").submit(function () {
      if ($("#mc_embed_signup .email").val() != "") {
        closeEmailModalWindow(newsletterWrapper, expire);
      }
    });
  }

  function product_fancybox() {
    $("[data-fancybox]").fancybox({
      mobile: {
        clickContent: "close",
        clickSlide: "close",
      },
      buttons: [
        "zoom",
        //"share",
        "slideShow",
        //"fullScreen",
        //"download",
        // "thumbs",
        "close",
      ],
    });
  }

  function Category_filter() {
    if (
      $(".themevale_MultiCategory_wrapper_2").length &&
      !$(".themevale_MultiCategory_wrapper").length
    ) {
      if ($(window).width() < 1025) {
        if (
          $(".slideshow-special .item-right .themevale_MultiCategory_wrapper_2")
            .length
        ) {
          $(
            ".slideshow-special .item-right .themevale_MultiCategory_wrapper_2"
          ).appendTo(
            ".slideshow-special .item-left .home-category-filter-sections"
          );
        }
      } else {
        if (
          !$(
            ".slideshow-special .item-right .themevale_MultiCategory_wrapper_2"
          ).length
        ) {
          $(
            ".slideshow-special .item-left .themevale_MultiCategory_wrapper_2"
          ).appendTo(
            ".slideshow-special .item-right .home-category-filter-sections"
          );
        }
      }
    }
  }

  function productCarousel($carousel) {
    if ($(window).width() < 1025) {
      if ($carousel.length) {
        if ($carousel.hasClass("slick-slider")) {
          $carousel.slick("unslick");
        }
      }
    } else {
      if ($carousel.length) {
        if (!$carousel.hasClass("slick-slider")) {
          $carousel.slick();
        }
      }
    }
  }

  function load_ajax_product(handle, loadingElm, curTabContent, dataRow) {
    $.ajax({
      type: "get",
      url: handle,
      cache: false,
      data: {
        view: "json",
        limit: "&" + dataRow,
      },
      beforeSend: function () {
        // loadingElm.html('<p>Loading ... please wait ...</p>');
      },
      success: function (data) {
        loadingElm.remove();
        if (handle == window.router + "/collections/?view=json") {
          loadingElm.html("<p>Please link to collections</p>").show();
        } else {
          curTabContent.html($(data).html());
          productCarousel(curTabContent);
          if (
            $(".shopify-product-reviews-badge").length &&
            $(".spr-badge").length
          ) {
            return (
              window.SPR.registerCallbacks(),
              window.SPR.initRatingHandler(),
              window.SPR.initDomEls(),
              window.SPR.loadProducts(),
              window.SPR.loadBadges()
            );
          }
        }
      },
      complete: function () {},
      error: function (xhr, text) {
        loadingElm
          .text("Sorry, there are no products in this collection")
          .show();
      },
    });
  }

  function active_collectionTab() {
    setTimeout(function () {
      $("[data-section-type='collection-tabs']").each(function (index) {
        var self = $(this),
          listTabs = self.find(".nav-tabs"),
          tabLink = listTabs.find(".nav-link"),
          tabContent = self.find(".tab-pane"),
          linkActive = self.find(".nav-tabs .nav-link.active"),
          dataRow = self.find(".nav-tabs").data("row"),
          activeTab = self.find(".tab-content .tab-pane.active");

        load_ajax_product(
          linkActive.data("href"),
          activeTab.find(".halo-loading"),
          activeTab.find(".halo-row"),
          dataRow
        );

        tabLink.on("click", function (e) {
          e.preventDefault();

          if ($(this).hasClass("active")) {
            return;
          }

          tabLink.removeClass("active");
          tabContent.removeClass("active").removeClass("show");

          var curTab = $(this),
            curTabContent = $(curTab.attr("href"));

          curTab.addClass("active");
          curTabContent.addClass("active show");

          if (curTabContent.find(".halo-loading").length) {
            load_ajax_product(
              curTab.data("href"),
              curTabContent.find(".halo-loading"),
              curTabContent.find(".halo-row"),
              dataRow
            );
          } else {
            if ($(window).width() > 1024) {
              curTabContent.find(".collection-carousel").slick("setPosition");
            }
          }
        });
      });
    }, 4500);
  }

  function special_layout() {
    if (!$("[data-section-type='product-special-layout']").length) {
      return;
    }

    $("[data-section-type='product-special-layout'] [data-slick]").each(
      function (index) {
        var $carousel = $(this);
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    );
  }

  function slideShow_special() {
    if (!$('[data-section-type="slideshow-section"]').length) {
      return;
    }

    $(".slideshow-special .collection-carousel[data-slick]").each(function (
      index
    ) {
      var $carousel = $(this);
      if ($(window).width() < 1025) {
        if ($carousel.length) {
          if ($carousel.hasClass("slick-slider")) {
            $carousel.slick("unslick");
          }
        }
      } else {
        if ($carousel.length) {
          if (!$carousel.hasClass("slick-slider")) {
            $carousel.slick();
          }
        }
      }
    });

    if ($(".slideshow-special").length && $(".halo-header-02").length) {
      if ($(".site-nav-vertical-wrapper").hasClass("is-open-2")) {
        if ($(window).width() > 1024) {
          var width = $(".site-nav-vertical-wrapper").outerWidth();
          $(".slideshow-special .item-left .slideshow").addClass(
            "slideshow--custom"
          );
          $(".slideshow-special .item-left .slideshow").css(
            "padding-left",
            width
          );
        } else {
          $(".slideshow-special .item-left .slideshow").css("padding-left", 0);
        }
      }
    }
  }

  // function collectionTab_carousel() {
  //     if (!$("[data-section-type='collection-tabs']").length) {
  //         return
  //     }

  //     $("[data-section-type='collection-tabs']").each(function(index) {
  //         var $carousel = $(this).find('.tab-pane.active [data-slick]');
  //         if ($(window).width() < 1025) {
  //             if ($carousel.length) {
  //                 if ($carousel.hasClass('slick-slider')) {
  //                     $carousel.slick('unslick');
  //                 }
  //             }
  //         } else {
  //             if ($carousel.length) {
  //                 if (!$carousel.hasClass('slick-slider')) {
  //                     $carousel.slick();
  //                 }
  //             }
  //         }
  //     });
  // }

  return {
    init: function () {
      logoList();
      blogList();
      customBlockCarousel();
      collectionList();
      testimonialList();
      customArrowButton();
      collection_carousel();
      backToTop();
      newsLetterPopup();
      popup_video();
      popup_product();
      product_fancybox();
      Category_filter();
      active_collectionTab();
      special_layout();
      slideShow_special();
    },
  };
})();

theme.header = (function () {
  function header_sticky() {
    if ($(".header-sticky").length) {
      var header_position, header_height;
      if ($(window).width() > 1024) {
        header_height = $(".header-sticky").height();
        header_position = $(".page-container").offset();
        header_scroll1(header_position.top, header_height);
      } else {
        header_height = $(".halo-header-mobile").height();
        header_position = $(".page-container").offset();
        header_scroll2(header_position.top, header_height);
      }
    }
  }

  function header_hover() {
    $(".halo-header-PC .site-nav .menu-lv-1.dropdown")
      .mouseenter(function () {
        $("body").addClass("open_menu_pc");
      })
      .mouseleave(function () {
        $("body").removeClass("open_menu_pc");
      });
  }

  function header_scroll1(header_position, header_height) {
    $(window).on("scroll load", function (event) {
      var scroll = $(window).scrollTop();
      if (scroll > header_height) {
        $(".header-sticky").addClass("is-sticky");
        $(".announcement-bar").hide();
        $("body").css("padding-top", header_height);
        if ($(".halo-header-01").length) {
          if ($(".halo-header-01 .halo-header-PC #site-nav").length) {
            $(".halo-header-01 .halo-header-PC #site-nav").appendTo(
              ".halo_mobileNavigation_wrapper .site-nav-mobile-wrapper"
            );
            document.getElementById("site-nav").className = "site-nav-mobile";
          }
        }
      } else {
        $(".header-sticky").removeClass("is-sticky");
        $(".announcement-bar").show();
        $("body").css("padding-top", 0);
        if ($(".halo-header-01").length) {
          if ($(".halo_mobileNavigation_wrapper #site-nav").length) {
            $(".halo_mobileNavigation_wrapper #site-nav").appendTo(
              ".halo-header-01 .halo-header-PC .header-bottom .container"
            );
            document.getElementById("site-nav").className = "site-nav";
          }
        }
      }
    });

    window.onload = function () {
      if ($(window).scrollTop() > header_position) {
        $(".header-sticky").addClass("is-sticky");
      }
    };
  }

  function header_scroll2(header_position, header_height) {
    if ($(".halo-header-01").length) {
      if ($(".halo-header-01 .halo-header-PC #site-nav").length) {
        $(".halo-header-01 .halo-header-PC #site-nav").appendTo(
          ".halo_mobileNavigation_wrapper .site-nav-mobile-wrapper"
        );
        document.getElementById("site-nav").className = "site-nav-mobile";
      }
    }

    $(window).on("scroll load", function (event) {
      var scroll = $(window).scrollTop();
      if (scroll > header_height) {
        $(".header-sticky").addClass("is-sticky");
        $(".announcement-bar").hide();
        $("body").css("padding-top", header_height);
      } else {
        $(".header-sticky").removeClass("is-sticky");
        $(".announcement-bar").show();
        $("body").css("padding-top", 0);
      }
    });

    window.onload = function () {
      if ($(window).scrollTop() > header_position) {
        $(".header-sticky").addClass("is-sticky");
      }
    };
  }

  function login_form() {
    if ($("#login-dropdown").length) {
      if ($(window).width() > 1024) {
        if ($("#login-mobile #login-dropdown").length) {
          $("#login-mobile #login-dropdown").appendTo(
            ".item--account .navUser-action"
          );
        }
      } else {
        if ($(".item--account #login-dropdown").length) {
          $(".item--account #login-dropdown").appendTo(
            "#login-mobile .halo_mobileNavigation_wrapper"
          );
        }
      }
    }
  }

  function cart_form() {
    if ($("#cart-dropdown").length) {
      if ($(window).width() > 1024) {
        if ($("#cart-mobile #cart-dropdown").length) {
          $("#cart-mobile #cart-dropdown").appendTo(".item--cart");
        }
      } else {
        if ($(".item--cart #cart-dropdown").length) {
          $(".item--cart #cart-dropdown").appendTo(
            "#cart-mobile .halo_mobileNavigation_wrapper"
          );
        }
      }
    }
  }

  function announcement() {
    if (!$(".announcement-bar-wrapper").length) {
      return;
    }

    $(".announcement-bar-wrapper .announcement-bar-wrapper--close").on(
      "click",
      function (event) {
        $(".announcement-bar-wrapper").hide();
      }
    );
  }

  function initToggleMuiltiLangCurrency() {
    var dropdownGroup = $(".lang_currency-dropdown"),
      dropdownLabel = dropdownGroup.find(".dropdown-label");

    if (dropdownLabel.length && dropdownLabel.is(":visible")) {
      dropdownLabel.on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var selfNextDropdown = $(this).next();

        if (!selfNextDropdown.is(":visible")) {
          dropdownLabel.next(".dropdown-menu").hide();
          selfNextDropdown.slideDown(300);
        } else {
          selfNextDropdown.slideUp(300);
        }
      });

      hideMuiltiLangCurrency();
    } else {
      dropdownLabel.next(".dropdown-menu").css({
        display: "",
      });
    }
  }

  function hideMuiltiLangCurrency() {
    $(document).on("click", function (e) {
      var muiltiDropdown = $(".lang_currency-dropdown .dropdown-menu");

      if (
        !muiltiDropdown.is(e.target) &&
        !muiltiDropdown.has(e.target).length
      ) {
        muiltiDropdown.slideUp(300);
      }
    });
  }

  function addTextMuiltiOptionActive(SltId, dataSlt, label) {
    if (label.length && label.is(":visible")) {
      var item = dataSlt.html();
      SltId.prev(label).html(item);
    }
  }

  function carouselMegaMenu() {
    if (!$(".featuredProductCarousel").length) {
      return;
    }

    if (!$(".featuredProductCarousel").hasClass("slick-slider")) {
      $(".featuredProductCarousel").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: false,
        arrows: false,
      });
    }

    $(".site-nav > li").mouseover(function () {
      $(".featuredProductCarousel").get(0).slick.setPosition();
    });
    $("ul.site-nav-mobile > li > .nav-action").on("click", function () {
      $(".featuredProductCarousel").get(0).slick.setPosition();
    });
  }

  function currency_mobile() {
    if ($("#lang-switcher").length) {
      if ($(window).width() > 1024) {
        if (!$(".navUser-currency .lang_currency-dropdown").length) {
          $(".currency-groups .lang_currency-dropdown").appendTo(
            ".navUser-currency"
          );
        }
      } else {
        if ($(".navUser-currency .lang_currency-dropdown").length) {
          $(".navUser-currency .lang_currency-dropdown").appendTo(
            ".currency-groups"
          );
        }
      }
    }
  }

  function language_mobile() {
    if ($("#lang-switcher").length) {
      if ($(window).width() > 1024) {
        if (!$(".navUser-language .lang_currency-dropdown").length) {
          $(".lang-groups .lang_currency-dropdown").appendTo(
            ".navUser-language"
          );
        }
      } else {
        if ($(".navUser-language .lang_currency-dropdown").length) {
          $(".navUser-language .lang_currency-dropdown").appendTo(
            ".lang-groups"
          );
        }
      }
    }
  }

  function logo_mobile() {
    if ($(".logo-wrapper").length) {
      if ($(window).width() > 1024) {
        if ($(".halo-header-mobile .logo-wrapper").length) {
          $(".halo-header-mobile .logo-wrapper").appendTo(
            ".halo-header-PC .header-middle-logo"
          );
        }
      } else {
        if ($(".halo-header-PC .logo-wrapper").length) {
          $(".halo-header-PC .logo-wrapper").appendTo(
            ".halo-header-mobile .header-Mobile-item.text-center .items"
          );
        }
      }
    }
  }

  function search_mobile() {
    if ($(".search-form").length) {
      if ($(window).width() > 1024) {
        if ($(".item--searchMobile .search-form").length) {
          $(".item--searchMobile .search-form").appendTo(".item--quickSearch");
        }
      } else {
        if ($(".item--quickSearch .search-form").length) {
          $(".item--quickSearch .search-form").appendTo(".item--searchMobile");
        }
      }
    }
  }

  function vertical_menu() {
    if (!$(".site-nav-vertical-wrapper").length) {
      return;
    }

    $(".site-nav-vertical-wrapper").on("click", function () {
      $(this).toggleClass("is-open");
    });
  }

  return {
    init: function () {
      logo_mobile();
      announcement();
      cart_form();
      login_form();
      header_hover();
      vertical_menu();
      header_sticky();
      search_mobile();
      currency_mobile();
      language_mobile();
      carouselMegaMenu();
      initToggleMuiltiLangCurrency();
      addTextMuiltiOptionActive(
        $("#currencies"),
        $("#currencies [data-currency].active"),
        $("[data-currency-label]")
      );
    },
  };
})();

theme.footer = (function () {
  function geotrust_slider() {
    if (!$(".geotrust_ssl--image[data-slick]").length) {
      return;
    }

    var $carousel = $(".geotrust_ssl--image[data-slick]");
    if ($carousel.length) {
      if (!$carousel.hasClass("slick-slider")) {
        $carousel.slick();
      }
    }
  }

  function block_icon() {
    if (!$(".footer-block-icon-row").length) {
      return;
    }

    var $carousel = $(".footer-block-icon-row");
    if ($(window).width() < 1025) {
      if ($carousel.length) {
        if (!$carousel.hasClass("slick-slider")) {
          $carousel.slick();
        }
      }
    } else {
      if ($carousel.length) {
        if ($carousel.hasClass("slick-slider")) {
          $carousel.slick("unslick");
        }
      }
    }
  }

  function footer_mobile() {
    if ($(window).width() <= 767) {
      if (!$(".footer-info").hasClass("footerMobile")) {
        $(".footer-info").addClass("footerMobile");
        $(".footer-col--mobile .footer-info-list").css("display", "none");
      }
    } else {
      $(".footer-info").removeClass("footerMobile");
      $(".footer-col--mobile").removeClass("open-dropdown");
      $(".footer-col--mobile .footer-info-list").css("display", "block");
    }
  }

  function toggle_footer() {
    if (window.innerWidth <= 767) {
      document.addEventListener("click", function (event) {
        if (
          event.target.matches(
            ".footerMobile .footer-col--mobile .footer-info-heading"
          )
        ) {
          const parent = event.target.parentNode;
          parent.classList.toggle("open-dropdown");
          const footerInfoList = parent.querySelector(".footer-info-list");
          footerInfoList.style.display =
            footerInfoList.style.display === "none" ? "block" : "none";
        }
      });
    }
  }

  return {
    init: function () {
      geotrust_slider();
      block_icon();
      footer_mobile();
      toggle_footer();
    },
  };
})();

theme.sidebar = (function () {
  function toggle_sidebar_mobile() {
    $(".sidebar_mobile").on("click", function (event) {
      event.preventDefault();
      const $target = $(event.target);
      if ($target.hasClass("is-open")) {
        $target.removeClass("is-open");
        $(".page-sidebar").removeClass("is-open");
        $("body").removeClass("open_Sidebar");
      } else {
        $target.addClass("is-open");
        $(".page-sidebar").addClass("is-open");
        $("body").addClass("open_Sidebar");
      }
    });

    $(".sidebar_close .close").on("click", function (event) {
      event.preventDefault();
      $(".page-sidebar").removeClass("is-open");
      $("body").removeClass("open_Sidebar");
    });

    $(".overlay_background").on("click", function (event) {
      event.preventDefault();
      if ($(".page-sidebar").hasClass("is-open")) {
        $(".page-sidebar").removeClass("is-open");
        $("body").removeClass("open_Sidebar");
      }
    });
  }

  function dropdown_collectionChild() {
    if ($(".all-categories-list").length) {
      $(document).on(
        "click",
        ".all-categories-list .navPages-action-wrapper",
        function (event) {
          const $target = $(event.target).parent();
          $target.siblings().removeClass("is-clicked");
          $target.toggleClass("is-clicked");
          $target.siblings().find("> .dropdown-category-list").slideUp("slow");
          $target.find("> .dropdown-category-list").slideToggle("slow");
        }
      );
    }

    var category_active = $(".breadcrumb-wrapper ul.breadcrumb .item.is-active")
      .children("a")
      .attr("href");
    $(".all-categories-list .navPages-level-1").each(function () {
      var self = $(this);
      if (
        self.find(".navPages-action-wrapper a").attr("href") === category_active
      ) {
        self.children(".navPages-action-wrapper").trigger("click");
      }
    });
  }

  function product_carousel() {
    if (!$("[data-product-carousel-sidebar]").length) {
      return;
    }

    $("[data-product-carousel-sidebar]").each(function (index) {
      var $carousel = $(this).find("[data-slick]");
      if ($carousel.length) {
        if (!$carousel.hasClass("slick-slider")) {
          $carousel.slick();
        }
      }
    });
  }

  function queryParams() {
    Shopify.queryParams = {};

    if (location.search.length) {
      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split("=");

        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
            decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }

  function ajaxCreateUrl(baseLink) {
    var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, "+");

    if (baseLink) {
      if (newQuery != "") return baseLink + "?" + newQuery;
      else return baseLink;
    }
    return location.pathname + "?" + newQuery;
  }

  function filterAjaxClick(baseLink) {
    delete Shopify.queryParams.page;

    var newurl = ajaxCreateUrl(baseLink);

    History.pushState(
      {
        param: Shopify.queryParams,
      },
      newurl,
      newurl
    );
  }

  function ajaxSortBy() {
    var $sortby = $('.filters-toolbar__item-child[data-select="SortBy"]'),
      $sortbyActive = $sortby.find("#SortBy").val();

    // $sortbyName.text($sortbyActive);
    $("#SortBy").on("change", function (e) {
      var sort = $("#SortBy").val();
      var url = window.location.href.replace(window.location.search, "");
      //console.log(url);
      if (sort.length) {
        Shopify.queryParams.sort_by = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
      filterAjaxClick();
    });
  }

  function ajaxFilterTags() {
    $(document).on(
      "click",
      ".list-tags a, .list-tags label, .refined .selected-tag",
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        var newTags = [];

        if (Shopify.queryParams.constraint) {
          newTags = Shopify.queryParams.constraint.split("+");
        }

        var tagName = $(this).prev().val();

        if (tagName) {
          var tagPos = newTags.indexOf(tagName);

          if (tagPos >= 0) {
            newTags.splice(tagPos, 1);
          } else {
            newTags.push(tagName);
          }
        }

        if (newTags.length) {
          Shopify.queryParams.constraint = newTags.join("+");
        } else {
          delete Shopify.queryParams.constraint;
        }

        filterAjaxClick();
        var newurl = ajaxCreateUrl();

        // doAjaxSidebarGetContent(newurl);
      }
    );
  }

  function ajaxFilterClearTags() {
    var sidebarTag = $(".sidebarBlock");

    $(".sidebarBlock").each(function () {
      var sidebarTagchild = $(this);

      if (sidebarTagchild.find("input:checked").length) {
        //has active tag
        sidebarTagchild.addClass("show_clear");
      }
    });

    $(document).on("click", ".sidebarBlock.show_clear .clear", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var currentTags = [];
      var currentBlock = $(this).parents(".sidebarBlock");
      if (Shopify.queryParams.constraint) {
        currentTags = Shopify.queryParams.constraint.split("+");
      }

      currentBlock.find("input:checked").each(function () {
        var selectedTag = $(this);
        var tagName = selectedTag.val();

        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {
            //remove tag
            currentTags.splice(tagPos, 1);
          }
        }
      });

      if (currentTags.length) {
        Shopify.queryParams.constraint = currentTags.join("+");
      } else {
        delete Shopify.queryParams.constraint;
      }

      filterAjaxClick();
      // var newurl = ajaxCreateUrl();
      // doAjaxSidebarGetContent(newurl);
    });
  }

  function ajaxFilterClearAll() {
    var clearAllSlt = ".refined-widgets a.clear-all";
    var clearAllElm = $(clearAllSlt);

    $(document).on("click", clearAllSlt, function (e) {
      e.preventDefault();
      e.stopPropagation();

      delete Shopify.queryParams.constraint;

      filterAjaxClick();
      // var newurl = ajaxCreateUrl();
      // doAjaxSidebarGetContent(newurl);
    });
  }

  function ajaxMapData(data) {
    var curCollTemplate = $(".template-collection .page-container"),
      curSidebar = curCollTemplate.find(".sidebar_content"),
      curProColl = curCollTemplate.find("#Collection"),
      curBreadcrumb = curCollTemplate.find(".breadcrumb-wrapper"),
      newCollTemplate = $(data).find(".page-collections"),
      newSidebar = newCollTemplate.find(".sidebar_content"),
      newBreadcrumb = newCollTemplate.find(".breadcrumb-wrapper"),
      newProColl = newCollTemplate.find("#Collection");

    curSidebar.replaceWith(newSidebar);
    curProColl.replaceWith(newProColl);

    if (checkNeedToConvertCurrency()) {
      Currency.convertAll(
        window.shop_currency,
        $("#currencies .active").attr("data-currency"),
        "span.money",
        "money_format"
      );
    }

    if ($(".shopify-product-reviews-badge").length && $(".spr-badge").length) {
      return (
        window.SPR.registerCallbacks(),
        window.SPR.initRatingHandler(),
        window.SPR.initDomEls(),
        window.SPR.loadProducts(),
        window.SPR.loadBadges()
      );
    }
  }

  function doAjaxSidebarGetContent(newurl) {
    $.ajax({
      type: "get",
      url: newurl,

      beforeSend: function () {
        showLoading();
      },

      success: function (data) {
        ajaxMapData(data);
        ajaxFilterClearTags();
        hide_filter();
        product_carousel();
      },

      error: function (xhr, text) {
        alert($.parseJSON(xhr.responseText).description);
      },

      complete: function () {
        hideLoading();
      },
    });
  }

  function historyAdapter() {
    var collTpl = $(".template-collection");

    if (collTpl.length) {
      History.Adapter.bind(window, "statechange", function () {
        var State = History.getState();

        queryParams();
        var newurl = ajaxCreateUrl();
        doAjaxSidebarGetContent(newurl);
      });
    }
  }

  function showLoading() {
    $(".loading-modal").show();
  }

  function hideLoading() {
    $(".loading-modal").hide();
  }

  function hide_filter() {
    $(".sidebarBlock_filter .sidebarBlock-content .list-tags").each(
      function () {
        if ($(this).children("li").length > 0) {
          $(this).parents(".sidebarBlock_filter").show();
        } else {
          $(this).parents(".sidebarBlock_filter").hide();
        }
      }
    );
  }

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  return {
    init: function () {
      product_carousel();
      toggle_sidebar_mobile();
      dropdown_collectionChild();

      queryParams();
      hide_filter();
      ajaxFilterTags();
      ajaxSortBy();
      // ajaxFilterClearTags();
      // ajaxFilterClearAll();
      historyAdapter();
    },
  };
})();

theme.cart_dropdown = (function () {
  var dropdownCart = $("#cart-dropdown"),
    miniProductList = dropdownCart.find(".products-list");

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function dropdown_Cart() {
    $("[data-cart-preview-pc]").on("click", function (event) {
      event.preventDefault();
      updateDropdownCart();
      const $target = $(event.currentTarget);
      if ($target.hasClass("is-open")) {
        $target.removeClass("is-open");
        $("#cart-dropdown").slideUp();
      } else {
        $target.addClass("is-open");
        $("#cart-dropdown").slideDown();
      }
    });

    $("[data-cart-preview]").on("click", function (event) {
      event.preventDefault();
      updateDropdownCart();
    });

    $(document).on("click", function (event) {
      if ($("[data-cart-preview-pc]").hasClass("is-open")) {
        if (
          $(event.target).closest("[data-cart-preview-pc]").length === 0 &&
          $(event.target).closest("#cart-dropdown").length === 0
        ) {
          $("[data-cart-preview-pc]").removeClass("is-open");
          $("#cart-dropdown").slideUp();
        }
      }
    });
  }

  function checkItemsInDropdownCart() {
    var cartNoItems = dropdownCart.find(".no-items"),
      cartHasItems = dropdownCart.find(".has-items");

    if (miniProductList.children().length) {
      cartHasItems.show();
      cartNoItems.hide();
    } else {
      cartHasItems.hide();
      cartNoItems.show();
    }
  }

  function removeItemDropdownCart(cart) {
    var btnRemove = dropdownCart.find(".btn-remove");

    btnRemove.on("click", function (event) {
      event.preventDefault();

      var productId = $(this).parents(".items").attr("id");
      productId = productId.match(/\d+/g);

      Shopify.removeItem(productId, function (cart) {
        doUpdateDropdownCart(cart);
      });
    });
  }

  function updateDropdownCart() {
    Shopify.getCart(function (cart) {
      doUpdateDropdownCart(cart);
    });
  }

  function doUpdateDropdownCart(cart) {
    var template =
      '<div class="items" id="cart-item-{ID}"><div class="product-on-cart"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" class="btn-remove"><span>&#215;</span></a><a class="product-name" href="{URL}">{TITLE}</a><div class="option"><span>{VARIANT}</span></div><div class="cart-collateral"><span class="qtt">{QUANTITY} X </span><span class="price money">{PRICE}</span></div></div></div></div>';

    $("[data-cart-count]").text(cart.item_count);

    dropdownCart
      .find(".summary .price")
      .html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
    $(".navUser-action-total-price .total-price").html(
      theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    );
    miniProductList.html("");

    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = template;

        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{URL\}/g, cart.items[i].url);
        item = item.replace(/\{TITLE\}/g, cart.items[i].product_title);

        // -- Extend - Prevents Extend warranty variant title from being rendered in dropdown cart
        if (item.includes("Extend Protection Plan") === true) {
          item = item.replace(/\{VARIANT\}/g, "");
        } else {
          item = item.replace(
            /\{VARIANT\}/g,
            cart.items[i].variant_title || ""
          );
        }
        // -- Extend - End code

        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(
          /\{IMAGE\}/g,
          Shopify.resizeImage(cart.items[i].image, "160x")
        );
        item = item.replace(
          /\{PRICE\}/g,
          theme.Currency.formatMoney(cart.items[i].price, theme.moneyFormat)
        );

        miniProductList.append(item);
      }

      removeItemDropdownCart(cart);

      if (checkNeedToConvertCurrency()) {
        Currency.convertAll(
          window.shop_currency,
          $("#currencies .active").attr("data-currency"),
          "span.money",
          "money_format"
        );
      }
    }
    checkItemsInDropdownCart();

    // -- Extend - Dispatch event to extend-dropdown-cart-integration.liquid when dropdown cart is updated
    window.dispatchEvent(Extend.CustomEvent("refreshDropDownCart"));
    // -- Extend - End code
  }

  function getShoppingCart() {
    if ($("ul.cart-list li").length > 0) {
      var check = false,
        cart = [];

      $("ul.cart-list li").each(function (i, el) {
        var product_id = $(el).data("product_id");

        if (product_id == mainProduct) check = true;

        if (cart.indexOf(product_id) == -1) cart.push(product_id);
      });

      if (check == true) {
        $.ajax({
          url:
            window.router +
            "/collections/bundle-" +
            mainProduct +
            "?view=bundle-json",
          success: function (response) {
            var myBundle = JSON.parse(response);
            if (cart.length >= myBundle.results.length) {
              checkProductInCart(cart, myBundle.results);
            } else {
              remove_discount();
            }
          },
        });
      } else {
        remove_discount();
      }
    }
  }

  function checkProductInCart(cart, collection) {
    var i = 0;
    collection.forEach(function (el) {
      if (cart.indexOf(el.id) != -1) i++;
    });
    if (i != collection.length) remove_discount();
  }

  function remove_discount() {
    $.ajax({
      url: window.router + "/checkout?discount=%20",
      success: function (response) {},
    });
  }

  return {
    init: function () {
      dropdown_Cart();
      checkItemsInDropdownCart();
      removeItemDropdownCart();
    },
  };
})();

theme.wishlist = (function () {
  var wishListsArr = localStorage.getItem("items")
    ? JSON.parse(localStorage.getItem("items"))
    : [];

  localStorage.setItem("items", JSON.stringify(wishListsArr));

  if (wishListsArr.length) {
    wishListsArr = JSON.parse(localStorage.getItem("items"));
  }

  theme.product_card.init();

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function initWishListIcons() {
    var wishListItems = localStorage.getItem("items")
      ? JSON.parse(localStorage.getItem("items"))
      : [];

    if (!wishListItems.length) {
      return;
    }

    for (var i = 0; i < wishListItems.length; i++) {
      var icon = $('[data-product-handle="' + wishListItems[i] + '"]');
      icon.addClass("whislist-added");
    }
  }

  function createWishListTplItem(ProductHandle) {
    var wishListCotainer = $("[data-wishlist-container]");

    jQuery.getJSON(
      window.router + "/products/" + ProductHandle + ".js",
      function (product) {
        var productHTML = "",
          price_min = theme.Currency.formatMoney(
            product.price_min,
            theme.moneyFormat
          );

        productHTML +=
          '<tr class="wishlist_row" data-wishlist-added="wishlist-' +
          product.id +
          '" data-product-id="product-' +
          product.handle +
          '">';
        productHTML += '<th class="wishlist_col wishlist_image text-center">';
        productHTML +=
          '<a href="' +
          product.url +
          '" class="product-grid-image" data-collections-related="/collections/all?view=related">';
        productHTML +=
          '<img src="' +
          product.featured_image +
          '" alt="' +
          product.featured_image.alt +
          '">';
        productHTML += "</a></th>";
        productHTML += '<th class="wishlist_col wishlist_name text-left">';
        productHTML += '<div class="product-vendor">';
        productHTML +=
          '<a href="' +
          window.router +
          "/collections/vendors?q=" +
          product.vendor +
          '" title="' +
          product.vendor +
          '">' +
          product.vendor +
          "</a></div>";
        productHTML +=
          '<a class="product-title" href="' +
          product.url +
          '" title="' +
          product.title +
          '">' +
          product.title +
          "</a></th>";
        productHTML +=
          '<th class="wishlist_col wishlist_price text-center"><div class="product-price"><span class="price-item">' +
          price_min +
          "</span></div></th>";
        productHTML +=
          '<th class="wishlist_col wishlist_remove text-center"><a class="btn btn--secondary product-remove whislist-added" href="#" data-product-handle="' +
          product.handle +
          '" data-icon-wishlist data-id="' +
          product.id +
          '"><span class="icon icon--big">&#215;</span>' +
          theme.strings.remove +
          "</a></th>";
        productHTML += '<th class="wishlist_col wishlist_add text-center">';
        productHTML +=
          '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' +
          product.id +
          '" data-id="product-actions-' +
          product.id +
          '" enctype="multipart/form-data">';
        if (product.available) {
          if (product.variants.length == 1) {
            productHTML +=
              '<button class="btn btn--secondary-accent" type="submit" data-btn-addToCart data-form-id="#wishlist-product-form-' +
              product.id +
              '">' +
              theme.strings.addToCart +
              '</button><input type="hidden" name="id" value="' +
              product.variants[0].id +
              '" />';
          }
          if (product.variants.length > 1) {
            productHTML +=
              '<a class="btn btn--secondary-accent" title="' +
              product.title +
              '" href="' +
              product.url +
              '">' +
              theme.strings.select_options +
              "</a>";
          }
        } else {
          productHTML +=
            '<button class="btn product-btn product-btn-soldOut" type="submit" disabled>' +
            theme.strings.unavailable +
            "</button>";
        }

        productHTML += "</form></th>";
        productHTML += "</tr>";

        wishListCotainer.append(productHTML);

        var regex = /(<([^>]+)>)/gi;
        var href = $(".wrapper-wishlist a.share").attr("href");
        href += encodeURIComponent(
          product.title +
            "\nPrice: " +
            price_min.replace(regex, "") +
            "\nLink: " +
            window.location.protocol +
            "//" +
            window.location.hostname +
            product.url +
            "\n\n"
        );
        $(".wrapper-wishlist a.share").attr("href", href);

        if (checkNeedToConvertCurrency()) {
          Currency.convertAll(
            window.shop_currency,
            $("#currencies .active").attr("data-currency"),
            "span.money",
            "money_format"
          );
        }
      }
    );
  }

  function initWishListPagging() {
    var data = JSON.parse(localStorage.getItem("items"));

    var wlpaggingContainer = $("#wishlist_pagination");
    var paggingTpl =
      '<li><a href="#" class="btn btn--narrow btn--prev disabled"><span class="icon_text">' +
      theme.strings.previous +
      "</span></a></li>";
    var wishListCotainer = $("[data-wishlist-container]");

    wlpaggingContainer.children().remove();

    var totalPages = Math.ceil(data.length / 5);

    if (totalPages <= 1) {
      wishListCotainer.children().show();
      return;
    }

    for (var i = 0; i < totalPages; i++) {
      var pageNum = i + 1;
      if (i === 0)
        paggingTpl +=
          '<li><a class="pagination-link pagination--current" data-page="' +
          pageNum +
          '" href="' +
          pageNum +
          '" title="' +
          pageNum +
          '">' +
          pageNum +
          "</a></li>";
      else
        paggingTpl +=
          '<li><a class="pagination-link" data-page="' +
          pageNum +
          '" href="' +
          pageNum +
          '" title="' +
          pageNum +
          '">' +
          pageNum +
          "</a></li>";
    }

    paggingTpl +=
      '<li><a class="btn btn--narrow btn--next" href="#"><span class="icon_text">' +
      theme.strings.next +
      "</span></a></li>";

    wlpaggingContainer.append(paggingTpl);

    wishListCotainer.children().each(function (idx, elm) {
      if (idx >= 0 && idx < 5) {
        $(elm).show();
      } else {
        $(elm).hide();
      }
    });

    wlpaggingContainer
      .off("click.wl-pagging")
      .on("click.wl-pagging", "li a", function (e) {
        e.preventDefault();

        var isPrev = $(this).hasClass("btn--prev");
        var isNext = $(this).hasClass("btn--next");
        var pageNumber = $(this).data("page");

        if (isPrev) {
          var curPage = parseInt(
            $("#wishlist_pagination").find(".pagination--current").data("page")
          );
          pageNumber = curPage - 1;
        }

        if (isNext) {
          var curPage = parseInt(
            $("#wishlist_pagination").find(".pagination--current").data("page")
          );
          pageNumber = curPage + 1;
        }

        wishListCotainer.children().each(function (idx, elm) {
          if (idx >= (pageNumber - 1) * 5 && idx < pageNumber * 5) {
            $(elm).show();
          } else {
            $(elm).hide();
          }
        });

        if (pageNumber === 1) {
          wlpaggingContainer.find(".btn--prev").addClass("disabled");
          wlpaggingContainer.find(".btn--next").removeClass("disabled");
        } else if (pageNumber === totalPages) {
          wlpaggingContainer.find(".btn--next").addClass("disabled");
          wlpaggingContainer.find(".btn--prev").removeClass("disabled");
        } else {
          wlpaggingContainer.find(".btn--prev").removeClass("disabled");
          wlpaggingContainer.find(".btn--next").removeClass("disabled");
        }

        $("#wishlist_pagination")
          .find(".pagination-link")
          .removeClass("pagination--current");
        $("#wishlist_pagination")
          .find('[data-page="' + pageNumber + '"]')
          .addClass("pagination--current");
      });
  }

  function initWishLists() {
    if (
      typeof Storage !== "undefined" &&
      $(".page").hasClass("page-wishlist")
    ) {
      var data = JSON.parse(localStorage.getItem("items"));

      if (data.length <= 0) {
        return;
      }

      data.forEach(function (item) {
        createWishListTplItem(item);
      });
      setTimeout(function () {
        initWishListPagging();
      }, 1000);
    }
  }

  function setAddedForWishlistIcon(ProductHandle) {
    var wishlistElm = $('[data-product-handle="' + ProductHandle + '"]'),
      idxArr = wishListsArr.indexOf(ProductHandle);

    if (idxArr >= 0) {
      wishlistElm.addClass("whislist-added");
    } else {
      wishlistElm.removeClass("whislist-added");
    }
  }

  function doAddOrRemoveWishlish() {
    var iconWishListsSlt = "[data-icon-wishlist]";

    $(document)
      .off("click.addOrRemoveWishlist", iconWishListsSlt)
      .on("click.addOrRemoveWishlist", iconWishListsSlt, function (e) {
        e.preventDefault();

        var self = $(this),
          productId = self.data("id"),
          ProductHandle = self.data("product-handle"),
          idxArr = wishListsArr.indexOf(ProductHandle);

        if (!self.hasClass("whislist-added")) {
          self.addClass("whislist-added");

          if ($("[data-wishlist-container]").length) {
            createWishListTplItem(ProductHandle);
          }

          wishListsArr.push(ProductHandle);
          localStorage.setItem("items", JSON.stringify(wishListsArr));
        } else {
          self.removeClass("whislist-added");

          if ($('[data-wishlist-added="wishlist-' + productId + '"]').length) {
            $('[data-wishlist-added="wishlist-' + productId + '"]').remove();
          }

          wishListsArr.splice(idxArr, 1);
          localStorage.setItem("items", JSON.stringify(wishListsArr));

          if ($("[data-wishlist-container]").length) {
            initWishListPagging();
          }
        }

        setAddedForWishlistIcon(ProductHandle);
      });
  }

  return {
    init: function () {
      initWishListIcons();
      initWishLists();
      doAddOrRemoveWishlish();
    },
  };
})();

theme.compare = (function () {
  var compareArr = localStorage.getItem("compareArr")
    ? JSON.parse(localStorage.getItem("compareArr"))
    : [];

  localStorage.setItem("compareArr", JSON.stringify(compareArr));

  if (compareArr.length) {
    compareArr = JSON.parse(localStorage.getItem("compareArr"));
  }

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function initCompareIcons() {
    if (!$(".page-collections").length) {
      return;
    }
    var compareCountNum = $("[data-compare-count]");

    totalProduct = Math.ceil(compareArr.length);
    compareCountNum.text(totalProduct);

    if (!compareArr.length) {
      return;
    } else {
      for (var i = 0; i < compareArr.length; i++) {
        var icon = $('[data-compare-product-handle="' + compareArr[i] + '"]');
        icon.addClass("compare-added");
      }

      if (typeof Storage !== "undefined") {
        if (compareArr.length <= 0) {
          return;
        }

        resetCompare();

        setTimeout(function () {
          compareArr.forEach(function (item) {
            createCompareItem(item);
            setAddedForCompareIcon(item);
          });
        }, 700);
      } else {
        alert("Sorry! No web storage support..");
      }
    }
  }

  function createCompareItem(ProductHandle) {
    var compareProduct = $("[data-compare-modal]").find(".product-grid"),
      compareRating = $("[data-compare-modal]").find(".rating"),
      compareDescription = $("[data-compare-modal]").find(".description"),
      compareCollection = $("[data-compare-modal]").find(".collection"),
      compareAvailability = $("[data-compare-modal]").find(".availability"),
      compareProductType = $("[data-compare-modal]").find(".product-type"),
      compareSKU = $("[data-compare-modal]").find(".product-sku");

    jQuery.getJSON(
      window.router + "/products/" + ProductHandle + ".js",
      function (product) {
        var productHTML = "",
          priceHTML = "",
          productLabelHTML = "",
          ratingHTML = "",
          descriptionHTML = "",
          collectionHTML = "",
          availabilityHTML = "",
          productTypeHTML = "",
          skuHTML = "",
          price_min = theme.Currency.formatMoney(
            product.price_min,
            theme.moneyFormat
          );

        var productIDCompare = product.id;
        var priceSale = "";

        $(".halo-column-product .halo-item").each(function () {
          var productID = $(this).find(".product-card").data("id");

          if (productID == productIDCompare) {
            price = $(this).find(".product-price").html();
            productLabel = $(this).find(".product_badges").html();
            rating = $(this).find(".spr-badge").html();
            coll = $(this).find(".collection-product").html();
            desc = $(this).find(".product-description").html();
            sku = $(this).find(".sku-product").html();
            if ($(this).find(".product-price").hasClass("price--on-sale"))
              priceSale = "price--on-sale";
            priceHTML += price;

            if (productLabel != undefined && productLabel != "") {
              productLabelHTML += productLabel;
            }

            if (rating == "" || rating == undefined) {
              ratingHTML +=
                '<div class="col-xl-4" data-compare-added="compare-' +
                product.id +
                '"></div>';
            } else {
              ratingHTML +=
                '<div class="col-xl-4" data-compare-added="compare-' +
                product.id +
                '">' +
                rating +
                "</div>";
            }
            compareRating.append(ratingHTML);

            if (coll == "" || desc == undefined) {
              collectionHTML +=
                '<div class="col-xl-4" data-compare-added="compare-' +
                product.id +
                '">-</div>';
            } else {
              collectionHTML +=
                '<div class="col-xl-4" data-compare-added="compare-' +
                product.id +
                '">' +
                coll +
                "</div>";
            }
            compareCollection.append(collectionHTML);

            if (desc == "" || desc == undefined) {
              descriptionHTML +=
                '<div class="col-xl-4" data-compare-added="compare-' +
                product.id +
                '">-</div>';
            } else {
              descriptionHTML +=
                '<div class="col-xl-4" data-compare-added="compare-' +
                product.id +
                '">' +
                desc +
                "</div>";
            }
            compareDescription.append(descriptionHTML);

            if (sku == "" || desc == undefined) {
              skuHTML +=
                '<div class="col-xl-4" data-compare-added="compare-' +
                product.id +
                '">-</div>';
            } else {
              skuHTML +=
                '<div class="col-xl-4" data-compare-added="compare-' +
                product.id +
                '">' +
                sku +
                "</div>";
            }
            compareSKU.append(skuHTML);
          }
        });

        productHTML +=
          '<div class="grid-item col-xl-4" data-compare-added="compare-' +
          product.id +
          '">';
        productHTML +=
          '<div class="product-card" data-product-id="product-' +
          product.handle +
          '">';
        productHTML += '<div class="product-image">';
        productHTML += '<a href="' + product.url + '" class="product-link">';
        productHTML +=
          '<img src="' +
          product.featured_image +
          '" alt="' +
          product.featured_image.alt +
          '">';
        productHTML += "</a>";
        productHTML +=
          '<div class="product_badges">' + productLabelHTML + "</div></div>";
        productHTML += '<div class="product-content">';
        productHTML += '<div class="product-vendor">';
        productHTML +=
          '<a href="' +
          window.router +
          "/collections/vendors?q=" +
          product.vendor +
          '" title="' +
          product.vendor +
          '">' +
          product.vendor +
          "</a></div>";
        productHTML +=
          '<h4 class="product-title"><a href="' +
          product.url +
          '" title="' +
          product.title +
          '">' +
          product.title +
          "</a></h4>";
        productHTML +=
          '<div class="product-price ' +
          priceSale +
          '">' +
          priceHTML +
          "</div>";

        productHTML += '<div class="product-action">';
        productHTML +=
          '<form action="/cart/add" method="post" class="variants" data-id="product-actions-' +
          product.id +
          '" enctype="multipart/form-data">';
        if (product.available) {
          if (product.variants.length == 1) {
            productHTML +=
              '<button data-btn-addToCart class="btn product-btn" type="submit">' +
              theme.strings.addToCart +
              '</button><input type="hidden" name="id" value="' +
              product.variants[0].id +
              '" />';
          }
          if (product.variants.length > 1) {
            productHTML +=
              '<a class="btn product-btn" title="' +
              product.title +
              '" href="' +
              product.url +
              '">' +
              theme.strings.select_options +
              "</a>";
          }
          availabilityHTML +=
            '<div class="col-xl-4 in-stock" data-compare-added="compare-' +
            product.id +
            '">' +
            theme.strings.in_stock +
            "</div>";
        } else {
          productHTML +=
            '<button data-btn-addToCart class="btn product-btn product-btn-soldOut" type="submit" disabled="disabled">' +
            theme.strings.unavailable +
            "</button>";
          availabilityHTML +=
            '<div class="col-xl-4 unavailable" data-compare-added="compare-' +
            product.id +
            '">' +
            theme.strings.out_of_stock +
            "</div>";
        }
        productHTML +=
          '</form><div class="text-center mt-3"><a class="product-remove" href="javascript:void(0);" data-icon-compare-added data-compare-product-handle="' +
          product.handle +
          '" data-id="' +
          product.id +
          '">' +
          theme.strings.remove +
          "</a></div>";

        productHTML += "</div></div></div></div>";

        compareProduct.append(productHTML);

        productTypeHTML +=
          '<div class="col-xl-4" data-compare-added="compare-' +
          product.id +
          '">' +
          product.type +
          "</div>";

        compareAvailability.append(availabilityHTML);
        compareProductType.append(productTypeHTML);

        if (checkNeedToConvertCurrency()) {
          Currency.convertAll(
            window.shop_currency,
            $("#currencies .active").attr("data-currency"),
            "span.money",
            "money_format"
          );
        }
      }
    );
  }

  function removeCompareItem(ProductHandle) {
    var iconCompareRemove = "[data-icon-compare-added]";

    $(document)
      .off("click.removeCompareItem", iconCompareRemove)
      .on("click.removeCompareItem", iconCompareRemove, function (e) {
        e.preventDefault();
        e.stopPropagation();

        var self = $(this),
          productId = self.data("id"),
          ProductHandle = self.data("compare-product-handle"),
          idxArr = compareArr.indexOf(ProductHandle);

        if ($('[data-compare-added="compare-' + productId + '"]').length) {
          $('[data-compare-added="compare-' + productId + '"]').remove();
        }

        compareArr.splice(idxArr, 1);
        localStorage.setItem("compareArr", JSON.stringify(compareArr));

        setAddedForCompareIcon(ProductHandle);
      });
  }

  function removeAllCompareItem(ProductHandle) {
    var compareRemoveAll = "[data-compare-remove-all]";
    compareCountNum = $("[data-compare-count]");
    compareElm = $("[data-icon-compare]");

    $(document)
      .off("click.removeAllCompareItem", compareRemoveAll)
      .on("click.removeAllCompareItem", compareRemoveAll, function (e) {
        e.preventDefault();
        e.stopPropagation();

        $("[data-compare-added]").remove();

        compareArr.splice(0, compareArr.length);
        localStorage.setItem("compareArr", JSON.stringify(compareArr));

        if (compareElm.hasClass("compare-added")) {
          compareElm.removeClass("compare-added");
        }

        totalProduct = Math.ceil(compareArr.length);
        compareCountNum.text("0");
        compareCountNum.parent().removeClass("show");
        $("#compare").modal("hide");
      });
  }

  function resetCompare() {
    var compareRemoveAll = "[data-compare-remove-all]";
    compareCountNum = $("[data-compare-count]");
    compareElm = $("[data-icon-compare]");

    $("[data-compare-added]").remove();

    compareArr.splice(0, compareArr.length);
    localStorage.setItem("compareArr", JSON.stringify(compareArr));

    if (compareElm.hasClass("compare-added")) {
      compareElm.removeClass("compare-added");
    }

    totalProduct = Math.ceil(compareArr.length);
    compareCountNum.text("0");
    compareCountNum.parent().removeClass("show");
  }

  function setAddedForCompareIcon(ProductHandle) {
    var compareElm = $('[data-compare-product-handle="' + ProductHandle + '"]'),
      idxArr = compareArr.indexOf(ProductHandle),
      compareCountNum = $("[data-compare-count]");

    compareItems = localStorage.getItem("compareArr")
      ? JSON.parse(localStorage.getItem("compareArr"))
      : [];
    totalProduct = Math.ceil(compareItems.length);

    if (idxArr >= 0) {
      compareElm.addClass("compare-added");
      compareElm.find(".compare-text").text("remove compare");
    } else {
      compareElm.removeClass("compare-added");
      compareElm.find(".compare-text").text("add compare");
    }

    compareCountNum.text(totalProduct);
    if (totalProduct > 1) {
      compareCountNum.parent().addClass("show");
    } else {
      compareCountNum.parent().removeClass("show");
    }
  }

  function doAddOrRemoveCompare() {
    if (!$(".page-collections").length) {
      return;
    }

    var iconCompare = "[data-icon-compare]";

    $(document).on("click", iconCompare, function (e) {
      e.preventDefault();

      var self = $(this),
        productId = self.data("id"),
        ProductHandle = self.data("compare-product-handle"),
        idxArr = compareArr.indexOf(ProductHandle);

      if (!self.hasClass("compare-added")) {
        self.addClass("compare-added");

        compareArr.push(ProductHandle);
        localStorage.setItem("compareArr", JSON.stringify(compareArr));

        createCompareItem(ProductHandle);
      } else {
        self.removeClass("compare-added");

        if ($('[data-compare-added="compare-' + productId + '"]').length) {
          $('[data-compare-added="compare-' + productId + '"]').remove();
        }

        compareArr.splice(idxArr, 1);
        localStorage.setItem("compareArr", JSON.stringify(compareArr));
      }

      setAddedForCompareIcon(ProductHandle);
    });
  }

  function initCompareSelected() {
    if (!$(".page-collections").length) {
      return;
    }

    var iconCompareSelected = "[data-compare-selected]",
      compareModal = $("[data-compare-modal]"),
      compareModalProduct = compareModal.find(".product-grid"),
      compareModalMessage = $("[data-compare-message-modal]");

    $(document)
      .off("click.compareSelected", iconCompareSelected)
      .on("click.compareSelected", iconCompareSelected, function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (typeof Storage !== "undefined") {
          if (compareArr.length <= 1) {
          } else {
            compareArr.forEach(function (item) {
              removeCompareItem(item);
            });

            removeAllCompareItem();
          }
        } else {
          alert("Sorry! No web storage support..");
        }
      });
  }

  return {
    init: function () {
      doAddOrRemoveCompare();
      initCompareIcons();
      initCompareSelected();
    },
  };
})();

theme.cart_page = (function () {
  function changeQuantityAddToCart() {
    if (!$(".page-cart").length) {
      return;
    }
    var buttonSlt = "[data-qtt]",
      buttonElm = $(buttonSlt);

    $(document).on("click", buttonSlt, function (e) {
      e.preventDefault();
      e.stopPropagation();

      var self = $(this),
        input =
          self.siblings('input[name="quantity"]').length > 0
            ? self.siblings('input[name="quantity"]')
            : self.siblings('input[name="group_quantity"]');

      if (input.length < 1) {
        input = self.siblings('input[name="updates[]"]');
      }

      var val = parseInt(input.val());

      switch (true) {
        case self.hasClass("plus"): {
          val += 1;
          break;
        }
        case self.hasClass("minus") && val > 0: {
          val -= 1;
          break;
        }
      }
      input.val(val);
    });
  }
  changeQuantityAddToCart();
})();

theme.someone_purchased = (function () {
  function toggleSomething() {
    var timeText = $(".product-notification .time-text span:visible").text();

    if ($(".product-notification").hasClass("active")) {
      $(".product-notification").removeClass("active");
    } else {
      var number = $(".data-product").length,
        i = Math.floor(Math.random() * number),
        images = $(".product-notification .data-product:eq(" + i + ")").data(
          "image"
        ),
        title = $(".product-notification .data-product:eq(" + i + ")").data(
          "title"
        ),
        url = $(".product-notification .data-product:eq(" + i + ")").data(
          "url"
        ),
        local = $(".product-notification .data-product:eq(" + i + ")").data(
          "local"
        );

      $(".product-notification").addClass("active");
      $(".product-notification .product-image").find("img").attr("src", images);
      $(".product-notification .product-name").attr("href", url);
      $(".product-notification .product-name").text(title);
      $(".product-notification .product-image").attr("href", url);
      $(".product-notification .time-text").text(local);
    }
  }

  function SomeonePurchased() {
    if (!$(".product-notification").length) {
      return;
    }

    if ($.cookie("pr_notification") == "closed") {
      $(".product-notification").remove();
    }

    $(".close-notifi").bind("click", function () {
      $(".product-notification").remove();
      $.cookie("pr_notification", "closed", { expires: 1, path: "/" });
    });

    var time = $(".product-notification").data("time");
    var timer = setInterval(toggleSomething, time);
  }

  function gdprCookie() {
    var gdprCookie = $("#accept-cookies");

    if ($.cookie("cookieMessage") == "closed") {
      gdprCookie.remove();
    } else {
      gdprCookie.removeClass("hide");
    }

    gdprCookie.find("[data-accept-cookie]").on("click", function (e) {
      e.preventDefault();
      gdprCookie.remove();
      $.cookie("cookieMessage", "closed", { expires: 1, path: "/" });
    });
  }

  return {
    init: function () {
      gdprCookie();
      SomeonePurchased();
    },
  };
})();

theme.MultiCategory = (function () {
  var first = true;
  function getCategories(root) {
    var result = new Array();
    root.find(" > li").each(function () {
      var link = jQuery(this).find(">a");
      var node = {
        link: link.attr("href"),
        title: link.html(),
        children: getCategories(jQuery(this).find("> ul ")),
      };
      result.push(node);
    });
    return result;
  }
  function setActive() {
    var result = new Array();
    var curLi = jQuery("nav#navPages >  ul").find(".active");
    if (curLi.index() == -1) return false;
    result.push(curLi.index());
    curLi = curLi.parent().parent();
    if (curLi.attr("id") != "navPages") {
      result.push(curLi.index());
      curLi = curLi.parent().parent();
      if (curLi.attr("id") != "navPages") {
        result.push(curLi.index());
      }
    }
    return result;
  }
  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      $("#themevale_select-level-" + i + " ul li[data-value]").remove();
    }
    for (var i = 0; i < level_List.length; i++) {
      $("#themevale_select-level-" + level + " ul").append(
        "<li data-value='" +
          i +
          "' onclick='theme.MultiCategory.changeOption(" +
          level +
          "," +
          i +
          ")'>" +
          level_List[i].title.trim() +
          "</li>"
      );
    }
  }
  function changeOptionAll(level) {
    $("#themevale_select-level-" + level + " ul")
      .children()
      .removeClass("active");
    var select_option = $(
      "#themevale_select-level-" + level + " ul li:eq(0)"
    ).html();
    $("#themevale_select-level-" + level)
      .prev(".da-force-up.form-select")
      .html(select_option);
  }
  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      if (
        $(
          "#themevale_select-level-" +
            level +
            ' ul li[data-value="' +
            num +
            '"]'
        ).hasClass("active") == false
      ) {
        redirect = true;
      }
      $("#themevale_select-level-" + level + " ul")
        .children()
        .removeClass("active");
      $("#themevale_select-level-" + level + " ul")
        .children()
        .each(function () {
          if ($(this).attr("data-value") == num) {
            $(this).addClass("active");
            $("#themevale_select-level-" + level)
              .prev(".da-force-up.form-select")
              .text($(this).text());
          }
        });
      resetDrop(level);
      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var index = parseInt(
          $("#themevale_select-level-" + i + " ul")
            .find(".active")
            .attr("data-value")
        );
        if (level_List[index] != undefined) {
          level_List = level_List[index].children;
        }
      }

      if (level == 3 && redirect == true) {
        $("#themevale_select-browse").trigger("click");
      }
      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        $(".themevale_multilevel-category-filter").find(".loading").show();
        setTimeout(function () {
          $("#themevale_select-level-" + level).addClass("open");
          $(".themevale_multilevel-category-filter").find(".loading").hide();
        }, 300);
      }
    }
  }
  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var select_option = $(
        "#themevale_select-level-" + i + " ul li:eq(0)"
      ).html();
      $("#themevale_select-level-" + i)
        .prev(".da-force-up.form-select")
        .html(select_option);
      $("#themevale_select-level-" + i + " ul").html(
        '<li onclick="theme.MultiCategory.changeOptionAll(' +
          i +
          ')">' +
          select_option +
          "</li>"
      );
    }
  }

  var list = getCategories(jQuery("nav#navPages >  ul"));
  var selectLevel1 = jQuery("#themevale_select-level-1 ul");
  var selectLevel2 = jQuery("#themevale_select-level-2 ul");
  var selectLevel3 = jQuery("#themevale_select-level-3 ul");

  function MultiCategory() {
    if (!$(".themevale_MultiCategory").length) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    if ($("body").hasClass("template-index")) {
      jQuery.cookie("multiLevelCategory", "");
    }

    //console.log(jQuery.cookie("multiLevelCategory"));
    if (jQuery.cookie("multiLevelCategory") != "") {
      var active = jQuery.cookie("multiLevelCategory").split(",");
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      $(".themevale_multilevel-category-filter").find(".loading").hide();
      $(".dropdown-up").removeClass("open");
    }

    $(document).on("click", ".da-force-up", function (e) {
      if ($(this).parent().find(".dropdown-up").hasClass("open")) {
        $(this).parent().find(".dropdown-up").removeClass("open");
      } else {
        $(".dropdown-up").removeClass("open");
        $(this).parent().find(".dropdown-up").addClass("open");
      }
    });

    $(window).click(function (e) {
      var container = $(".da-force-up");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.next(".dropdown-up").removeClass("open");
      }
    });

    $("#themevale_select-browse").click(function () {
      var level_List = list;
      var index = 0,
        url = "";
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        index = parseInt(
          $("#themevale_select-level-" + i + " ul")
            .find(".active")
            .attr("data-value")
        );
        if (!isNaN(index)) {
          menu.push(index);
          url = level_List[index].link;
          if (level_List[index].children.length) {
            level_List = level_List[index].children;
          }
        }
      }
      jQuery.cookie("multiLevelCategory", menu, { expires: 1, path: "/" });
      location.href = url;
    });

    $("#themevale_clear-select").click(function () {
      resetDrop(1);
      var select_option = $("#themevale_select-level-1 ul li:eq(0)").html();
      $("#themevale_select-level-1")
        .prev(".da-force-up.form-select")
        .html(select_option);
      $("#themevale_select-level-1 ul").children().removeClass("active");
    });
    first = false;
  }

  return {
    init: function () {
      MultiCategory();
    },
    changeOption: function (level, num) {
      changeOption(level, num);
    },
    changeOptionAll: function (level) {
      changeOptionAll(level);
    },
  };
})();

theme.halo_mobile = (function () {
  function toggle_menu() {
    $('[data-mobile-menu-toggle="menu"]').on("click", function () {
      $(this).toggleClass("is-open");
      $("body").toggleClass("open_menu");
      if ($(window).width() > 1024) {
        var position = $(".site-header").position(),
          height = $(".site-header").outerHeight();
        $("#site-nav-mobile").css({
          top: position.top + height,
          height: $(window).height() - position.top - height,
        });
      } else {
        $("#site-nav-mobile").css("top", 0);
      }
    });

    $("#site-nav-mobile .close_menu").on("click", function (event) {
      $('[data-mobile-menu-toggle="menu"]').removeClass("is-open");
      $("body").removeClass("open_menu");
      reset_dropdownMenu();
    });

    $(".overlay_background").on("click", function (event) {
      if ($("body").hasClass("open_menu")) {
        $('[data-mobile-menu-toggle="menu"]').removeClass("is-open");
        $("body").removeClass("open_menu");
        reset_dropdownMenu();
      }
    });
  }

  function toggle_login() {
    $("[data-login-dropdown-pc]").on("click", function (event) {
      event.preventDefault();
      const $target = $(event.currentTarget);
      if ($target.hasClass("is-open")) {
        $target.removeClass("is-open");
        $("#login-dropdown").slideUp();
      } else {
        $target.addClass("is-open");
        $("#login-dropdown").slideDown();
      }
    });

    $("[data-close-login-dropdown-pc]").on("click", function (event) {
      event.preventDefault();
      $("[data-login-dropdown-pc]").removeClass("is-open");
      $("#login-dropdown").slideUp();
    });

    $(document).on("click", function (event) {
      if ($("[data-login-dropdown-pc]").hasClass("is-open")) {
        if (
          $(event.target).closest("[data-login-dropdown-pc]").length === 0 &&
          $(event.target).closest("#login-dropdown").length === 0
        ) {
          $("[data-login-dropdown-pc]").removeClass("is-open");
          $("#login-dropdown").slideUp();
        }
      }
    });

    $("[data-login-toggle]").on("click", function (event) {
      $("body").addClass("open_Account");
    });

    $("[data-close-login-dropdown]").on("click", function (event) {
      $("body").removeClass("open_Account");
    });

    $(".overlay_background").on("click", function (event) {
      event.preventDefault();
      if ($("body").hasClass("open_Account")) {
        $("body").removeClass("open_Account");
      }
    });
  }

  function toggle_cart() {
    $("[data-cart-preview]").on("click", function (event) {
      $("body").addClass("open_Cart");
    });

    $("[data-close-cart-preview]").on("click", function (event) {
      $("body").removeClass("open_Cart");
    });

    $(document).on("click", function (event) {
      if ($("body").hasClass("open_Cart")) {
        if (
          $(event.target).closest("[data-cart-preview]").length === 0 &&
          $(event.target).closest("#cart-mobile").length === 0
        ) {
          $("body").removeClass("open_Cart");
        }
      }
    });
  }

  function toggle_search() {
    $(".item--searchMobile .navUser-action").on("click", function (event) {
      $(".item--searchMobile .navUser-action").toggleClass("is-open");
    });
  }

  function reset_dropdownMenu() {
    $("#site-nav-mobile").find(".is-open").removeClass("is-open");
    $("#site-nav-mobile").find(".is-hidden").removeClass("is-hidden");
  }

  function toggle_dropdownMenu() {
    // var $opemMenu = $('.site-nav-mobile').find('.nav-action');
    // $(document).on("click", ".site-nav-mobile .nav-action", function (event) {
    //   const $openAction = $(event.target).parent();
    //   const $parentSiblings = $openAction.siblings();
    //   const $checkTitle = $openAction.closest(".site-nav-dropdown");
    //   const $closestTitle = $checkTitle.siblings();
    //   if (!$(event.target).hasClass("menu__moblie_end")) {
    //     if (!$(event.target).hasClass("link")) {
    //       $openAction.addClass("is-open");
    //       if ($openAction.hasClass("is-open")) {
    //         $parentSiblings.addClass("is-hidden");
    //       }
    //       if ($checkTitle.length) {
    //         $closestTitle.addClass("is-hidden");
    //       }
    //     }
    //   }
    // });
    // var $closestMenu = $('.site-nav-mobile').find('.menu-mb-title');
    // $(document).on(
    //   "click",
    //   ".site-nav-mobile .menu-mb-title",
    //   function (event) {
    //     const $closestAction = $(event.target).closest(".dropdown");
    //     const $parentSiblings2 = $closestAction.siblings();
    //     const $openTitle = $(event.target)
    //       .closest(".site-nav-dropdown")
    //       .siblings();
    //     $closestAction.removeClass("is-open");
    //     $parentSiblings2.removeClass("is-hidden");
    //     $openTitle.removeClass("is-hidden");
    //   }
    // );
  }

  function terms_conditions() {
    if (!$(".terms_conditions_wrapper").length) {
      return;
    }

    var checkBox = $('.terms_conditions_wrapper input[type="checkbox"]');

    checkBox.each(function () {
      if ($(this).is(":checked")) {
        $(this).parent().next().removeClass("disabled");
      } else {
        $(this).parent().next().addClass("disabled");
      }
    });

    $(document).on("click", ".terms_conditions_wrapper .title", function (e) {
      e.preventDefault();
      var self = $(this),
        ipt = self.prev();

      if (!ipt.prop("checked")) {
        ipt.prop("checked", true);
        self.parent().next().removeClass("disabled");
      } else {
        ipt.prop("checked", false);
        self.parent().next().addClass("disabled");
      }
    });
  }

  return {
    init: function () {
      toggle_menu();
      toggle_cart();
      toggle_login();
      toggle_search();
      terms_conditions();
      toggle_dropdownMenu();
    },
  };
})();

$(document).ready(function () {
  var sections = new theme.Sections();

  sections.register("cart-template", theme.Cart);
  sections.register("product", theme.Product);
  sections.register("collection-template", theme.Filters);
  sections.register("product-template", theme.Product);
  sections.register("map", theme.Maps);
  sections.register("video-section", theme.VideoSection);
  sections.register("product-recommendations", theme.ProductRecommendations);
  sections.register("slideshow-section", theme.SlideshowSection);
  sections.register("cart-page", theme.cart_page);

  theme.header.init();
  theme.footer.init();
  theme.sidebar.init();
  theme.wishlist.init();
  theme.compare.init();
  theme.collection.init();
  theme.cart_dropdown.init();
  theme.halo_mobile.init();
  theme.product_card.init();
  theme.product_sticky_atc.init();
  theme.someone_purchased.init();
  theme.products_frequently_by_together.init();
  theme.product_quickview.init();
  theme.MultiCategory.init();
  theme.homepage_section.init();

  $(window).resize(function () {
    theme.header.init();
    theme.footer.init();
    theme.product_card.init();
    theme.homepage_section.init();
  });
});

theme.init = function () {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = ".rte table," + ".custom__item-inner--html table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "scrollable-wrapper",
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "video-wrapper",
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on("click", function (evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal,
    },
    $links: $("a[href]:not([aria-describedby], .product-single__thumbnail)"),
  });

  theme.FormStatus.init();

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    $(selectors.image + ".lazyloaded")
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  }

  onLoadHideLazysizesAnimation();

  // Do the injection svg
  var mySVGsToInject = document.querySelectorAll("svg[data-src]");

  SVGInjector(mySVGsToInject);
};
//

//
/*var modal = document.querySelector(".ventana"),
  trigger = document.querySelector(".announcement-bar"),
  closeButton = document.querySelector(".boton-cerrar"),
  closeButtonRed = document.querySelector(".btn-cerrar-modal"),
  modalSlider = document.querySelector("#boton-slider"),
  banner = document.getElementsByClassName("image")[6],
  bannerTwo = document.getElementsByClassName("image")[12];
function toggleModal() {
  modal.classList.toggle("mostrar-ventana");
}
function windowOnClick(t) {
  t.target === modal && toggleModal();
}
trigger.addEventListener("click", toggleModal),
  closeButton.addEventListener("click", toggleModal),
  closeButtonRed.addEventListener("click", toggleModal),
  window.addEventListener("click", windowOnClick),
  modalSlider && modalSlider.addEventListener("click", toggleModal),
  banner && banner.addEventListener("click", toggleModal),
  bannerTwo && bannerTwo.addEventListener("click", toggleModal),*/
$(theme.init);
// Open chat with a click
let chat = document.getElementById("chat");
if (chat) {
  chat.addEventListener("click", function (event) {
    chatShow();
  });
}
function chatShow() {
  window.HubSpotConversations.widget.open();
}



function openTabJks(tabName, valuesArray) {
  console.log(tabName, valuesArray, "JKS");
  let i;
  let x = document.getElementsByClassName("tabs-disaster");

  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  let tabTarget = document.getElementById(tabName);
  if (tabTarget != null) {
    document.getElementById(tabName).style.display = "block";
  } else {
    noAvaible(valuesArray[0], valuesArray[1], valuesArray[2], valuesArray[3]);
  }

  //evt.currentTarget.className += " disabled";
}
// Filtro de los que no existen
function noAvaible(kit, level, desired, load) {
  let shocks = document.getElementById("SCHOCKS_RELOCATION_BRACKETS");
  let ibp = document.getElementById("FOX_3-0-IBP-SCHOCKS");
  let jspec = document.getElementById("JSPEC");
  let fox20Adven = document.getElementById("FOX_2.0_ADVENTURE");
  let fox25Eli = document.getElementById("FOX_2.5_ELITE");
  let fox20Per = document.getElementById("FOX_2.0_PERFORMANCE");
  let fox25Per = document.getElementById("FOX_2.5_PERFORMANCE");
  let constant1 = document.getElementById("for_constant_1");
  let constant2 = document.getElementById("for_constant_2");

  if (kit === "ROAD_FRIENDLY" && level === "LEVEL_1" && desired === "3.5") {
    ibp.disabled = true;
    shocks.disabled = true;
    //
    jspec.disabled = false;
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (
    kit === "ROAD_FRIENDLY" &&
    level === "LEVEL_1" &&
    desired === "2.5"
  ) {
    ibp.disabled = true;
    //
    shocks.disabled = false;
    jspec.disabled = false;
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (
    kit === "ROAD_FRIENDLY" &&
    level === "LEVEL_2" &&
    desired === "2.5"
  ) {
    ibp.disabled = true;
    //
    shocks.disabled = false;
    jspec.disabled = false;
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (
    kit === "ROAD_FRIENDLY" &&
    level === "LEVEL_2" &&
    desired === "3.5"
  ) {
    shocks.disabled = true;
    ibp.disabled = true;
    //
    jspec.disabled = false;
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (
    kit === "ROAD_FRIENDLY" &&
    level === "LEVEL_3" &&
    desired === "2.5"
  ) {
    ibp.disabled = true;
    //
    shocks.disabled = false;
    jspec.disabled = false;
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (
    kit === "ROAD_FRIENDLY" &&
    level === "LEVEL_3" &&
    desired === "3.5"
  ) {
    ibp.disabled = true;
    shocks.disabled = true;
    //
    jspec.disabled = false;
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (
    kit === "SPECIAL_USE" &&
    level === "OVERLOADING" &&
    desired === "3.5"
  ) {
    constant1.style.display = "none";
    constant2.style.checked = true;
    //

    jspec.disabled = true;
    ibp.disabled = true;
    shocks.disabled = true;

    //
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
  } else if (
    kit === "SPECIAL_USE" &&
    level === "CRAWL" &&
    desired === "3.5" &&
    load === "NO"
  ) {
    shocks.disabled = true;
    jspec.disabled = true;
    //
    ibp.disabled = false;
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (
    kit === "SPECIAL_USE" &&
    level === "CRAWL" &&
    desired === "3.5" &&
    load === "YES"
  ) {
    shocks.disabled = true;
    jspec.disabled = true;
    //
    ibp.disabled = false;
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (kit === "SPECIAL_USE" && level === "BAJA" && desired === "3.5") {
    constant2.style.display = "none";
    constant1.checked = true;
    //
    shocks.disabled = true;
    fox20Adven.disabled = true;
    fox20Per.disabled = true;
    fox25Per.disabled = true;
    fox25Eli.disabled = true;
    ibp.disabled = true;
    //
    jspec.disabled = false;
  } else if (
    kit === "SPECIAL_USE" &&
    level === "BAJA" &&
    desired === "3.5" &&
    load === "YES"
  ) {
    jspec.disabled = false;
    //
    fox20Adven.disabled = true;
    fox20Per.disabled = true;
    fox25Per.disabled = true;
    fox25Eli.disabled = true;
    ibp.disabled = true;
    shocks.disabled = true;

    //
    constant2.style.display = "block";
    constant1.style.display = "block";
  } else if (kit === "SPECIAL_USE") {
    document.getElementById("your_kit_overloading").click();
    document.getElementById("desired_lander_1").click();
    document.getElementById("constant_2").click();
    document.getElementById("recolocation_brackets").selectedIndex = 2;
  } else {
    constant2.style.display = "block";
    constant1.style.display = "block";
    //
    fox20Adven.disabled = false;
    fox25Eli.disabled = false;
    fox20Per.disabled = false;
    fox25Per.disabled = false;
    shocks.disabled = false;
    ibp.disabled = false;
    jspec.disabled = false;
  }
  console.log(kit, level, desired, load);
}

let form = document.getElementById("values_product_jks");
if (form) {
  let valueProuduct = document.getElementById("values_product_jks");
  let valuesSelectes = Object.fromEntries(
    new FormData(valueProuduct).entries()
  );
  var valuesArray = [
    valuesSelectes.your_kit,
    valuesSelectes.your_kit_level,
    valuesSelectes.your_desired_lift,
    valuesSelectes.your_constant_load,
    valuesSelectes.select_container_shocks,
  ];
  document
    .getElementById("values_product_jks")
    .addEventListener("change", function () {
      valuesSelectes = Object.fromEntries(
        new FormData(valueProuduct).entries()
      );
      valuesArray = [
        valuesSelectes.your_kit,
        valuesSelectes.your_kit_level,
        valuesSelectes.your_desired_lift,
        valuesSelectes.your_constant_load,
        valuesSelectes.select_container_shocks,
      ];
      console.log("cambio form jks");
      openTabJks(
        valuesSelectes.your_kit +
          valuesSelectes.your_kit_level +
          valuesSelectes.your_desired_lift +
          valuesSelectes.your_constant_load +
          valuesSelectes.select_container_shocks,
        valuesArray
      );
      noAvaible(
        valuesSelectes.your_kit,
        valuesSelectes.your_kit_level,
        valuesSelectes.your_desired_lift,
        valuesSelectes.your_constant_load
      );
    });
  noAvaible(
    valuesSelectes.your_kit,
    valuesSelectes.your_kit_level,
    valuesSelectes.your_desired_lift,
    valuesSelectes.your_constant_load
  );
}

function selectGroupLevel(group) {
  let group1 = document.getElementById("your-kit-level__group1");
  let group2 = document.getElementById("your-kit-level__group2");
  let kit = document.getElementById("your_kit_overloading");
  let kit2 = document.getElementById("your_kit_overloading_2");

  if (group == "ROAD_FRIENDLY") {
    group1.style.display = "flex";
    group2.style.display = "none";
    /**/
    document.getElementById("your_kit_1_level").checked = true;
  } else if (group == "SPECIAL_USE") {
    group2.style.display = "flex";
    group1.style.display = "none";
    /**/
    kit ? (kit.checked = true) : (kit2.checked = true);
  }
}

function selectDesiredLift(desired_lift) {
  let i;
  let x = document.getElementsByClassName("desired-div");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  document.getElementById(desired_lift).style.display = "flex";
}

function openTabGlobal(evt, tabName) {
  let i;
  let x = document.getElementsByClassName("tabs-disaster-global");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  let tablinksGLobal = document.getElementsByClassName(
    "button-disaster-global"
  );
  for (i = 0; i < x.length; i++) {
    tablinksGLobal[i].className = tablinksGLobal[i].className.replace(
      " disabled",
      ""
    );
  }
  document.getElementById(tabName).style.display = "block";

  evt.currentTarget.className += " disabled";
}

// BUSCADOR

function desplegarBuscadorMobile() {
  const lupa = document.getElementById("lupita");
  let banderaLupa = true;

  console.log("Lupa: ", lupa);

  const toggleLupa = () => {
    if (banderaLupa) {
      document
        .getElementById("cm_SearchBoxDialogButton")
        .classList.add("hiddeSearch");
      banderaLupa = false;
      console.log("click lupa");
    } else {
      document
        .getElementById("cm_SearchBoxDialogButton")
        .classList.remove("hiddeSearch");
      banderaLupa = true;
      console.log("click lupa else");
    }
  };

  lupa.addEventListener("click", toggleLupa);
}

desplegarBuscadorMobile();

// MOSTRAR CHAT EN EL MENU
function menuMobile() {
  let elemento = document.querySelector(".liveChatMenuMobile");
  console.log(elemento);
  elemento.addEventListener("click", chatShow);
}

menuMobile();

// ABRIR SUBMENU

// function mostrarSubMenu($variable) {
//     window.location = $variable;
//     elemento.addEventListener('submenu',$variable);

// }

// mostrarSubMenu($variable);

// abrir submenu
function abrirsubmenu() {
  $(document).on("click",".site-nav-mobile #li-elemento-mobile",function (event) {
      if ($(event.target).hasClass("p-principal")) {
        const $openAction = $(event.target).parent();
        const $parentSiblings = $openAction.siblings();
        const $checkTitle = $openAction.closest(".site-nav-dropdown");
        const $closestTitle = $checkTitle.siblings();
        if (!$(event.target).hasClass("menu__moblie_end")) {
          if (!$(event.target).hasClass("link")) {
            $openAction.addClass("is-open");
            if ($openAction.hasClass("is-open")) {
              $parentSiblings.addClass("is-hidden");
            }
            if ($checkTitle.length) {
              $closestTitle.addClass("is-hidden");
            }
          }
        }
      } else if ($(event.target).hasClass("img-menu-mobile")) {
        const $openAction = $(event.target).parent();
        const $parentSiblings = $openAction.siblings();
        const $checkTitle = $openAction.closest(".site-nav-dropdown");
        const $closestTitle = $checkTitle.siblings();
        if (!$(event.target).hasClass("menu__moblie_end")) {
          if (!$(event.target).hasClass("link")) {
            $openAction.addClass("is-open");
            if ($openAction.hasClass("is-open")) {
              $parentSiblings.addClass("is-hidden");
            }
            if ($checkTitle.length) {
              $closestTitle.addClass("is-hidden");
            }
          }
        }
      } else if ($(event.target).hasClass("li-elemento-mobile")) {
        const $openAction = $(event.target);
        const $parentSiblings = $openAction.siblings();
        const $checkTitle = $openAction.closest(".site-nav-dropdown");
        const $closestTitle = $checkTitle.siblings();
        if (!$(event.target).hasClass("menu__moblie_end")) {
          if (!$(event.target).hasClass("link")) {
            $openAction.addClass("is-open");
            if ($openAction.hasClass("is-open")) {
              $parentSiblings.addClass("is-hidden");
            }
            if ($checkTitle.length) {
              $closestTitle.addClass("is-hidden");
            }
          }
        }
      } else if (($(event.target).parent()).hasClass("menu-lv-2")) {
        if (($(event.target).parent()).hasClass("dropdown")) {
          const $openAction = $(event.target).parent();
          const $parentSiblings = $openAction.siblings();
          const $checkTitle = $openAction.closest(".site-nav-dropdown");
          const $closestTitle = $checkTitle.siblings();
          if (!$(event.target).hasClass("menu__moblie_end")) {
            if (!$(event.target).hasClass("link")) {
              $openAction.addClass("is-open");
              if ($openAction.hasClass("is-open")) {
                $parentSiblings.addClass("is-hidden");
              }
              if ($checkTitle.length) {
                $closestTitle.addClass("is-hidden");
              }
            }
          }
      }
    }
    else if (($(event.target).parent()).hasClass("nav-action")) {
      console.log("click submenu", $(event.target).parent());
      const $padre1 = $(event.target).parent();

      if (($padre1.parent()).hasClass("menu-lv-2")) {
        if (($padre1.parent()).hasClass("dropdown")) {
          console.log("click submenu", $padre1.parent());
          $(event.target).attr("href","javascript:void(0)");
          
          const $openAction = $padre1.parent();
          const $parentSiblings = $openAction.siblings();
          const $checkTitle = $openAction.closest(".site-nav-dropdown");
          const $closestTitle = $checkTitle.siblings();
          if (!($(event.target).parent()).hasClass("menu__moblie_end")) {
            if (!($(event.target).parent()).hasClass("link")) {
              $openAction.addClass("is-open");
              if ($openAction.hasClass("is-open")) {
                $parentSiblings.addClass("is-hidden");
              }
              if ($checkTitle.length) {
                $closestTitle.addClass("is-hidden");
              }
            }
          }
      }
    }
  }

      // console.log("click submenu", $(event.target));
    }
  );
}

abrirsubmenu();

// CERRAR MENU

function cerrarSubmenu() {
  $(document).on("click", ".site-nav-mobile .menu-mb-title", function (event) {
    if ($(event.target).hasClass("menu-mb-title")) {
      const $closestAction = $(event.target).hasClass("menu-mb-title");
      const $parentSiblings2 = $(event.target).closest(".dropdown").siblings();
      const $openTitle = $(event.target)
        .closest(".site-nav-dropdown")
        .siblings();

      $(event.target).closest(".dropdown").removeClass("is-open");
      $parentSiblings2.removeClass("is-hidden");
      $openTitle.removeClass("is-hidden");
    } else if ($(event.target).hasClass("tituloSubMenu")) {
      const $closestAction = $(event.target).hasClass("tituloSubMenu");
      const $parentSiblings2 = $(event.target).closest(".dropdown").siblings();
      const $openTitle = $(event.target)
        .closest(".site-nav-dropdown")
        .siblings();

      $(event.target).closest(".dropdown").removeClass("is-open");
      $parentSiblings2.removeClass("is-hidden");
      $openTitle.removeClass("is-hidden");
    } else if ($(event.target).hasClass("iconoSubmenuAtras")) {
      const $closestAction = $(event.target).hasClass("iconoSubmenuAtras");
      const $parentSiblings2 = $(event.target).closest(".dropdown").siblings();
      const $openTitle = $(event.target)
        .closest(".site-nav-dropdown")
        .siblings();

      $(event.target).closest(".dropdown").removeClass("is-open");
      $parentSiblings2.removeClass("is-hidden");
      $openTitle.removeClass("is-hidden");
    }

    console.log($("click cerrar menu", event.target));
  });
}

cerrarSubmenu();

// Set Includes

function setIncludes() {
  let elemento = document.querySelectorAll('#custom_in_the_box');
  let contenido = document.querySelectorAll('.contenidoSetIncludes');
  let botones = document.querySelectorAll('.swatch-element');

  elemento.forEach(element =>{
    contenido.forEach(content =>{
        if(element.attributes[1].value != element.attributes[0].value && element.attributes[1].value != content.attributes[0].value){
          content.removeAttribute("id");

          element.classList.remove('mostrarVariante');
          element.classList.add('ocultarVariante');
        }
      })
    })

  botones.forEach(boton =>{
    elemento.forEach(element =>{
      contenido.forEach(content =>{
        boton.addEventListener('click',()=>{
            content.classList.remove('show');
          if(boton.attributes[0].value == element.attributes[0].value && boton.attributes[0].value == content.attributes[0].value){
            content.setAttribute("id", "inthebox_mobile");

            element.classList.remove('ocultarVariante');
            element.classList.add('mostrarVariante');
          }
          if(boton.attributes[0].value != element.attributes[0].value && boton.attributes[0].value != content.attributes[0].value){
            content.removeAttribute("id");

            element.classList.remove('mostrarVariante');
            element.classList.add('ocultarVariante');
          }
        })
      })
    })
  })

}

// botonesLiftKits();

function imprimirHola() {
  for (let i = 0; i < 20; i++) {
    console.log("Hola");
  }
}

imprimirHola();


// Set Includes

// function setIncludes() {
//   let elemento = document.querySelectorAll('#custom_in_the_box');
//   let contenido = document.querySelectorAll('.contenidoSetIncludes');

//   elemento.forEach(element =>{
//     contenido.forEach(content =>{
//         if(element.attributes[1].value != element.attributes[0].value && element.attributes[1].value != content.attributes[0].value){
//           content.removeAttribute("id");

//           element.classList.remove('mostrarVariante');
//           element.classList.add('ocultarVariante');
//         }
//         else{
//           content.setAttribute("id", "inthebox_mobile");
//           element.classList.remove('ocultarVariante');
//           element.classList.add('mostrarVariante');
//         }
//       })
//     })
// }


// setIncludes()

function openTab(evt, tabName) {
  let i;

  let x = document.getElementsByClassName("tabs-disaster");
  let tablinks = document.getElementsByClassName("button-disaster");

  for (i = 0; i < x.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" disabled", "");
  }
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " disabled";
}

// Logo mobile

function logo() {
  window.addEventListener('load', function() {
    let contenedorLogos = document.querySelector(".header-Mobile-item.text-center .items");
    const width = window.innerWidth;
    if(width < 1024){
      if(contenedorLogos.childElementCount == 0){
              const nuevoElemento = document.createElement('div');
              nuevoElemento.className = 'logo-wrapper';
              nuevoElemento.setAttribute('itemscope',''); 
              nuevoElemento.setAttribute('itemtype', 'http://schema.org/Organization');
              nuevoElemento.innerHTML = `
                  <meta itemprop="url" content="https://mudify.com">
                  <a href="/" class="site-header__logo-image" aria-label="logo" style="width: 200px">
                      <img itemprop="logo" src="//mudify.com/cdn/shop/files/logotype-mudify-4wd_205x.png?v=1620745063" alt="Mudify ">
                  </a>
              `;
              contenedorLogos.appendChild(nuevoElemento);
      }
    }
  });
}

logo();


// Retardo en carga de tooltip

function tooltipR() {
  let tooltiptext = document.querySelectorAll(".ptooltiptext");

  window.addEventListener('load', function() {
    tooltiptext.forEach(ttt =>{
      ttt.style.display = "block";
    })
  });
}

tooltipR();


function removeDollar() {
  document.querySelectorAll(".price-item, .money, .price-item__locations").forEach(el => {
    if (el && el.textContent) {
      el.textContent = el.textContent.replace(/\$/g, "");
    }
  });
}
